//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class DADeliverableSMEClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDetailsById(deliverableId: string): Observable<DADeliverableDetailsViewModel> {
        let url_ = this.baseUrl + "/SME/DADeliverable/GetDetailsById/{deliverableId}";
        if (deliverableId === undefined || deliverableId === null)
            throw new Error("The parameter 'deliverableId' must be defined.");
        url_ = url_.replace("{deliverableId}", encodeURIComponent("" + deliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableDetailsViewModel>;
        }));
    }

    protected processGetDetailsById(response: HttpResponseBase): Observable<DADeliverableDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IPIMSDocumentsSMEClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchIPIMSDocuments(domain: string | undefined, filter: string | undefined): Observable<IPIMSDocumentsSearchViewModel> {
        let url_ = this.baseUrl + "/SME/IPIMSDocuments/SearchIPIMSDocuments?";
        if (domain === null)
            throw new Error("The parameter 'domain' cannot be null.");
        else if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchIPIMSDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchIPIMSDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPIMSDocumentsSearchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPIMSDocumentsSearchViewModel>;
        }));
    }

    protected processSearchIPIMSDocuments(response: HttpResponseBase): Observable<IPIMSDocumentsSearchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IPIMSDocumentsSearchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIPIMSDomains(): Observable<IPIMSDomain[]> {
        let url_ = this.baseUrl + "/SME/IPIMSDocuments/GetIPIMSDomains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIPIMSDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIPIMSDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPIMSDomain[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPIMSDomain[]>;
        }));
    }

    protected processGetIPIMSDomains(response: HttpResponseBase): Observable<IPIMSDomain[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPIMSDomain.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObservationToolCheckSMEClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getObservationToolCheck(observationToolCheckId: string): Observable<ObservationToolCheckViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationToolCheck/GetObservationToolCheck/{observationToolCheckId}";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel>;
        }));
    }

    protected processGetObservationToolCheck(response: HttpResponseBase): Observable<ObservationToolCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolCheckDashboardForPhase(phaseId: string): Observable<ObservationToolCheckDashboardViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationToolCheck/GetObservationToolCheckDashboardForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolCheckDashboardForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolCheckDashboardForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckDashboardViewModel[]>;
        }));
    }

    protected processGetObservationToolCheckDashboardForPhase(response: HttpResponseBase): Observable<ObservationToolCheckDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolChecksForPhase(phaseId: string): Observable<ObservationToolCheckViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationToolCheck/GetObservationToolChecksForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolChecksForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolChecksForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel[]>;
        }));
    }

    protected processGetObservationToolChecksForPhase(response: HttpResponseBase): Observable<ObservationToolCheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDisciplineAssignmentsForPhase(phaseId: string): Observable<SMEDisciplineInObservationViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationToolCheck/GetDisciplineAssignmentsForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDisciplineAssignmentsForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDisciplineAssignmentsForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineInObservationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineInObservationViewModel[]>;
        }));
    }

    protected processGetDisciplineAssignmentsForPhase(response: HttpResponseBase): Observable<SMEDisciplineInObservationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplineInObservationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateObservationToolCheckComplete(observationToolCheckId: string, status: string | undefined): Observable<ObservationToolCheckViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationToolCheck/UpdateObservationToolCheckComplete/{observationToolCheckId}?";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateObservationToolCheckComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateObservationToolCheckComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel>;
        }));
    }

    protected processUpdateObservationToolCheckComplete(response: HttpResponseBase): Observable<ObservationToolCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSMEComments(observationToolCheckId: string, smeComments: string): Observable<CheckViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationToolCheck/UpdateSMEComments/{observationToolCheckId}";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(smeComments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSMEComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSMEComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckViewModel>;
        }));
    }

    protected processUpdateSMEComments(response: HttpResponseBase): Observable<CheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObservationToolSMEClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getObservationToolForPhase(phaseId: string): Observable<ObservationToolDashboardViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDashboardViewModel[]>;
        }));
    }

    protected processGetObservationToolForPhase(response: HttpResponseBase): Observable<ObservationToolDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    details(observationToolId: string): Observable<ObservationToolDetailsViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDetailsViewModel>;
        }));
    }

    protected processDetails(response: HttpResponseBase): Observable<ObservationToolDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservation(observationId: string): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/GetObservation/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processGetObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentsAssigned(observationToolId: string): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/GetDocumentsAssigned/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsAssigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsAssigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processGetDocumentsAssigned(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDisciplinesAssignedToCurrentUser(observationToolId: string): Observable<SMEDisciplineInObservationViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/GetDisciplinesAssignedToCurrentUser/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDisciplinesAssignedToCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDisciplinesAssignedToCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineInObservationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineInObservationViewModel[]>;
        }));
    }

    protected processGetDisciplinesAssignedToCurrentUser(response: HttpResponseBase): Observable<SMEDisciplineInObservationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplineInObservationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRespondingToOptionsForObservation(observationId: string): Observable<ObservationToolCheckViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/GetRespondingToOptionsForObservation/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRespondingToOptionsForObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRespondingToOptionsForObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel[]>;
        }));
    }

    protected processGetRespondingToOptionsForObservation(response: HttpResponseBase): Observable<ObservationToolCheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAreaSelectionOptionsForPhase(phaseId: string): Observable<string[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/GetAreaSelectionOptionsForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaSelectionOptionsForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaSelectionOptionsForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAreaSelectionOptionsForPhase(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolDashboardIndicators(phaseId: string): Observable<ObservationToolDashboardIndicators> {
        let url_ = this.baseUrl + "/SME/ObservationTool/GetObservationToolDashboardIndicators/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolDashboardIndicators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolDashboardIndicators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDashboardIndicators>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDashboardIndicators>;
        }));
    }

    protected processGetObservationToolDashboardIndicators(response: HttpResponseBase): Observable<ObservationToolDashboardIndicators> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDashboardIndicators.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentsFromFolder(documentFolderId: string, getActive: boolean | undefined): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/GetDocumentsFromFolder/{documentFolderId}?";
        if (documentFolderId === undefined || documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' must be defined.");
        url_ = url_.replace("{documentFolderId}", encodeURIComponent("" + documentFolderId));
        if (getActive === null)
            throw new Error("The parameter 'getActive' cannot be null.");
        else if (getActive !== undefined)
            url_ += "getActive=" + encodeURIComponent("" + getActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsFromFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsFromFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processGetDocumentsFromFolder(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDeliverableFlag(observationToolId: string, description: string | undefined): Observable<ObservationToolDeliverableFlagViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/CreateDeliverableFlag/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliverableFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliverableFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDeliverableFlagViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDeliverableFlagViewModel>;
        }));
    }

    protected processCreateDeliverableFlag(response: HttpResponseBase): Observable<ObservationToolDeliverableFlagViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDeliverableFlagViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createObservation(observationToolId: string, observationForm: ObservationToolObservationSaveSMEObservationViewModel, saveAsDraft: boolean | undefined): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/CreateObservation/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (saveAsDraft === null)
            throw new Error("The parameter 'saveAsDraft' cannot be null.");
        else if (saveAsDraft !== undefined)
            url_ += "saveAsDraft=" + encodeURIComponent("" + saveAsDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(observationForm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processCreateObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createObservationForCheck(observationToolCheckId: string, observationForm: ObservationToolObservationSaveSMEObservationViewModel, saveAsDraft: boolean | undefined): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/CreateObservationForCheck/{observationToolCheckId}?";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        if (saveAsDraft === null)
            throw new Error("The parameter 'saveAsDraft' cannot be null.");
        else if (saveAsDraft !== undefined)
            url_ += "saveAsDraft=" + encodeURIComponent("" + saveAsDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(observationForm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateObservationForCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateObservationForCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processCreateObservationForCheck(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateObservation(observationToolObservationId: string, observationForm: ObservationToolObservationSaveSMEObservationViewModel, saveAsDraft: boolean | undefined): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/UpdateObservation/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (saveAsDraft === null)
            throw new Error("The parameter 'saveAsDraft' cannot be null.");
        else if (saveAsDraft !== undefined)
            url_ += "saveAsDraft=" + encodeURIComponent("" + saveAsDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(observationForm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processUpdateObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteObservation(observationId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/SME/ObservationTool/DeleteObservation/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteObservation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignIPIMSObservationAttachments(observationToolObservationId: string, iPIMSDocumentsPrimaryKeys: string[]): Observable<ObservationToolObservationAttachmentViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/AssignIPIMSObservationAttachments/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPIMSDocumentsPrimaryKeys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignIPIMSObservationAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignIPIMSObservationAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationAttachmentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationAttachmentViewModel[]>;
        }));
    }

    protected processAssignIPIMSObservationAttachments(response: HttpResponseBase): Observable<ObservationToolObservationAttachmentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationAttachmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignURLDocumentAttachment(observationToolObservationId: string, title: string | undefined, documentURL: string | undefined): Observable<ObservationToolObservationAttachmentViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/AssignURLDocumentAttachment/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (documentURL === null)
            throw new Error("The parameter 'documentURL' cannot be null.");
        else if (documentURL !== undefined)
            url_ += "documentURL=" + encodeURIComponent("" + documentURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignURLDocumentAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignURLDocumentAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationAttachmentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationAttachmentViewModel>;
        }));
    }

    protected processAssignURLDocumentAttachment(response: HttpResponseBase): Observable<ObservationToolObservationAttachmentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationAttachmentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteObservationAttachment(documentId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/SME/ObservationTool/DeleteObservationAttachment/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObservationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObservationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteObservationAttachment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markDisciplineReviewed(observationToolId: string, request: MarkDisciplineReviewedRequestViewModel): Observable<ObservationToolDetailsViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/MarkDisciplineReviewed/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkDisciplineReviewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkDisciplineReviewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDetailsViewModel>;
        }));
    }

    protected processMarkDisciplineReviewed(response: HttpResponseBase): Observable<ObservationToolDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markDocumentsReviewed(observationToolId: string, request: MarkDisciplineReviewedRequestViewModel): Observable<ObservationToolDetailsViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/MarkDocumentsReviewed/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkDocumentsReviewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkDocumentsReviewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDetailsViewModel>;
        }));
    }

    protected processMarkDocumentsReviewed(response: HttpResponseBase): Observable<ObservationToolDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendObservationMessage(observationToolObservationId: string, message: string, channel: string | undefined, nextActionWith: string | null | undefined): Observable<ObservationToolObservationMessageViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/SendObservationMessage/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        if (nextActionWith !== undefined && nextActionWith !== null)
            url_ += "nextActionWith=" + encodeURIComponent("" + nextActionWith) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendObservationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendObservationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationMessageViewModel>;
        }));
    }

    protected processSendObservationMessage(response: HttpResponseBase): Observable<ObservationToolObservationMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setObservationMessageRead(observationToolObservationId: string, messageIds: string[]): Observable<ObservationToolObservationMessageReadViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/SetObservationMessageRead/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetObservationMessageRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetObservationMessageRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationMessageReadViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationMessageReadViewModel[]>;
        }));
    }

    protected processSetObservationMessageRead(response: HttpResponseBase): Observable<ObservationToolObservationMessageReadViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationMessageReadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendObservationToolCheckMessage(observationToolCheckId: string, message: string): Observable<ObservationToolCheckMessageViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/SendObservationToolCheckMessage/{observationToolCheckId}";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendObservationToolCheckMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendObservationToolCheckMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckMessageViewModel>;
        }));
    }

    protected processSendObservationToolCheckMessage(response: HttpResponseBase): Observable<ObservationToolCheckMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setObservationToolCheckMessageRead(messageIds: string[]): Observable<ObservationToolCheckMessageReadViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/SetObservationToolCheckMessageRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetObservationToolCheckMessageRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetObservationToolCheckMessageRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckMessageReadViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckMessageReadViewModel[]>;
        }));
    }

    protected processSetObservationToolCheckMessageRead(response: HttpResponseBase): Observable<ObservationToolCheckMessageReadViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckMessageReadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDocumentNickname(documentId: string, newNickname: string | null | undefined): Observable<ObservationToolDocumentViewModel> {
        let url_ = this.baseUrl + "/SME/ObservationTool/SetDocumentNickname/{documentId}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (newNickname !== undefined && newNickname !== null)
            url_ += "newNickname=" + encodeURIComponent("" + newNickname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDocumentNickname(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDocumentNickname(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel>;
        }));
    }

    protected processSetDocumentNickname(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDocumentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSMEBookmarks(observationToolId: string, bookmarks: SMEDocumentsBookmarkedViewModel[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/SME/ObservationTool/CreateSMEBookmarks/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookmarks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSMEBookmarks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSMEBookmarks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateSMEBookmarks(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationsDashboard(phaseId: string): Observable<ObservationToolObservationDashboardViewModel[]> {
        let url_ = this.baseUrl + "/SME/ObservationTool/GetObservationsDashboard/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationsDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationsDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationDashboardViewModel[]>;
        }));
    }

    protected processGetObservationsDashboard(response: HttpResponseBase): Observable<ObservationToolObservationDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectSMEClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<ProjectViewModel[]> {
        let url_ = this.baseUrl + "/SME/Project";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProjectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectPhaseSMEClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(id: string): Observable<ProjectPhaseWithProjectViewModel> {
        let url_ = this.baseUrl + "/SME/ProjectPhase/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseWithProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseWithProjectViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectPhaseWithProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectPhaseWithProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SMEDisciplineSMEClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSMEDisciplinesPeerPool(phaseId: string | undefined): Observable<SMEDisciplinePeerPoolWithProjectPhaseViewModel[]> {
        let url_ = this.baseUrl + "/SME/SMEDiscipline/PeerPoolForSME?";
        if (phaseId === null)
            throw new Error("The parameter 'phaseId' cannot be null.");
        else if (phaseId !== undefined)
            url_ += "phaseId=" + encodeURIComponent("" + phaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinesPeerPool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinesPeerPool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseViewModel[]>;
        }));
    }

    protected processGetSMEDisciplinesPeerPool(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolWithProjectPhaseViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplinePeerPoolWithProjectPhaseViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplinePeerPool(disciplineId: string): Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel> {
        let url_ = this.baseUrl + "/SME/SMEDiscipline/PeerPoolForSME/{disciplineId}";
        if (disciplineId === undefined || disciplineId === null)
            throw new Error("The parameter 'disciplineId' must be defined.");
        url_ = url_.replace("{disciplineId}", encodeURIComponent("" + disciplineId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinePeerPool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinePeerPool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel>;
        }));
    }

    protected processGetSMEDisciplinePeerPool(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplinesWithCodesForPhase(phaseId: string): Observable<SMEDisciplineViewModel[]> {
        let url_ = this.baseUrl + "/SME/SMEDiscipline/DisciplinesWithCodes/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinesWithCodesForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinesWithCodesForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineViewModel[]>;
        }));
    }

    protected processGetSMEDisciplinesWithCodesForPhase(response: HttpResponseBase): Observable<SMEDisciplineViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplineViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DADeliverableProjectContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDetailsById(deliverableId: string): Observable<DADeliverableDetailsViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/DADeliverable/GetDetailsById/{deliverableId}";
        if (deliverableId === undefined || deliverableId === null)
            throw new Error("The parameter 'deliverableId' must be defined.");
        url_ = url_.replace("{deliverableId}", encodeURIComponent("" + deliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableDetailsViewModel>;
        }));
    }

    protected processGetDetailsById(response: HttpResponseBase): Observable<DADeliverableDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByTemplateId(deliverableTemplateId: string): Observable<DADeliverableFormViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/DADeliverable/GetByTemplateId/{deliverableTemplateId}";
        if (deliverableTemplateId === undefined || deliverableTemplateId === null)
            throw new Error("The parameter 'deliverableTemplateId' must be defined.");
        url_ = url_.replace("{deliverableTemplateId}", encodeURIComponent("" + deliverableTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByTemplateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTemplateId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableFormViewModel>;
        }));
    }

    protected processGetByTemplateId(response: HttpResponseBase): Observable<DADeliverableFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByIdForm(deliverableId: string): Observable<DADeliverableFormViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/DADeliverable/GetByIdForm/{deliverableId}";
        if (deliverableId === undefined || deliverableId === null)
            throw new Error("The parameter 'deliverableId' must be defined.");
        url_ = url_.replace("{deliverableId}", encodeURIComponent("" + deliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableFormViewModel>;
        }));
    }

    protected processGetByIdForm(response: HttpResponseBase): Observable<DADeliverableFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeliverableMasterProjectContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDeliverableMasterListForPhase(phaseId: string): Observable<DeliverableMasterViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/DeliverableMaster/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliverableMasterListForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliverableMasterListForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliverableMasterViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliverableMasterViewModel[]>;
        }));
    }

    protected processGetDeliverableMasterListForPhase(response: HttpResponseBase): Observable<DeliverableMasterViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliverableMasterViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendDeliverableMessage(daDeliverableId: string, projectDeliverableId: string, message: string): Observable<DeliverableMessageViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/DeliverableMaster/SendDeliverableMessage/{daDeliverableId}/{projectDeliverableId}";
        if (daDeliverableId === undefined || daDeliverableId === null)
            throw new Error("The parameter 'daDeliverableId' must be defined.");
        url_ = url_.replace("{daDeliverableId}", encodeURIComponent("" + daDeliverableId));
        if (projectDeliverableId === undefined || projectDeliverableId === null)
            throw new Error("The parameter 'projectDeliverableId' must be defined.");
        url_ = url_.replace("{projectDeliverableId}", encodeURIComponent("" + projectDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDeliverableMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDeliverableMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliverableMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliverableMessageViewModel>;
        }));
    }

    protected processSendDeliverableMessage(response: HttpResponseBase): Observable<DeliverableMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliverableMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDeliverableMessageRead(messageIds: string[]): Observable<DeliverableMessageReadViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/DeliverableMaster/SetDeliverableMessageRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDeliverableMessageRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDeliverableMessageRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliverableMessageReadViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliverableMessageReadViewModel[]>;
        }));
    }

    protected processSetDeliverableMessageRead(response: HttpResponseBase): Observable<DeliverableMessageReadViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliverableMessageReadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IPIMSDocumentsProjectContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchIPIMSDocuments(domain: string | undefined, filter: string | undefined): Observable<IPIMSDocumentsSearchViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/IPIMSDocuments/SearchIPIMSDocuments?";
        if (domain === null)
            throw new Error("The parameter 'domain' cannot be null.");
        else if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchIPIMSDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchIPIMSDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPIMSDocumentsSearchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPIMSDocumentsSearchViewModel>;
        }));
    }

    protected processSearchIPIMSDocuments(response: HttpResponseBase): Observable<IPIMSDocumentsSearchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IPIMSDocumentsSearchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIPIMSDomains(): Observable<IPIMSDomain[]> {
        let url_ = this.baseUrl + "/ProjectContact/IPIMSDocuments/GetIPIMSDomains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIPIMSDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIPIMSDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPIMSDomain[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPIMSDomain[]>;
        }));
    }

    protected processGetIPIMSDomains(response: HttpResponseBase): Observable<IPIMSDomain[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPIMSDomain.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObservationToolCheckProjectContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getObservationToolCheck(observationToolCheckId: string): Observable<ObservationToolCheckViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationToolCheck/GetObservationToolCheck/{observationToolCheckId}";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel>;
        }));
    }

    protected processGetObservationToolCheck(response: HttpResponseBase): Observable<ObservationToolCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolCheckDashboardForPhase(phaseId: string): Observable<ObservationToolCheckDashboardViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationToolCheck/GetObservationToolCheckDashboardForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolCheckDashboardForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolCheckDashboardForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckDashboardViewModel[]>;
        }));
    }

    protected processGetObservationToolCheckDashboardForPhase(response: HttpResponseBase): Observable<ObservationToolCheckDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateObservationToolCheckComplete(observationToolCheckId: string, status: string | undefined): Observable<ObservationToolCheckViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationToolCheck/UpdateObservationToolCheckComplete/{observationToolCheckId}?";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateObservationToolCheckComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateObservationToolCheckComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel>;
        }));
    }

    protected processUpdateObservationToolCheckComplete(response: HttpResponseBase): Observable<ObservationToolCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObservationToolProjectContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getObservationToolForPhase(phaseId: string): Observable<ObservationToolDashboardViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDashboardViewModel[]>;
        }));
    }

    protected processGetObservationToolForPhase(response: HttpResponseBase): Observable<ObservationToolDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    details(observationToolId: string): Observable<ObservationToolDetailsViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDetailsViewModel>;
        }));
    }

    protected processDetails(response: HttpResponseBase): Observable<ObservationToolDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservation(observationId: string): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/GetObservation/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processGetObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectDeliverablesAndIPIMSDocumentsToAssign(ipimsDomain: string, phaseId: string | undefined): Observable<ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/GetProjectDeliverablesAndIPIMSDocumentsToAssign/{ipimsDomain}?";
        if (ipimsDomain === undefined || ipimsDomain === null)
            throw new Error("The parameter 'ipimsDomain' must be defined.");
        url_ = url_.replace("{ipimsDomain}", encodeURIComponent("" + ipimsDomain));
        if (phaseId === null)
            throw new Error("The parameter 'phaseId' cannot be null.");
        else if (phaseId !== undefined)
            url_ += "phaseId=" + encodeURIComponent("" + phaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDeliverablesAndIPIMSDocumentsToAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDeliverablesAndIPIMSDocumentsToAssign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel[]>;
        }));
    }

    protected processGetProjectDeliverablesAndIPIMSDocumentsToAssign(response: HttpResponseBase): Observable<ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignDocuments(observationToolId: string): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/AssignDocuments/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processAssignDocuments(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notifyDAToAssignDocuments(observationToolId: string): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/NotifyDAToAssignDocuments/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyDAToAssignDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyDAToAssignDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processNotifyDAToAssignDocuments(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loadIPIMSDocuments(observationToolId: string, iPIMSDocumentsPrimaryKeys: string[]): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/LoadIPIMSDocuments/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPIMSDocumentsPrimaryKeys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadIPIMSDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadIPIMSDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processLoadIPIMSDocuments(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignIPIMSDocumentRevisions(observationToolObservationId: string, iPIMSDocumentsPrimaryKeys: string[]): Observable<ObservationToolObservationDocumentRevisionViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/AssignIPIMSDocumentRevisions/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPIMSDocumentsPrimaryKeys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignIPIMSDocumentRevisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignIPIMSDocumentRevisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationDocumentRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationDocumentRevisionViewModel[]>;
        }));
    }

    protected processAssignIPIMSDocumentRevisions(response: HttpResponseBase): Observable<ObservationToolObservationDocumentRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationDocumentRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignIPIMSDocumentsOneToOne(assignments: ObservationToolIPIMSDocumentOneToOneAssignViewModel[]): Observable<ObservationToolDocumentViewModel[][]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/AssignIPIMSDocumentsOneToOne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignIPIMSDocumentsOneToOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignIPIMSDocumentsOneToOne(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[][]>;
        }));
    }

    protected processAssignIPIMSDocumentsOneToOne(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loadSharePointDocument(observationToolId: string, title: string | undefined, iPIMSDocumentURL: string | undefined): Observable<ObservationToolDocumentViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/LoadSharePointDocument/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (iPIMSDocumentURL === null)
            throw new Error("The parameter 'iPIMSDocumentURL' cannot be null.");
        else if (iPIMSDocumentURL !== undefined)
            url_ += "iPIMSDocumentURL=" + encodeURIComponent("" + iPIMSDocumentURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadSharePointDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadSharePointDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel>;
        }));
    }

    protected processLoadSharePointDocument(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDocumentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loadSharePointFolder(observationToolId: string, folderTitle: string | undefined, folderURL: string | undefined, documentsToLoad: ObservationToolDocumentLoadViewModel[]): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/LoadSharePointFolder/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (folderTitle === null)
            throw new Error("The parameter 'folderTitle' cannot be null.");
        else if (folderTitle !== undefined)
            url_ += "folderTitle=" + encodeURIComponent("" + folderTitle) + "&";
        if (folderURL === null)
            throw new Error("The parameter 'folderURL' cannot be null.");
        else if (folderURL !== undefined)
            url_ += "folderURL=" + encodeURIComponent("" + folderURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentsToLoad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadSharePointFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadSharePointFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processLoadSharePointFolder(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignURLDocumentRevision(observationToolObservationId: string, title: string | undefined, iPIMSDocumentURL: string | undefined): Observable<ObservationToolObservationDocumentRevisionViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/AssignURLDocumentRevision/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (iPIMSDocumentURL === null)
            throw new Error("The parameter 'iPIMSDocumentURL' cannot be null.");
        else if (iPIMSDocumentURL !== undefined)
            url_ += "iPIMSDocumentURL=" + encodeURIComponent("" + iPIMSDocumentURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignURLDocumentRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignURLDocumentRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationDocumentRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationDocumentRevisionViewModel>;
        }));
    }

    protected processAssignURLDocumentRevision(response: HttpResponseBase): Observable<ObservationToolObservationDocumentRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationDocumentRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteObservationToolDocument(documentId: string, isSoftDelete: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/DeleteObservationToolDocument/{documentId}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (isSoftDelete === null)
            throw new Error("The parameter 'isSoftDelete' cannot be null.");
        else if (isSoftDelete !== undefined)
            url_ += "isSoftDelete=" + encodeURIComponent("" + isSoftDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObservationToolDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObservationToolDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteObservationToolDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    restoreObservationToolDocument(documentIds: string[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/RestoreObservationToolDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreObservationToolDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreObservationToolDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRestoreObservationToolDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignIPIMSObservationAttachments(observationToolObservationId: string, iPIMSDocumentsPrimaryKeys: string[]): Observable<ObservationToolObservationAttachmentViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/AssignIPIMSObservationAttachments/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPIMSDocumentsPrimaryKeys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignIPIMSObservationAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignIPIMSObservationAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationAttachmentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationAttachmentViewModel[]>;
        }));
    }

    protected processAssignIPIMSObservationAttachments(response: HttpResponseBase): Observable<ObservationToolObservationAttachmentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationAttachmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignURLDocumentAttachment(observationToolObservationId: string, title: string | undefined, documentURL: string | undefined): Observable<ObservationToolObservationAttachmentViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/AssignURLDocumentAttachment/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (documentURL === null)
            throw new Error("The parameter 'documentURL' cannot be null.");
        else if (documentURL !== undefined)
            url_ += "documentURL=" + encodeURIComponent("" + documentURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignURLDocumentAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignURLDocumentAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationAttachmentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationAttachmentViewModel>;
        }));
    }

    protected processAssignURLDocumentAttachment(response: HttpResponseBase): Observable<ObservationToolObservationAttachmentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationAttachmentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteObservationAttachment(documentId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/DeleteObservationAttachment/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObservationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObservationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteObservationAttachment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDocumentNickname(documentId: string, newNickname: string | null | undefined): Observable<ObservationToolDocumentViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/SetDocumentNickname/{documentId}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (newNickname !== undefined && newNickname !== null)
            url_ += "newNickname=" + encodeURIComponent("" + newNickname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDocumentNickname(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDocumentNickname(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel>;
        }));
    }

    protected processSetDocumentNickname(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDocumentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendObservationMessage(observationToolObservationId: string, message: string, channel: string | undefined, nextActionWith: string | null | undefined): Observable<ObservationToolObservationMessageViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/SendObservationMessage/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        if (nextActionWith !== undefined && nextActionWith !== null)
            url_ += "nextActionWith=" + encodeURIComponent("" + nextActionWith) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendObservationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendObservationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationMessageViewModel>;
        }));
    }

    protected processSendObservationMessage(response: HttpResponseBase): Observable<ObservationToolObservationMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setObservationMessageRead(observationToolObservationId: string, messageIds: string[]): Observable<ObservationToolObservationMessageReadViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/SetObservationMessageRead/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetObservationMessageRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetObservationMessageRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationMessageReadViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationMessageReadViewModel[]>;
        }));
    }

    protected processSetObservationMessageRead(response: HttpResponseBase): Observable<ObservationToolObservationMessageReadViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationMessageReadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendObservationToolCheckMessage(observationToolCheckId: string, message: string): Observable<ObservationToolCheckMessageViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/SendObservationToolCheckMessage/{observationToolCheckId}";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendObservationToolCheckMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendObservationToolCheckMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckMessageViewModel>;
        }));
    }

    protected processSendObservationToolCheckMessage(response: HttpResponseBase): Observable<ObservationToolCheckMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setObservationToolCheckMessageRead(messageIds: string[]): Observable<ObservationToolCheckMessageReadViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/SetObservationToolCheckMessageRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetObservationToolCheckMessageRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetObservationToolCheckMessageRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckMessageReadViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckMessageReadViewModel[]>;
        }));
    }

    protected processSetObservationToolCheckMessageRead(response: HttpResponseBase): Observable<ObservationToolCheckMessageReadViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckMessageReadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateP3ActionCompleted(observationToolObservationId: string, p3ActionDescription: string): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/UpdateP3ActionCompleted/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(p3ActionDescription);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateP3ActionCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateP3ActionCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processUpdateP3ActionCompleted(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeP3ActionCompleted(observationToolObservationId: string): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/RemoveP3ActionCompleted/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveP3ActionCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveP3ActionCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processRemoveP3ActionCompleted(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentsFromFolder(documentFolderId: string, getActive: boolean | undefined): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/GetDocumentsFromFolder/{documentFolderId}?";
        if (documentFolderId === undefined || documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' must be defined.");
        url_ = url_.replace("{documentFolderId}", encodeURIComponent("" + documentFolderId));
        if (getActive === null)
            throw new Error("The parameter 'getActive' cannot be null.");
        else if (getActive !== undefined)
            url_ += "getActive=" + encodeURIComponent("" + getActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsFromFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsFromFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processGetDocumentsFromFolder(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDocumentsFromFolder(documentFolderId: string, documentsChange: ObservationToolDocumentsFromFolderUpdateViewModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/UpdateDocumentsFromFolder/{documentFolderId}";
        if (documentFolderId === undefined || documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' must be defined.");
        url_ = url_.replace("{documentFolderId}", encodeURIComponent("" + documentFolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentsChange);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentsFromFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentsFromFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateDocumentsFromFolder(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportObservationsByPhaseId(phaseId: string, observationUrlForProjectContact: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/ExportObservationsByPhaseId/{phaseId}?";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        if (observationUrlForProjectContact === null)
            throw new Error("The parameter 'observationUrlForProjectContact' cannot be null.");
        else if (observationUrlForProjectContact !== undefined)
            url_ += "observationUrlForProjectContact=" + encodeURIComponent("" + observationUrlForProjectContact) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportObservationsByPhaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportObservationsByPhaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportObservationsByPhaseId(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationsDashboard(phaseId: string): Observable<ObservationToolObservationDashboardViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/ObservationTool/GetObservationsDashboard/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationsDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationsDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationDashboardViewModel[]>;
        }));
    }

    protected processGetObservationsDashboard(response: HttpResponseBase): Observable<ObservationToolObservationDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectProjectContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<ProjectViewModel[]> {
        let url_ = this.baseUrl + "/ProjectContact/Project";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProjectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectPhaseProjectContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(id: string): Observable<ProjectPhaseWithProjectViewModel> {
        let url_ = this.baseUrl + "/ProjectContact/ProjectPhase/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseWithProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseWithProjectViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectPhaseWithProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectPhaseWithProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetClassDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<AssetClassViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/AssetClass";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetClassViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetClassViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssetClassViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetClassViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<AssetClassViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/AssetClass/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetClassViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetClassViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetClassViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetClassViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AttentionItemSettingDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getByProjectId(projectId: string): Observable<AttentionItemSettingViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/AttentionItemSetting/GetByProjectId/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttentionItemSettingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttentionItemSettingViewModel>;
        }));
    }

    protected processGetByProjectId(response: HttpResponseBase): Observable<AttentionItemSettingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttentionItemSettingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdate(attentionItemSettingViewModel: AttentionItemSettingViewModel): Observable<AttentionItemSettingViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/AttentionItemSetting/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attentionItemSettingViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttentionItemSettingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttentionItemSettingViewModel>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AttentionItemSettingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttentionItemSettingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(viewModel: AttentionItemSettingViewModel): Observable<AttentionItemSettingViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/AttentionItemSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttentionItemSettingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttentionItemSettingViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AttentionItemSettingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttentionItemSettingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<AttentionItemSettingViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/AttentionItemSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttentionItemSettingViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttentionItemSettingViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AttentionItemSettingViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttentionItemSettingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: AttentionItemSettingViewModel): Observable<AttentionItemSettingViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/AttentionItemSetting/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttentionItemSettingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttentionItemSettingViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AttentionItemSettingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttentionItemSettingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/AttentionItemSetting/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<AttentionItemSettingViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/AttentionItemSetting/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttentionItemSettingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttentionItemSettingViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AttentionItemSettingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttentionItemSettingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BusinessUnitDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<BusinessUnitViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/BusinessUnit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BusinessUnitViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessUnitViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(viewModel: BusinessUnitViewModel): Observable<BusinessUnitViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/BusinessUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BusinessUnitViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessUnitViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBusinessUnit(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/BusinessUnit/DeleteBusinessUnit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBusinessUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBusinessUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteBusinessUnit(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBusinessUnit(id: string, businessUnit: BusinessUnitViewModel): Observable<BusinessUnitViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/BusinessUnit/UpdateBusinessUnit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(businessUnit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusinessUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusinessUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel>;
        }));
    }

    protected processUpdateBusinessUnit(response: HttpResponseBase): Observable<BusinessUnitViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessUnitViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: BusinessUnitViewModel): Observable<BusinessUnitViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/BusinessUnit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BusinessUnitViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessUnitViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/BusinessUnit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<BusinessUnitViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/BusinessUnit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<BusinessUnitViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessUnitViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CheckDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(viewModel: CheckViewModel): Observable<CheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CheckViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: CheckViewModel): Observable<CheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Check/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<CheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Check/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllChecksForPhase(phaseId: string): Observable<CheckViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Check/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllChecksForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChecksForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckViewModel[]>;
        }));
    }

    protected processGetAllChecksForPhase(response: HttpResponseBase): Observable<CheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllMandatoryCheckTemplates(): Observable<MandatoryCheckTemplateViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Check/GetAllMandatoryCheckTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMandatoryCheckTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMandatoryCheckTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MandatoryCheckTemplateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MandatoryCheckTemplateViewModel[]>;
        }));
    }

    protected processGetAllMandatoryCheckTemplates(response: HttpResponseBase): Observable<MandatoryCheckTemplateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MandatoryCheckTemplateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMandatoryChecksFromTemplates(phaseId: string, templateIds: string[]): Observable<CheckViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Check/CreateMandatoryChecksFromTemplates/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMandatoryChecksFromTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMandatoryChecksFromTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckViewModel[]>;
        }));
    }

    protected processCreateMandatoryChecksFromTemplates(response: HttpResponseBase): Observable<CheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllWithProjectMappingsForPhase(phaseId: string): Observable<CheckWithMappingsViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Check/{phaseId}/withMappings";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithProjectMappingsForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithProjectMappingsForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckWithMappingsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckWithMappingsViewModel[]>;
        }));
    }

    protected processGetAllWithProjectMappingsForPhase(response: HttpResponseBase): Observable<CheckWithMappingsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckWithMappingsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCheck(checkId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/Check/deleteCheck/{checkId}";
        if (checkId === undefined || checkId === null)
            throw new Error("The parameter 'checkId' must be defined.");
        url_ = url_.replace("{checkId}", encodeURIComponent("" + checkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteCheck(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DADeliverableDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(viewModel: DADeliverableViewModel): Observable<DADeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DADeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<DADeliverableViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DADeliverableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByIdForm(deliverableId: string): Observable<DADeliverableFormViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/GetByIdForm/{deliverableId}";
        if (deliverableId === undefined || deliverableId === null)
            throw new Error("The parameter 'deliverableId' must be defined.");
        url_ = url_.replace("{deliverableId}", encodeURIComponent("" + deliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableFormViewModel>;
        }));
    }

    protected processGetByIdForm(response: HttpResponseBase): Observable<DADeliverableFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByTemplateId(deliverableTemplateId: string): Observable<DADeliverableFormViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/GetByTemplateId/{deliverableTemplateId}";
        if (deliverableTemplateId === undefined || deliverableTemplateId === null)
            throw new Error("The parameter 'deliverableTemplateId' must be defined.");
        url_ = url_.replace("{deliverableTemplateId}", encodeURIComponent("" + deliverableTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByTemplateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTemplateId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableFormViewModel>;
        }));
    }

    protected processGetByTemplateId(response: HttpResponseBase): Observable<DADeliverableFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDetailsById(deliverableId: string): Observable<DADeliverableDetailsViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/GetDetailsById/{deliverableId}";
        if (deliverableId === undefined || deliverableId === null)
            throw new Error("The parameter 'deliverableId' must be defined.");
        url_ = url_.replace("{deliverableId}", encodeURIComponent("" + deliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableDetailsViewModel>;
        }));
    }

    protected processGetDetailsById(response: HttpResponseBase): Observable<DADeliverableDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createForm(phaseId: string, viewModel: DADeliverableFormViewModel): Observable<DADeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/CreateForm/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableViewModel>;
        }));
    }

    protected processCreateForm(response: HttpResponseBase): Observable<DADeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateForm(deliverableId: string, viewModel: DADeliverableFormViewModel): Observable<DADeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/UpdateForm/{deliverableId}";
        if (deliverableId === undefined || deliverableId === null)
            throw new Error("The parameter 'deliverableId' must be defined.");
        url_ = url_.replace("{deliverableId}", encodeURIComponent("" + deliverableId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableViewModel>;
        }));
    }

    protected processUpdateForm(response: HttpResponseBase): Observable<DADeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRange(deliverableIds: string[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/DeleteRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliverableIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteRange(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createRange(deliverablesViewModel: DADeliverableViewModel[]): Observable<DADeliverableViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/CreateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliverablesViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableViewModel[]>;
        }));
    }

    protected processCreateRange(response: HttpResponseBase): Observable<DADeliverableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDeliverablesFromTemplatesAndTagFocusArea(focusAreaId: string, daDeliverableTemplatesIds: string[]): Observable<DADeliverableTagFocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/CreateDeliverablesFromTemplatesAndTagFocusArea/{focusAreaId}";
        if (focusAreaId === undefined || focusAreaId === null)
            throw new Error("The parameter 'focusAreaId' must be defined.");
        url_ = url_.replace("{focusAreaId}", encodeURIComponent("" + focusAreaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(daDeliverableTemplatesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliverablesFromTemplatesAndTagFocusArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliverablesFromTemplatesAndTagFocusArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTagFocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTagFocusAreaViewModel[]>;
        }));
    }

    protected processCreateDeliverablesFromTemplatesAndTagFocusArea(response: HttpResponseBase): Observable<DADeliverableTagFocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableTagFocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDeliverablesTagFocusArea(focusAreaId: string, daDeliverableIds: string[]): Observable<DADeliverableTagFocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/DeleteDeliverablesTagFocusArea/{focusAreaId}";
        if (focusAreaId === undefined || focusAreaId === null)
            throw new Error("The parameter 'focusAreaId' must be defined.");
        url_ = url_.replace("{focusAreaId}", encodeURIComponent("" + focusAreaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(daDeliverableIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeliverablesTagFocusArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeliverablesTagFocusArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTagFocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTagFocusAreaViewModel[]>;
        }));
    }

    protected processDeleteDeliverablesTagFocusArea(response: HttpResponseBase): Observable<DADeliverableTagFocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableTagFocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstimatesForDeliverable(deliverableId: string): Observable<DADeliverableWithWorkloadEstimatesViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/{deliverableId}/estimates";
        if (deliverableId === undefined || deliverableId === null)
            throw new Error("The parameter 'deliverableId' must be defined.");
        url_ = url_.replace("{deliverableId}", encodeURIComponent("" + deliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstimatesForDeliverable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimatesForDeliverable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableWithWorkloadEstimatesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableWithWorkloadEstimatesViewModel>;
        }));
    }

    protected processGetEstimatesForDeliverable(response: HttpResponseBase): Observable<DADeliverableWithWorkloadEstimatesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableWithWorkloadEstimatesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeliverablesWithMappingsForPhase(phaseId: string): Observable<DADeliverableWithMappingsViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/{phaseId}/mappings";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliverablesWithMappingsForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliverablesWithMappingsForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableWithMappingsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableWithMappingsViewModel[]>;
        }));
    }

    protected processGetDeliverablesWithMappingsForPhase(response: HttpResponseBase): Observable<DADeliverableWithMappingsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableWithMappingsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeliverablesForPhase(phaseId: string): Observable<DADeliverableViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliverablesForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliverablesForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableViewModel[]>;
        }));
    }

    protected processGetDeliverablesForPhase(response: HttpResponseBase): Observable<DADeliverableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadImportTemplateFile(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/DownloadImportTemplateFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImportTemplateFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImportTemplateFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadImportTemplateFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(phaseId: string, file: FileParameter | undefined, onlyAdd: boolean | undefined, insertMissing: boolean | undefined, removeDeleted: boolean | undefined, updateExisting: boolean | undefined): Observable<DADeliverableImportResultViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/import/{phaseId}?";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        if (onlyAdd === null)
            throw new Error("The parameter 'onlyAdd' cannot be null.");
        else if (onlyAdd !== undefined)
            url_ += "onlyAdd=" + encodeURIComponent("" + onlyAdd) + "&";
        if (insertMissing === null)
            throw new Error("The parameter 'insertMissing' cannot be null.");
        else if (insertMissing !== undefined)
            url_ += "insertMissing=" + encodeURIComponent("" + insertMissing) + "&";
        if (removeDeleted === null)
            throw new Error("The parameter 'removeDeleted' cannot be null.");
        else if (removeDeleted !== undefined)
            url_ += "removeDeleted=" + encodeURIComponent("" + removeDeleted) + "&";
        if (updateExisting === null)
            throw new Error("The parameter 'updateExisting' cannot be null.");
        else if (updateExisting !== undefined)
            url_ += "updateExisting=" + encodeURIComponent("" + updateExisting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableImportResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableImportResultViewModel>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<DADeliverableImportResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(ADAPModelValidator.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableImportResultViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkForUploadDuplicates(phaseId: string, file: FileParameter | undefined): Observable<DADeliverableImportDuplicatesViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/CheckForUploadDuplicates/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckForUploadDuplicates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckForUploadDuplicates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableImportDuplicatesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableImportDuplicatesViewModel[]>;
        }));
    }

    protected processCheckForUploadDuplicates(response: HttpResponseBase): Observable<DADeliverableImportDuplicatesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(ADAPModelValidator.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableImportDuplicatesViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFocusAreaToExistingDeliverables(focusAreaId: string, daDeliverableIds: string[]): Observable<DADeliverableTagFocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/AddFocusAreaToExistingDeliverables/{focusAreaId}";
        if (focusAreaId === undefined || focusAreaId === null)
            throw new Error("The parameter 'focusAreaId' must be defined.");
        url_ = url_.replace("{focusAreaId}", encodeURIComponent("" + focusAreaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(daDeliverableIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFocusAreaToExistingDeliverables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFocusAreaToExistingDeliverables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTagFocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTagFocusAreaViewModel[]>;
        }));
    }

    protected processAddFocusAreaToExistingDeliverables(response: HttpResponseBase): Observable<DADeliverableTagFocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableTagFocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeFocusAreaFromExistingDeliverables(focusAreaId: string, daDeliverableIds: string[]): Observable<DADeliverableTagFocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/RemoveFocusAreaFromExistingDeliverables/{focusAreaId}";
        if (focusAreaId === undefined || focusAreaId === null)
            throw new Error("The parameter 'focusAreaId' must be defined.");
        url_ = url_.replace("{focusAreaId}", encodeURIComponent("" + focusAreaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(daDeliverableIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFocusAreaFromExistingDeliverables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFocusAreaFromExistingDeliverables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTagFocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTagFocusAreaViewModel[]>;
        }));
    }

    protected processRemoveFocusAreaFromExistingDeliverables(response: HttpResponseBase): Observable<DADeliverableTagFocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableTagFocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: DADeliverableViewModel): Observable<DADeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DADeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<DADeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DADeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DADeliverableTemplateDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllDADeliverableTemplates(): Observable<DADeliverableTemplateViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplate/GetAllDADeliverableTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDADeliverableTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDADeliverableTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateViewModel[]>;
        }));
    }

    protected processGetAllDADeliverableTemplates(response: HttpResponseBase): Observable<DADeliverableTemplateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableTemplateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDADeliverableTemplate(viewModel: DADeliverableTemplateViewModel): Observable<DADeliverableTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplate/CreateDADeliverableTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDADeliverableTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDADeliverableTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateViewModel>;
        }));
    }

    protected processCreateDADeliverableTemplate(response: HttpResponseBase): Observable<DADeliverableTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(viewModel: DADeliverableTemplateViewModel): Observable<DADeliverableTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplate/UpdateDADeliverableTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DADeliverableTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(viewModel: DADeliverableTemplateViewModel): Observable<DADeliverableTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DADeliverableTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<DADeliverableTemplateViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DADeliverableTemplateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableTemplateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update2(id: string, viewModel: DADeliverableTemplateViewModel): Observable<DADeliverableTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateViewModel>;
        }));
    }

    protected processUpdate2(response: HttpResponseBase): Observable<DADeliverableTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<DADeliverableTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DADeliverableTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DADeliverableTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DADeliverableTemplateTableDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllForPhaseId(projectPhaseId: string): Observable<DADeliverableTemplateTableViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplateTable/phase/{projectPhaseId}";
        if (projectPhaseId === undefined || projectPhaseId === null)
            throw new Error("The parameter 'projectPhaseId' must be defined.");
        url_ = url_.replace("{projectPhaseId}", encodeURIComponent("" + projectPhaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForPhaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForPhaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateTableViewModel[]>;
        }));
    }

    protected processGetAllForPhaseId(response: HttpResponseBase): Observable<DADeliverableTemplateTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableTemplateTableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllForPhaseIdAndFocusArea(projectPhaseId: string, focusAreaId: string): Observable<DADeliverableTemplateTableViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DADeliverableTemplateTable/phase/{projectPhaseId}/focusArea/{focusAreaId}";
        if (projectPhaseId === undefined || projectPhaseId === null)
            throw new Error("The parameter 'projectPhaseId' must be defined.");
        url_ = url_.replace("{projectPhaseId}", encodeURIComponent("" + projectPhaseId));
        if (focusAreaId === undefined || focusAreaId === null)
            throw new Error("The parameter 'focusAreaId' must be defined.");
        url_ = url_.replace("{focusAreaId}", encodeURIComponent("" + focusAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForPhaseIdAndFocusArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForPhaseIdAndFocusArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableTemplateTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableTemplateTableViewModel[]>;
        }));
    }

    protected processGetAllForPhaseIdAndFocusArea(response: HttpResponseBase): Observable<DADeliverableTemplateTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableTemplateTableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeliverableManagerOverviewDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDeliverableManagerOverviewForPhase(phaseId: string): Observable<DeliverableManagerOverviewViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DeliverableManagerOverview/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliverableManagerOverviewForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliverableManagerOverviewForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliverableManagerOverviewViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliverableManagerOverviewViewModel[]>;
        }));
    }

    protected processGetDeliverableManagerOverviewForPhase(response: HttpResponseBase): Observable<DeliverableManagerOverviewViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliverableManagerOverviewViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDeliverableRequestToProject(phaseId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/DeliverableManagerOverview/deliverablerequest/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDeliverableRequestToProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDeliverableRequestToProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportDeliverableRequestToProject(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeliverableMasterDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDeliverableMasterListForPhase(phaseId: string): Observable<DeliverableMasterViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DeliverableMaster/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliverableMasterListForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliverableMasterListForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliverableMasterViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliverableMasterViewModel[]>;
        }));
    }

    protected processGetDeliverableMasterListForPhase(response: HttpResponseBase): Observable<DeliverableMasterViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliverableMasterViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendDeliverableMessage(daDeliverableId: string, projectDeliverableId: string, message: string): Observable<DeliverableMessageViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/DeliverableMaster/SendDeliverableMessage/{daDeliverableId}/{projectDeliverableId}";
        if (daDeliverableId === undefined || daDeliverableId === null)
            throw new Error("The parameter 'daDeliverableId' must be defined.");
        url_ = url_.replace("{daDeliverableId}", encodeURIComponent("" + daDeliverableId));
        if (projectDeliverableId === undefined || projectDeliverableId === null)
            throw new Error("The parameter 'projectDeliverableId' must be defined.");
        url_ = url_.replace("{projectDeliverableId}", encodeURIComponent("" + projectDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDeliverableMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDeliverableMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliverableMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliverableMessageViewModel>;
        }));
    }

    protected processSendDeliverableMessage(response: HttpResponseBase): Observable<DeliverableMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliverableMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDeliverableMessageRead(messageIds: string[]): Observable<DeliverableMessageReadViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/DeliverableMaster/SetDeliverableMessageRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDeliverableMessageRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDeliverableMessageRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliverableMessageReadViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliverableMessageReadViewModel[]>;
        }));
    }

    protected processSetDeliverableMessageRead(response: HttpResponseBase): Observable<DeliverableMessageReadViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliverableMessageReadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GlobalMetricsDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getObservationReturns(bySME: boolean | undefined): Observable<GlobalMetricsObservationReturnsViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/GlobalMetrics/ObservationReturns?";
        if (bySME === null)
            throw new Error("The parameter 'bySME' cannot be null.");
        else if (bySME !== undefined)
            url_ += "bySME=" + encodeURIComponent("" + bySME) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationReturns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationReturns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalMetricsObservationReturnsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalMetricsObservationReturnsViewModel[]>;
        }));
    }

    protected processGetObservationReturns(response: HttpResponseBase): Observable<GlobalMetricsObservationReturnsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalMetricsObservationReturnsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationActionsTaken(): Observable<GlobalMetricsObservationActionsTakenViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/GlobalMetrics/ObservationActionsTaken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationActionsTaken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationActionsTaken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalMetricsObservationActionsTakenViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalMetricsObservationActionsTakenViewModel[]>;
        }));
    }

    protected processGetObservationActionsTaken(response: HttpResponseBase): Observable<GlobalMetricsObservationActionsTakenViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalMetricsObservationActionsTakenViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDismissedObservations(smeId: string | null | undefined, projectId: string | null | undefined): Observable<GlobalMetricsDismissedObservationsViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/GlobalMetrics/GetDismissedObservations?";
        if (smeId !== undefined && smeId !== null)
            url_ += "smeId=" + encodeURIComponent("" + smeId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDismissedObservations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDismissedObservations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalMetricsDismissedObservationsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalMetricsDismissedObservationsViewModel[]>;
        }));
    }

    protected processGetDismissedObservations(response: HttpResponseBase): Observable<GlobalMetricsDismissedObservationsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalMetricsDismissedObservationsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOverriddenDeliverables(): Observable<GlobalMetricsOverriddenDeliverablesViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/GlobalMetrics/OverriddenDeliverables";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverriddenDeliverables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverriddenDeliverables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalMetricsOverriddenDeliverablesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalMetricsOverriddenDeliverablesViewModel[]>;
        }));
    }

    protected processGetOverriddenDeliverables(response: HttpResponseBase): Observable<GlobalMetricsOverriddenDeliverablesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalMetricsOverriddenDeliverablesViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GlobalSettingsDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getValueRecognitions(): Observable<GlobalSettingsValueRecognitionViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/GlobalSettings/ValueRecognitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValueRecognitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValueRecognitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsValueRecognitionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsValueRecognitionViewModel[]>;
        }));
    }

    protected processGetValueRecognitions(response: HttpResponseBase): Observable<GlobalSettingsValueRecognitionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalSettingsValueRecognitionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendReleaseEmail(role: string | undefined): Observable<EmailToViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/GlobalSettings/SendReleaseEmail?";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReleaseEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReleaseEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailToViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailToViewModel>;
        }));
    }

    protected processSendReleaseEmail(response: HttpResponseBase): Observable<EmailToViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailToViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateValueRecognitions(valueRecognitions: GlobalSettingsValueRecognitionViewModel[]): Observable<GlobalSettingsValueRecognitionViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/GlobalSettings/UpdateValueRecognitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valueRecognitions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateValueRecognitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValueRecognitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsValueRecognitionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsValueRecognitionViewModel[]>;
        }));
    }

    protected processUpdateValueRecognitions(response: HttpResponseBase): Observable<GlobalSettingsValueRecognitionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalSettingsValueRecognitionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignments(): Observable<AssignmentViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/GlobalSettings/Assignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignmentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignmentViewModel[]>;
        }));
    }

    protected processGetAssignments(response: HttpResponseBase): Observable<AssignmentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IPIMSDocumentsDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchIPIMSDocuments(domain: string | undefined, filter: string | undefined): Observable<IPIMSDocumentsSearchViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/IPIMSDocuments/SearchIPIMSDocuments?";
        if (domain === null)
            throw new Error("The parameter 'domain' cannot be null.");
        else if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchIPIMSDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchIPIMSDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPIMSDocumentsSearchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPIMSDocumentsSearchViewModel>;
        }));
    }

    protected processSearchIPIMSDocuments(response: HttpResponseBase): Observable<IPIMSDocumentsSearchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IPIMSDocumentsSearchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIPIMSDomains(): Observable<IPIMSDomain[]> {
        let url_ = this.baseUrl + "/DAEngineer/IPIMSDocuments/GetIPIMSDomains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIPIMSDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIPIMSDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPIMSDomain[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPIMSDomain[]>;
        }));
    }

    protected processGetIPIMSDomains(response: HttpResponseBase): Observable<IPIMSDomain[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPIMSDomain.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MandatoryCheckTemplateDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    import(file: FileParameter | undefined, onlyAdd: boolean | undefined, insertMissing: boolean | undefined, removeDeleted: boolean | undefined, updateExisting: boolean | undefined): Observable<MandatoryCheckImportResultViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/MandatoryCheckTemplate/import?";
        if (onlyAdd === null)
            throw new Error("The parameter 'onlyAdd' cannot be null.");
        else if (onlyAdd !== undefined)
            url_ += "onlyAdd=" + encodeURIComponent("" + onlyAdd) + "&";
        if (insertMissing === null)
            throw new Error("The parameter 'insertMissing' cannot be null.");
        else if (insertMissing !== undefined)
            url_ += "insertMissing=" + encodeURIComponent("" + insertMissing) + "&";
        if (removeDeleted === null)
            throw new Error("The parameter 'removeDeleted' cannot be null.");
        else if (removeDeleted !== undefined)
            url_ += "removeDeleted=" + encodeURIComponent("" + removeDeleted) + "&";
        if (updateExisting === null)
            throw new Error("The parameter 'updateExisting' cannot be null.");
        else if (updateExisting !== undefined)
            url_ += "updateExisting=" + encodeURIComponent("" + updateExisting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MandatoryCheckImportResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MandatoryCheckImportResultViewModel>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<MandatoryCheckImportResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(ADAPModelValidator.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MandatoryCheckImportResultViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(viewModel: MandatoryCheckTemplateViewModel): Observable<MandatoryCheckTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/MandatoryCheckTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MandatoryCheckTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MandatoryCheckTemplateViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MandatoryCheckTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MandatoryCheckTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<MandatoryCheckTemplateViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/MandatoryCheckTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MandatoryCheckTemplateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MandatoryCheckTemplateViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MandatoryCheckTemplateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MandatoryCheckTemplateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: MandatoryCheckTemplateViewModel): Observable<MandatoryCheckTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/MandatoryCheckTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MandatoryCheckTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MandatoryCheckTemplateViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MandatoryCheckTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MandatoryCheckTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/MandatoryCheckTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<MandatoryCheckTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/MandatoryCheckTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MandatoryCheckTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MandatoryCheckTemplateViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MandatoryCheckTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MandatoryCheckTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObservationToolCheckDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getObservationToolCheck(observationToolCheckId: string): Observable<ObservationToolCheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolCheck/GetObservationToolCheck/{observationToolCheckId}";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel>;
        }));
    }

    protected processGetObservationToolCheck(response: HttpResponseBase): Observable<ObservationToolCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolCheckDashboardForPhase(phaseId: string): Observable<ObservationToolCheckDashboardViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolCheck/GetObservationToolCheckDashboardForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolCheckDashboardForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolCheckDashboardForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckDashboardViewModel[]>;
        }));
    }

    protected processGetObservationToolCheckDashboardForPhase(response: HttpResponseBase): Observable<ObservationToolCheckDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolChecksForPhase(phaseId: string): Observable<ObservationToolCheckViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolCheck/GetObservationToolChecksForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolChecksForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolChecksForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel[]>;
        }));
    }

    protected processGetObservationToolChecksForPhase(response: HttpResponseBase): Observable<ObservationToolCheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateObservationToolCheckComplete(observationToolCheckId: string, status: string | undefined): Observable<ObservationToolCheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolCheck/UpdateObservationToolCheckComplete/{observationToolCheckId}?";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateObservationToolCheckComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateObservationToolCheckComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel>;
        }));
    }

    protected processUpdateObservationToolCheckComplete(response: HttpResponseBase): Observable<ObservationToolCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateObservationToolCheckNotes(observationToolCheckId: string, notes: string): Observable<ObservationToolCheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolCheck/AddOrUpdateObservationToolCheckNotes/{observationToolCheckId}";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateObservationToolCheckNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateObservationToolCheckNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel>;
        }));
    }

    protected processAddOrUpdateObservationToolCheckNotes(response: HttpResponseBase): Observable<ObservationToolCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObservationToolDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getObservationToolForPhase(phaseId: string): Observable<ObservationToolDashboardViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDashboardViewModel[]>;
        }));
    }

    protected processGetObservationToolForPhase(response: HttpResponseBase): Observable<ObservationToolDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    details(observationToolId: string, getSMEAssignments: boolean | undefined): Observable<ObservationToolDetailsViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (getSMEAssignments === null)
            throw new Error("The parameter 'getSMEAssignments' cannot be null.");
        else if (getSMEAssignments !== undefined)
            url_ += "getSMEAssignments=" + encodeURIComponent("" + getSMEAssignments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDetailsViewModel>;
        }));
    }

    protected processDetails(response: HttpResponseBase): Observable<ObservationToolDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservation(observationId: string): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetObservation/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processGetObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectDeliverablesAndIPIMSDocumentsToAssign(ipimsDomain: string, phaseId: string | undefined): Observable<ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetProjectDeliverablesAndIPIMSDocumentsToAssign/{ipimsDomain}?";
        if (ipimsDomain === undefined || ipimsDomain === null)
            throw new Error("The parameter 'ipimsDomain' must be defined.");
        url_ = url_.replace("{ipimsDomain}", encodeURIComponent("" + ipimsDomain));
        if (phaseId === null)
            throw new Error("The parameter 'phaseId' cannot be null.");
        else if (phaseId !== undefined)
            url_ += "phaseId=" + encodeURIComponent("" + phaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDeliverablesAndIPIMSDocumentsToAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDeliverablesAndIPIMSDocumentsToAssign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel[]>;
        }));
    }

    protected processGetProjectDeliverablesAndIPIMSDocumentsToAssign(response: HttpResponseBase): Observable<ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRespondingToOptionsForObservation(observationId: string): Observable<ObservationToolCheckViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetRespondingToOptionsForObservation/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRespondingToOptionsForObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRespondingToOptionsForObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckViewModel[]>;
        }));
    }

    protected processGetRespondingToOptionsForObservation(response: HttpResponseBase): Observable<ObservationToolCheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAreaSelectionOptionsForPhase(phaseId: string): Observable<string[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetAreaSelectionOptionsForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaSelectionOptionsForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaSelectionOptionsForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAreaSelectionOptionsForPhase(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolDashboardIndicators(phaseId: string): Observable<ObservationToolDashboardIndicators> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetObservationToolDashboardIndicators/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolDashboardIndicators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolDashboardIndicators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDashboardIndicators>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDashboardIndicators>;
        }));
    }

    protected processGetObservationToolDashboardIndicators(response: HttpResponseBase): Observable<ObservationToolDashboardIndicators> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDashboardIndicators.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignIPIMSDocumentsOneToOne(assignments: ObservationToolIPIMSDocumentOneToOneAssignViewModel[]): Observable<ObservationToolDocumentViewModel[][]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/AssignIPIMSDocumentsOneToOne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignIPIMSDocumentsOneToOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignIPIMSDocumentsOneToOne(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[][]>;
        }));
    }

    protected processAssignIPIMSDocumentsOneToOne(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loadSharePointDocument(observationToolId: string, title: string | undefined, iPIMSDocumentURL: string | undefined): Observable<ObservationToolDocumentViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/LoadSharePointDocument/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (iPIMSDocumentURL === null)
            throw new Error("The parameter 'iPIMSDocumentURL' cannot be null.");
        else if (iPIMSDocumentURL !== undefined)
            url_ += "iPIMSDocumentURL=" + encodeURIComponent("" + iPIMSDocumentURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadSharePointDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadSharePointDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel>;
        }));
    }

    protected processLoadSharePointDocument(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDocumentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loadSharePointFolder(observationToolId: string, folderTitle: string | undefined, folderURL: string | undefined, documentsToLoad: ObservationToolDocumentLoadViewModel[]): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/LoadSharePointFolder/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (folderTitle === null)
            throw new Error("The parameter 'folderTitle' cannot be null.");
        else if (folderTitle !== undefined)
            url_ += "folderTitle=" + encodeURIComponent("" + folderTitle) + "&";
        if (folderURL === null)
            throw new Error("The parameter 'folderURL' cannot be null.");
        else if (folderURL !== undefined)
            url_ += "folderURL=" + encodeURIComponent("" + folderURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentsToLoad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadSharePointFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadSharePointFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processLoadSharePointFolder(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentsFromFolder(documentFolderId: string, getActive: boolean | undefined): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetDocumentsFromFolder/{documentFolderId}?";
        if (documentFolderId === undefined || documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' must be defined.");
        url_ = url_.replace("{documentFolderId}", encodeURIComponent("" + documentFolderId));
        if (getActive === null)
            throw new Error("The parameter 'getActive' cannot be null.");
        else if (getActive !== undefined)
            url_ += "getActive=" + encodeURIComponent("" + getActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsFromFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsFromFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processGetDocumentsFromFolder(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDocumentsFromFolder(documentFolderId: string, documentsChange: ObservationToolDocumentsFromFolderUpdateViewModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/UpdateDocumentsFromFolder/{documentFolderId}";
        if (documentFolderId === undefined || documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' must be defined.");
        url_ = url_.replace("{documentFolderId}", encodeURIComponent("" + documentFolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentsChange);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentsFromFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentsFromFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateDocumentsFromFolder(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignURLDocumentRevision(observationToolObservationId: string, title: string | undefined, iPIMSDocumentURL: string | undefined): Observable<ObservationToolObservationDocumentRevisionViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/AssignURLDocumentRevision/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (iPIMSDocumentURL === null)
            throw new Error("The parameter 'iPIMSDocumentURL' cannot be null.");
        else if (iPIMSDocumentURL !== undefined)
            url_ += "iPIMSDocumentURL=" + encodeURIComponent("" + iPIMSDocumentURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignURLDocumentRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignURLDocumentRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationDocumentRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationDocumentRevisionViewModel>;
        }));
    }

    protected processAssignURLDocumentRevision(response: HttpResponseBase): Observable<ObservationToolObservationDocumentRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationDocumentRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markDocumentRevisionsFinal(observationToolObservationId: string, documentIdsToMarkFinal: string[]): Observable<ObservationToolObservationDocumentRevisionViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/MarkDocumentRevisionsFinal/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentIdsToMarkFinal);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkDocumentRevisionsFinal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkDocumentRevisionsFinal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationDocumentRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationDocumentRevisionViewModel[]>;
        }));
    }

    protected processMarkDocumentRevisionsFinal(response: HttpResponseBase): Observable<ObservationToolObservationDocumentRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationDocumentRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignDocuments(observationToolId: string): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/AssignDocuments/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processAssignDocuments(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loadIPIMSDocuments(observationToolId: string, iPIMSDocumentsPrimaryKeys: string[]): Observable<ObservationToolDocumentViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/LoadIPIMSDocuments/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPIMSDocumentsPrimaryKeys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadIPIMSDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadIPIMSDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel[]>;
        }));
    }

    protected processLoadIPIMSDocuments(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignIPIMSDocumentRevisions(observationToolObservationId: string, iPIMSDocumentsPrimaryKeys: string[]): Observable<ObservationToolObservationDocumentRevisionViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/AssignIPIMSDocumentRevisions/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPIMSDocumentsPrimaryKeys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignIPIMSDocumentRevisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignIPIMSDocumentRevisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationDocumentRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationDocumentRevisionViewModel[]>;
        }));
    }

    protected processAssignIPIMSDocumentRevisions(response: HttpResponseBase): Observable<ObservationToolObservationDocumentRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationDocumentRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteObservationToolDocument(documentId: string, isSoftDelete: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/DeleteObservationToolDocument/{documentId}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (isSoftDelete === null)
            throw new Error("The parameter 'isSoftDelete' cannot be null.");
        else if (isSoftDelete !== undefined)
            url_ += "isSoftDelete=" + encodeURIComponent("" + isSoftDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObservationToolDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObservationToolDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteObservationToolDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    restoreObservationToolDocument(documentIds: string[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/RestoreObservationToolDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreObservationToolDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreObservationToolDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRestoreObservationToolDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignIPIMSObservationAttachments(observationToolObservationId: string, iPIMSDocumentsPrimaryKeys: string[]): Observable<ObservationToolObservationAttachmentViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/AssignIPIMSObservationAttachments/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPIMSDocumentsPrimaryKeys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignIPIMSObservationAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignIPIMSObservationAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationAttachmentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationAttachmentViewModel[]>;
        }));
    }

    protected processAssignIPIMSObservationAttachments(response: HttpResponseBase): Observable<ObservationToolObservationAttachmentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationAttachmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignURLDocumentAttachment(observationToolObservationId: string, title: string | undefined, documentURL: string | undefined): Observable<ObservationToolObservationAttachmentViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/AssignURLDocumentAttachment/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (documentURL === null)
            throw new Error("The parameter 'documentURL' cannot be null.");
        else if (documentURL !== undefined)
            url_ += "documentURL=" + encodeURIComponent("" + documentURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignURLDocumentAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignURLDocumentAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationAttachmentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationAttachmentViewModel>;
        }));
    }

    protected processAssignURLDocumentAttachment(response: HttpResponseBase): Observable<ObservationToolObservationAttachmentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationAttachmentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignIPIMSDocumentToNote(noteId: string, iPIMSDocumentPrimaryKey: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/AssignIPIMSDocumentToNote/{noteId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPIMSDocumentPrimaryKey);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignIPIMSDocumentToNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignIPIMSDocumentToNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAssignIPIMSDocumentToNote(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignURLDocumentToNote(noteId: string, title: string | undefined, documentURL: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/AssignURLDocumentToNote/{noteId}?";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (documentURL === null)
            throw new Error("The parameter 'documentURL' cannot be null.");
        else if (documentURL !== undefined)
            url_ += "documentURL=" + encodeURIComponent("" + documentURL) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignURLDocumentToNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignURLDocumentToNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAssignURLDocumentToNote(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteObservationAttachment(documentId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/DeleteObservationAttachment/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObservationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObservationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteObservationAttachment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateObservation(observationForm: ObservationToolObservationSaveDAEngineerViewModel, isDAObservation: boolean | undefined, saveAsDraft: boolean | undefined): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/UpdateObservation?";
        if (isDAObservation === null)
            throw new Error("The parameter 'isDAObservation' cannot be null.");
        else if (isDAObservation !== undefined)
            url_ += "isDAObservation=" + encodeURIComponent("" + isDAObservation) + "&";
        if (saveAsDraft === null)
            throw new Error("The parameter 'saveAsDraft' cannot be null.");
        else if (saveAsDraft !== undefined)
            url_ += "saveAsDraft=" + encodeURIComponent("" + saveAsDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(observationForm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processUpdateObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDocumentNickname(documentId: string, newNickname: string | null | undefined): Observable<ObservationToolDocumentViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/SetDocumentNickname/{documentId}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (newNickname !== undefined && newNickname !== null)
            url_ += "newNickname=" + encodeURIComponent("" + newNickname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDocumentNickname(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDocumentNickname(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDocumentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDocumentViewModel>;
        }));
    }

    protected processSetDocumentNickname(response: HttpResponseBase): Observable<ObservationToolDocumentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDocumentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDeliverableFlag(observationToolId: string, description: string | undefined): Observable<ObservationToolDeliverableFlagViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/CreateDeliverableFlag/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliverableFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliverableFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDeliverableFlagViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDeliverableFlagViewModel>;
        }));
    }

    protected processCreateDeliverableFlag(response: HttpResponseBase): Observable<ObservationToolDeliverableFlagViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDeliverableFlagViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDeliverableNote(observationToolId: string, title: string | undefined, description: string | undefined, documentId: string | null | undefined): Observable<ObservationToolDeliverableNoteViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/CreateDeliverableNote/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliverableNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliverableNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDeliverableNoteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDeliverableNoteViewModel>;
        }));
    }

    protected processCreateDeliverableNote(response: HttpResponseBase): Observable<ObservationToolDeliverableNoteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDeliverableNoteViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resolveDeliverableFlag(deliverableFlagId: string, observationToolId: string | undefined, resolvedResponse: string | undefined): Observable<ObservationToolDeliverableFlagViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/ResolveDeliverableFlag/{deliverableFlagId}?";
        if (deliverableFlagId === undefined || deliverableFlagId === null)
            throw new Error("The parameter 'deliverableFlagId' must be defined.");
        url_ = url_.replace("{deliverableFlagId}", encodeURIComponent("" + deliverableFlagId));
        if (observationToolId === null)
            throw new Error("The parameter 'observationToolId' cannot be null.");
        else if (observationToolId !== undefined)
            url_ += "observationToolId=" + encodeURIComponent("" + observationToolId) + "&";
        if (resolvedResponse === null)
            throw new Error("The parameter 'resolvedResponse' cannot be null.");
        else if (resolvedResponse !== undefined)
            url_ += "resolvedResponse=" + encodeURIComponent("" + resolvedResponse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveDeliverableFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveDeliverableFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDeliverableFlagViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDeliverableFlagViewModel>;
        }));
    }

    protected processResolveDeliverableFlag(response: HttpResponseBase): Observable<ObservationToolDeliverableFlagViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolDeliverableFlagViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dismissObservation(observationId: string, isDismissedJustified: boolean): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/DismissObservation/{observationId}/{isDismissedJustified}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        if (isDismissedJustified === undefined || isDismissedJustified === null)
            throw new Error("The parameter 'isDismissedJustified' must be defined.");
        url_ = url_.replace("{isDismissedJustified}", encodeURIComponent("" + isDismissedJustified));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processDismissObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    undoDismissObservation(observationId: string, isDismissedJustified: boolean): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/UndoDismissObservation/{observationId}/{isDismissedJustified}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        if (isDismissedJustified === undefined || isDismissedJustified === null)
            throw new Error("The parameter 'isDismissedJustified' must be defined.");
        url_ = url_.replace("{isDismissedJustified}", encodeURIComponent("" + isDismissedJustified));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoDismissObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoDismissObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processUndoDismissObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteObservation(observationId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/DeleteObservation/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteObservation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendObservationMessage(observationToolObservationId: string, message: string, channel: string | undefined, nextActionWith: string | null | undefined): Observable<ObservationToolObservationMessageViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/SendObservationMessage/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        if (nextActionWith !== undefined && nextActionWith !== null)
            url_ += "nextActionWith=" + encodeURIComponent("" + nextActionWith) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendObservationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendObservationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationMessageViewModel>;
        }));
    }

    protected processSendObservationMessage(response: HttpResponseBase): Observable<ObservationToolObservationMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setObservationMessageRead(observationToolObservationId: string, messageIds: string[]): Observable<ObservationToolObservationMessageReadViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/SetObservationMessageRead/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetObservationMessageRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetObservationMessageRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationMessageReadViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationMessageReadViewModel[]>;
        }));
    }

    protected processSetObservationMessageRead(response: HttpResponseBase): Observable<ObservationToolObservationMessageReadViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationMessageReadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendObservationToolCheckMessage(observationToolCheckId: string, message: string): Observable<ObservationToolCheckMessageViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/SendObservationToolCheckMessage/{observationToolCheckId}";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendObservationToolCheckMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendObservationToolCheckMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckMessageViewModel>;
        }));
    }

    protected processSendObservationToolCheckMessage(response: HttpResponseBase): Observable<ObservationToolCheckMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolCheckMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setObservationToolCheckMessageRead(messageIds: string[]): Observable<ObservationToolCheckMessageReadViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/SetObservationToolCheckMessageRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetObservationToolCheckMessageRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetObservationToolCheckMessageRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolCheckMessageReadViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolCheckMessageReadViewModel[]>;
        }));
    }

    protected processSetObservationToolCheckMessageRead(response: HttpResponseBase): Observable<ObservationToolCheckMessageReadViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolCheckMessageReadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publishMessage(observationToolObservationId: string, messageId: string | undefined): Observable<ObservationToolObservationMessageViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/PublishObservationMessage/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (messageId === null)
            throw new Error("The parameter 'messageId' cannot be null.");
        else if (messageId !== undefined)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationMessageViewModel>;
        }));
    }

    protected processPublishMessage(response: HttpResponseBase): Observable<ObservationToolObservationMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    returnMessage(observationToolObservationId: string, originalMessageId: string | undefined, message: string | undefined, channel: string | undefined): Observable<ObservationToolObservationMessageViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/ReturnObservationMessage/{observationToolObservationId}?";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        if (originalMessageId === null)
            throw new Error("The parameter 'originalMessageId' cannot be null.");
        else if (originalMessageId !== undefined)
            url_ += "originalMessageId=" + encodeURIComponent("" + originalMessageId) + "&";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationMessageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationMessageViewModel>;
        }));
    }

    protected processReturnMessage(response: HttpResponseBase): Observable<ObservationToolObservationMessageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationMessageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMoveToObservationToolVerification(phaseId: string): Observable<MoveToObservationToolVerificationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetMoveToObservationToolVerification/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMoveToObservationToolVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoveToObservationToolVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveToObservationToolVerificationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveToObservationToolVerificationViewModel>;
        }));
    }

    protected processGetMoveToObservationToolVerification(response: HttpResponseBase): Observable<MoveToObservationToolVerificationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveToObservationToolVerificationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportObservationsByPhaseId(phaseId: string, observationUrlForProjectContact: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/ExportObservationsByPhaseId/{phaseId}?";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        if (observationUrlForProjectContact === null)
            throw new Error("The parameter 'observationUrlForProjectContact' cannot be null.");
        else if (observationUrlForProjectContact !== undefined)
            url_ += "observationUrlForProjectContact=" + encodeURIComponent("" + observationUrlForProjectContact) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportObservationsByPhaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportObservationsByPhaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportObservationsByPhaseId(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportChecksByPhaseId(phaseId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/ExportChecksByPhaseId/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportChecksByPhaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportChecksByPhaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportChecksByPhaseId(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendObservationAttentionItemEmail(observationId: string): Observable<SMEAttentionItemReminderEmailToViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/SendObservationAttentionItemEmail/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendObservationAttentionItemEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendObservationAttentionItemEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEAttentionItemReminderEmailToViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEAttentionItemReminderEmailToViewModel>;
        }));
    }

    protected processSendObservationAttentionItemEmail(response: HttpResponseBase): Observable<SMEAttentionItemReminderEmailToViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEAttentionItemReminderEmailToViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendObservationToolAttentionItemEmail(request: ObservationToolAttentionItemReminderRequestViewModel): Observable<SMEAttentionItemReminderEmailToViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/SendObservationToolAttentionItemEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendObservationToolAttentionItemEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendObservationToolAttentionItemEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEAttentionItemReminderEmailToViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEAttentionItemReminderEmailToViewModel>;
        }));
    }

    protected processSendObservationToolAttentionItemEmail(response: HttpResponseBase): Observable<SMEAttentionItemReminderEmailToViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEAttentionItemReminderEmailToViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationPriorityRecommendationByAI(observation: ObservationToolGetObservationPriorityRecommendationByAIViewModel): Observable<ObservationToolObservationRecommendationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetObservationPriorityRecommendationByAI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(observation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationPriorityRecommendationByAI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationPriorityRecommendationByAI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationRecommendationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationRecommendationViewModel>;
        }));
    }

    protected processGetObservationPriorityRecommendationByAI(response: HttpResponseBase): Observable<ObservationToolObservationRecommendationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationRecommendationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDismissedObservationsBySmeAndPhase(smeId: string, projectPhaseId: string): Observable<ObservationToolObservationViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetDismissedObservationsBySmeAndPhase/{smeId}/{projectPhaseId}";
        if (smeId === undefined || smeId === null)
            throw new Error("The parameter 'smeId' must be defined.");
        url_ = url_.replace("{smeId}", encodeURIComponent("" + smeId));
        if (projectPhaseId === undefined || projectPhaseId === null)
            throw new Error("The parameter 'projectPhaseId' must be defined.");
        url_ = url_.replace("{projectPhaseId}", encodeURIComponent("" + projectPhaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDismissedObservationsBySmeAndPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDismissedObservationsBySmeAndPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel[]>;
        }));
    }

    protected processGetDismissedObservationsBySmeAndPhase(response: HttpResponseBase): Observable<ObservationToolObservationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    overrideMarkDisciplinesReviewed(observationToolId: string, disciplinesAndOverrideReasons: ObservationToolDisciplineOverrideCompleteViewModel[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/OverrideMarkDisciplinesReviewed/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(disciplinesAndOverrideReasons);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverrideMarkDisciplinesReviewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverrideMarkDisciplinesReviewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOverrideMarkDisciplinesReviewed(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setNextActionWithDAEngineer(observationToolObservationId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/SetNextActionWithDAEngineer/{observationToolObservationId}";
        if (observationToolObservationId === undefined || observationToolObservationId === null)
            throw new Error("The parameter 'observationToolObservationId' must be defined.");
        url_ = url_.replace("{observationToolObservationId}", encodeURIComponent("" + observationToolObservationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNextActionWithDAEngineer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNextActionWithDAEngineer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSetNextActionWithDAEngineer(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markDocumentsRequiredToSME(observationToolId: string, selection: SMEDocumentsRequiredSelectionViewModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/MarkDocumentsRequiredToSME/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selection);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkDocumentsRequiredToSME(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkDocumentsRequiredToSME(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processMarkDocumentsRequiredToSME(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkDocumentsRequiredToSME(observationToolId: string): Observable<SMEDocumentsRequiredSelectionViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/CheckDocumentsRequiredToSME/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDocumentsRequiredToSME(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDocumentsRequiredToSME(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDocumentsRequiredSelectionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDocumentsRequiredSelectionViewModel>;
        }));
    }

    protected processCheckDocumentsRequiredToSME(response: HttpResponseBase): Observable<SMEDocumentsRequiredSelectionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDocumentsRequiredSelectionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDocumentsRequired(observationToolId: string): Observable<SMEDocumentsRequiredViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetSMEDocumentsRequired/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDocumentsRequired(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDocumentsRequired(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDocumentsRequiredViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDocumentsRequiredViewModel[]>;
        }));
    }

    protected processGetSMEDocumentsRequired(response: HttpResponseBase): Observable<SMEDocumentsRequiredViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDocumentsRequiredViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createRange(viewModel: DisciplineDocumentMappingListViewModel): Observable<SMEDocumentsRequiredViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDocumentsRequiredViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDocumentsRequiredViewModel[]>;
        }));
    }

    protected processCreateRange(response: HttpResponseBase): Observable<SMEDocumentsRequiredViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDocumentsRequiredViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDABookmarks(observationToolId: string, referenceId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/DeleteDABookmarks/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referenceId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDABookmarks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDABookmarks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteDABookmarks(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSMEBookmarks(observationToolId: string, bookmarks: SMEDocumentsBookmarkedViewModel[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/DeleteSMEBookmarks/{observationToolId}";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookmarks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSMEBookmarks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSMEBookmarks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteSMEBookmarks(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportObservationToolDeliverablesByIds(phaseId: string, ids: string[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/ExportDeliverablesByIds/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportObservationToolDeliverablesByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportObservationToolDeliverablesByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportObservationToolDeliverablesByIds(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDisciplinesAssignedToCurrentUser(phaseId: string): Observable<SMEDisciplineInObservationViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetDisciplinesAssignedToCurrentUser/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDisciplinesAssignedToCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDisciplinesAssignedToCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineInObservationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineInObservationViewModel[]>;
        }));
    }

    protected processGetDisciplinesAssignedToCurrentUser(response: HttpResponseBase): Observable<SMEDisciplineInObservationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplineInObservationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createObservation(observationToolId: string, observationForm: ObservationToolObservationSaveSMEObservationViewModel, saveAsDraft: boolean | undefined): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/CreateObservation/{observationToolId}?";
        if (observationToolId === undefined || observationToolId === null)
            throw new Error("The parameter 'observationToolId' must be defined.");
        url_ = url_.replace("{observationToolId}", encodeURIComponent("" + observationToolId));
        if (saveAsDraft === null)
            throw new Error("The parameter 'saveAsDraft' cannot be null.");
        else if (saveAsDraft !== undefined)
            url_ += "saveAsDraft=" + encodeURIComponent("" + saveAsDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(observationForm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateObservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateObservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processCreateObservation(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createObservationForCheck(observationToolCheckId: string, observationForm: ObservationToolObservationSaveSMEObservationViewModel, saveAsDraft: boolean | undefined): Observable<ObservationToolObservationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/CreateObservationForCheck/{observationToolCheckId}?";
        if (observationToolCheckId === undefined || observationToolCheckId === null)
            throw new Error("The parameter 'observationToolCheckId' must be defined.");
        url_ = url_.replace("{observationToolCheckId}", encodeURIComponent("" + observationToolCheckId));
        if (saveAsDraft === null)
            throw new Error("The parameter 'saveAsDraft' cannot be null.");
        else if (saveAsDraft !== undefined)
            url_ += "saveAsDraft=" + encodeURIComponent("" + saveAsDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(observationForm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateObservationForCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateObservationForCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel>;
        }));
    }

    protected processCreateObservationForCheck(response: HttpResponseBase): Observable<ObservationToolObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteObservationMessage(messageId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/DeleteObservationMessage/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObservationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObservationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteObservationMessage(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveObservationMessage(messageId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/MoveObservationMessage/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveObservationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveObservationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processMoveObservationMessage(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationsDashboard(phaseId: string): Observable<ObservationToolObservationDashboardViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationTool/GetObservationsDashboard/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationsDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationsDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationDashboardViewModel[]>;
        }));
    }

    protected processGetObservationsDashboard(response: HttpResponseBase): Observable<ObservationToolObservationDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObservationToolMetricsDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getObservationToolMetricsDeliverables(phaseId: string, onlyCarryOver: boolean): Observable<ObservationToolMetricsDeliverablesViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/GetObservationToolMetricsDeliverables/{phaseId}/{onlyCarryOver}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        if (onlyCarryOver === undefined || onlyCarryOver === null)
            throw new Error("The parameter 'onlyCarryOver' must be defined.");
        url_ = url_.replace("{onlyCarryOver}", encodeURIComponent("" + onlyCarryOver));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolMetricsDeliverables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolMetricsDeliverables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolMetricsDeliverablesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolMetricsDeliverablesViewModel>;
        }));
    }

    protected processGetObservationToolMetricsDeliverables(response: HttpResponseBase): Observable<ObservationToolMetricsDeliverablesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolMetricsDeliverablesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolMetricsChecks(phaseId: string): Observable<ObservationToolMetricsChecksViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/GetObservationToolMetricsChecks/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolMetricsChecks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolMetricsChecks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolMetricsChecksViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolMetricsChecksViewModel>;
        }));
    }

    protected processGetObservationToolMetricsChecks(response: HttpResponseBase): Observable<ObservationToolMetricsChecksViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolMetricsChecksViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolMetricsObservationsInfo(phaseId: string, onlyCarryOver: boolean): Observable<ObservationToolMetricsObservationInfoViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/GetObservationToolMetricsObservationsInfo/{phaseId}/{onlyCarryOver}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        if (onlyCarryOver === undefined || onlyCarryOver === null)
            throw new Error("The parameter 'onlyCarryOver' must be defined.");
        url_ = url_.replace("{onlyCarryOver}", encodeURIComponent("" + onlyCarryOver));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolMetricsObservationsInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolMetricsObservationsInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolMetricsObservationInfoViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolMetricsObservationInfoViewModel[]>;
        }));
    }

    protected processGetObservationToolMetricsObservationsInfo(response: HttpResponseBase): Observable<ObservationToolMetricsObservationInfoViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolMetricsObservationInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolMetricsReadinessCheck(phaseId: string): Observable<ReadinessCheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/GetObservationToolMetricsReadinessCheck/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolMetricsReadinessCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolMetricsReadinessCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReadinessCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReadinessCheckViewModel>;
        }));
    }

    protected processGetObservationToolMetricsReadinessCheck(response: HttpResponseBase): Observable<ReadinessCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReadinessCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolMetricsPendingDeliverables(phaseId: string): Observable<ObservationToolDashboardViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/GetObservationToolMetricsPendingDeliverables/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolMetricsPendingDeliverables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolMetricsPendingDeliverables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolDashboardViewModel[]>;
        }));
    }

    protected processGetObservationToolMetricsPendingDeliverables(response: HttpResponseBase): Observable<ObservationToolDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolMetricsPendingObservations(phaseId: string): Observable<ObservationToolObservationViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/GetObservationToolMetricsPendingObservations/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolMetricsPendingObservations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolMetricsPendingObservations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolObservationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolObservationViewModel[]>;
        }));
    }

    protected processGetObservationToolMetricsPendingObservations(response: HttpResponseBase): Observable<ObservationToolObservationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationToolObservationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolMetricsPendingChecks(phaseId: string): Observable<CheckWithObservationsViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/GetObservationToolMetricsPendingChecks/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolMetricsPendingChecks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolMetricsPendingChecks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckWithObservationsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckWithObservationsViewModel[]>;
        }));
    }

    protected processGetObservationToolMetricsPendingChecks(response: HttpResponseBase): Observable<CheckWithObservationsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckWithObservationsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getObservationToolMetricsValueRecognition(phaseId: string, startDate: string, endDate: string): Observable<ObservationToolMetricsValueRecognitionViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/GetObservationToolMetricsValueRecognition/{phaseId}/{startDate}/{endDate}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent("" + endDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservationToolMetricsValueRecognition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservationToolMetricsValueRecognition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationToolMetricsValueRecognitionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationToolMetricsValueRecognitionViewModel>;
        }));
    }

    protected processGetObservationToolMetricsValueRecognition(response: HttpResponseBase): Observable<ObservationToolMetricsValueRecognitionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationToolMetricsValueRecognitionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateValueRecognitionForProject(projectId: string): Observable<ProjectValueRecognitionViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ObservationToolMetrics/UpdateValueRecognitionForProject/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateValueRecognitionForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValueRecognitionForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectValueRecognitionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectValueRecognitionViewModel[]>;
        }));
    }

    protected processUpdateValueRecognitionForProject(response: HttpResponseBase): Observable<ProjectValueRecognitionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectValueRecognitionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(id: string): Observable<ProjectViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: ProjectViewModel): Observable<ProjectViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getValueRecognition(projectId: string): Observable<ProjectValueRecognitionViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Project/ValueRecognition/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValueRecognition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValueRecognition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectValueRecognitionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectValueRecognitionViewModel[]>;
        }));
    }

    protected processGetValueRecognition(response: HttpResponseBase): Observable<ProjectValueRecognitionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectValueRecognitionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<ProjectViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Project";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProjectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(viewModel: ProjectViewModel): Observable<ProjectViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    archive(projectId: string): Observable<ProjectViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Project/Archive/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<ProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reinstateArchived(projectId: string): Observable<ProjectViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Project/ReinstateArchived/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReinstateArchived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReinstateArchived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel>;
        }));
    }

    protected processReinstateArchived(response: HttpResponseBase): Observable<ProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectDADeliverableMappingDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createRange(viewModel: ProjectDADeliverableMappingListViewModel): Observable<ProjectDADeliverableMappingViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDADeliverableMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDADeliverableMappingViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDADeliverableMappingViewModel[]>;
        }));
    }

    protected processCreateRange(response: HttpResponseBase): Observable<ProjectDADeliverableMappingViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDADeliverableMappingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOneOnOneMappings(viewModel: ProjectDADeliverableOneOnOneMappingViewModel[]): Observable<ProjectDADeliverableMappingViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDADeliverableMapping/oneOnOneMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOneOnOneMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOneOnOneMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDADeliverableMappingViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDADeliverableMappingViewModel[]>;
        }));
    }

    protected processCreateOneOnOneMappings(response: HttpResponseBase): Observable<ProjectDADeliverableMappingViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDADeliverableMappingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteMappingsForDADeliverable(daDeliverableId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDADeliverableMapping/deleteMappingsForDADeliverable/{daDeliverableId}";
        if (daDeliverableId === undefined || daDeliverableId === null)
            throw new Error("The parameter 'daDeliverableId' must be defined.");
        url_ = url_.replace("{daDeliverableId}", encodeURIComponent("" + daDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMappingsForDADeliverable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMappingsForDADeliverable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteMappingsForDADeliverable(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteMappingsForProjectDeliverable(projectDeliverableId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDADeliverableMapping/deleteMappingsForProjectDeliverable/{projectDeliverableId}";
        if (projectDeliverableId === undefined || projectDeliverableId === null)
            throw new Error("The parameter 'projectDeliverableId' must be defined.");
        url_ = url_.replace("{projectDeliverableId}", encodeURIComponent("" + projectDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMappingsForProjectDeliverable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMappingsForProjectDeliverable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteMappingsForProjectDeliverable(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLastWorkplanSharedDate(phaseId: string): Observable<ProjectPhaseViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDADeliverableMapping/UpdateLastWorkplanSharedDate/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLastWorkplanSharedDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLastWorkplanSharedDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseViewModel>;
        }));
    }

    protected processUpdateLastWorkplanSharedDate(response: HttpResponseBase): Observable<ProjectPhaseViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectPhaseViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectDeliverableCheckMappingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getByPhaseId(phaseId: string): Observable<ProjectDeliverableCheckMappingViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverableCheckMapping/GetByPhaseId/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPhaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPhaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableCheckMappingViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableCheckMappingViewModel[]>;
        }));
    }

    protected processGetByPhaseId(response: HttpResponseBase): Observable<ProjectDeliverableCheckMappingViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDeliverableCheckMappingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createRange(viewModel: ProjectDeliverableCheckMappingListViewModel): Observable<ProjectDeliverableCheckMappingViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverableCheckMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableCheckMappingViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableCheckMappingViewModel[]>;
        }));
    }

    protected processCreateRange(response: HttpResponseBase): Observable<ProjectDeliverableCheckMappingViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDeliverableCheckMappingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteMappingsForCheck(checkId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverableCheckMapping/deleteMappingsForCheck/{checkId}";
        if (checkId === undefined || checkId === null)
            throw new Error("The parameter 'checkId' must be defined.");
        url_ = url_.replace("{checkId}", encodeURIComponent("" + checkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMappingsForCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMappingsForCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteMappingsForCheck(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCheckMappingsForProjectDeliverable(projectDeliverableId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverableCheckMapping/deleteCheckMappingsForProjectDeliverable/{projectDeliverableId}";
        if (projectDeliverableId === undefined || projectDeliverableId === null)
            throw new Error("The parameter 'projectDeliverableId' must be defined.");
        url_ = url_.replace("{projectDeliverableId}", encodeURIComponent("" + projectDeliverableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCheckMappingsForProjectDeliverable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCheckMappingsForProjectDeliverable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteCheckMappingsForProjectDeliverable(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectDeliverableDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(viewModel: ProjectDeliverableViewModel): Observable<ProjectDeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProjectDeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<ProjectDeliverableViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProjectDeliverableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDeliverableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllForPhase(phaseId: string): Observable<ProjectDeliverableViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableViewModel[]>;
        }));
    }

    protected processGetAllForPhase(response: HttpResponseBase): Observable<ProjectDeliverableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDeliverableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllWithMappingsForPhase(phaseId: string): Observable<ProjectDeliverableWithMappingsViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/{phaseId}/mappings";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithMappingsForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithMappingsForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableWithMappingsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableWithMappingsViewModel[]>;
        }));
    }

    protected processGetAllWithMappingsForPhase(response: HttpResponseBase): Observable<ProjectDeliverableWithMappingsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDeliverableWithMappingsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllWithCheckMappingsForPhase(phaseId: string): Observable<ProjectDeliverableWithCheckMappingsViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/{phaseId}/check/mappings";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithCheckMappingsForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithCheckMappingsForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableWithCheckMappingsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableWithCheckMappingsViewModel[]>;
        }));
    }

    protected processGetAllWithCheckMappingsForPhase(response: HttpResponseBase): Observable<ProjectDeliverableWithCheckMappingsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDeliverableWithCheckMappingsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(phaseId: string, file: FileParameter | undefined, onlyAdd: boolean | undefined, insertMissing: boolean | undefined, removeDeleted: boolean | undefined, updateExisting: boolean | undefined): Observable<ProjectDeliverableImportResultViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/import/{phaseId}?";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        if (onlyAdd === null)
            throw new Error("The parameter 'onlyAdd' cannot be null.");
        else if (onlyAdd !== undefined)
            url_ += "onlyAdd=" + encodeURIComponent("" + onlyAdd) + "&";
        if (insertMissing === null)
            throw new Error("The parameter 'insertMissing' cannot be null.");
        else if (insertMissing !== undefined)
            url_ += "insertMissing=" + encodeURIComponent("" + insertMissing) + "&";
        if (removeDeleted === null)
            throw new Error("The parameter 'removeDeleted' cannot be null.");
        else if (removeDeleted !== undefined)
            url_ += "removeDeleted=" + encodeURIComponent("" + removeDeleted) + "&";
        if (updateExisting === null)
            throw new Error("The parameter 'updateExisting' cannot be null.");
        else if (updateExisting !== undefined)
            url_ += "updateExisting=" + encodeURIComponent("" + updateExisting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableImportResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableImportResultViewModel>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ProjectDeliverableImportResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(ADAPModelValidator.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableImportResultViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkForUploadDuplicates(phaseId: string, file: FileParameter | undefined): Observable<ProjectDeliverableImportDuplicatesViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/CheckForUploadDuplicates/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckForUploadDuplicates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckForUploadDuplicates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableImportDuplicatesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableImportDuplicatesViewModel[]>;
        }));
    }

    protected processCheckForUploadDuplicates(response: HttpResponseBase): Observable<ProjectDeliverableImportDuplicatesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(ADAPModelValidator.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDeliverableImportDuplicatesViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadImportTemplateFile(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/DownloadImportTemplateFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImportTemplateFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImportTemplateFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadImportTemplateFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUnmatchedCarryOvers(phaseId: string | undefined): Observable<ProjectDeliverableViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/GetUnmatchedCarryOversProjectDeliverables?";
        if (phaseId === null)
            throw new Error("The parameter 'phaseId' cannot be null.");
        else if (phaseId !== undefined)
            url_ += "phaseId=" + encodeURIComponent("" + phaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnmatchedCarryOvers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnmatchedCarryOvers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableViewModel[]>;
        }));
    }

    protected processGetUnmatchedCarryOvers(response: HttpResponseBase): Observable<ProjectDeliverableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDeliverableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setSSR(projectDeliverableId: string | undefined, isSSR: boolean | undefined): Observable<ProjectDeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/SetSSR?";
        if (projectDeliverableId === null)
            throw new Error("The parameter 'projectDeliverableId' cannot be null.");
        else if (projectDeliverableId !== undefined)
            url_ += "projectDeliverableId=" + encodeURIComponent("" + projectDeliverableId) + "&";
        if (isSSR === null)
            throw new Error("The parameter 'isSSR' cannot be null.");
        else if (isSSR !== undefined)
            url_ += "isSSR=" + encodeURIComponent("" + isSSR) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSSR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSSR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableViewModel>;
        }));
    }

    protected processSetSSR(response: HttpResponseBase): Observable<ProjectDeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: ProjectDeliverableViewModel): Observable<ProjectDeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProjectDeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<ProjectDeliverableViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectDeliverable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDeliverableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDeliverableViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectDeliverableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectPhaseDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    update(id: string, viewModel: ProjectPhaseViewModel): Observable<ProjectPhaseViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhase/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProjectPhaseViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectPhaseViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<ProjectPhaseViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhase/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectPhaseViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectPhaseViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<ProjectPhaseViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProjectPhaseViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectPhaseViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(viewModel: ProjectPhaseViewModel): Observable<ProjectPhaseViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProjectPhaseViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectPhaseViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    emailMyTeam(id: string, role: string | undefined): Observable<EmailToViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhase/EmailMyTeam/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailMyTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailMyTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailToViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailToViewModel>;
        }));
    }

    protected processEmailMyTeam(response: HttpResponseBase): Observable<EmailToViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailToViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setValueRecognitionNotes(id: string, valueRecognitionNotes: string): Observable<string> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhase/SetValueRecognitionNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valueRecognitionNotes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetValueRecognitionNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetValueRecognitionNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetValueRecognitionNotes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhase/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectPhaseTemplateDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(id: string): Observable<ProjectPhaseTemplateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhaseTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseTemplateViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectPhaseTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectPhaseTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<ProjectPhaseTemplateViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ProjectPhaseTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseTemplateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseTemplateViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProjectPhaseTemplateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectPhaseTemplateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReadinessCheckDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(phaseId: string, viewModel: ReadinessCheckSaveViewModel): Observable<ReadinessCheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ReadinessCheck/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReadinessCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReadinessCheckViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReadinessCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReadinessCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: ReadinessCheckSaveViewModel): Observable<ReadinessCheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ReadinessCheck/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReadinessCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReadinessCheckViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReadinessCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReadinessCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<ReadinessCheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/ReadinessCheck/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReadinessCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReadinessCheckViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ReadinessCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReadinessCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<ReadinessCheckViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/ReadinessCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReadinessCheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReadinessCheckViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReadinessCheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReadinessCheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportGeneratorDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getReadinessCheckReportByPhaseId(phaseId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/ReportGenerator/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReadinessCheckReportByPhaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReadinessCheckReportByPhaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetReadinessCheckReportByPhaseId(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RiskAssessmentConfigDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllFocusAreaConfigs(): Observable<FocusAreaConfigViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig/GetAllFocusAreaConfigs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFocusAreaConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFocusAreaConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaConfigViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaConfigViewModel[]>;
        }));
    }

    protected processGetAllFocusAreaConfigs(response: HttpResponseBase): Observable<FocusAreaConfigViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FocusAreaConfigViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFocusAreaConfigWithProjectPhaseTemplateDefinitions(id: string | undefined): Observable<FocusAreaConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig/GetFocusAreaConfigWithProjectPhaseTemplateDefinitions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFocusAreaConfigWithProjectPhaseTemplateDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFocusAreaConfigWithProjectPhaseTemplateDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaConfigViewModel>;
        }));
    }

    protected processGetFocusAreaConfigWithProjectPhaseTemplateDefinitions(response: HttpResponseBase): Observable<FocusAreaConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createFocusAreaConfig(viewModel: FocusAreaConfigViewModel): Observable<FocusAreaConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig/CreateFocusAreaConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFocusAreaConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFocusAreaConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaConfigViewModel>;
        }));
    }

    protected processCreateFocusAreaConfig(response: HttpResponseBase): Observable<FocusAreaConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(viewModel: FocusAreaConfigViewModel): Observable<FocusAreaConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig/UpdateFocusAreaConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaConfigViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FocusAreaConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFocusAreaConfig(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig/DeleteFocusAreaConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFocusAreaConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFocusAreaConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteFocusAreaConfig(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(viewModel: FocusAreaConfigViewModel): Observable<FocusAreaConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaConfigViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FocusAreaConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<FocusAreaConfigViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaConfigViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaConfigViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FocusAreaConfigViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FocusAreaConfigViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update2(id: string, viewModel: FocusAreaConfigViewModel): Observable<FocusAreaConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaConfigViewModel>;
        }));
    }

    protected processUpdate2(response: HttpResponseBase): Observable<FocusAreaConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<FocusAreaConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessmentConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaConfigViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FocusAreaConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RiskAssessmentDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllForPhase(phaseId: string): Observable<FocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaViewModel[]>;
        }));
    }

    protected processGetAllForPhase(response: HttpResponseBase): Observable<FocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFocusAreasDisplayingDisciplinesForPhase(phaseId: string): Observable<FocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/GetFocusAreasDisplayingDisciplinesForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFocusAreasDisplayingDisciplinesForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFocusAreasDisplayingDisciplinesForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaViewModel[]>;
        }));
    }

    protected processGetFocusAreasDisplayingDisciplinesForPhase(response: HttpResponseBase): Observable<FocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDeliverableRecommendationToFocusArea(viewModel: DeliverablesRecommendationForFocusAreaViewModel): Observable<DADeliverableFocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/deliverables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDeliverableRecommendationToFocusArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDeliverableRecommendationToFocusArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableFocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableFocusAreaViewModel[]>;
        }));
    }

    protected processAddDeliverableRecommendationToFocusArea(response: HttpResponseBase): Observable<DADeliverableFocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableFocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeDeliverablesRecommendationToFocusArea(viewModel: DeliverablesRecommendationForFocusAreaViewModel): Observable<DADeliverableFocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/deliverables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDeliverablesRecommendationToFocusArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDeliverablesRecommendationToFocusArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableFocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableFocusAreaViewModel[]>;
        }));
    }

    protected processRemoveDeliverablesRecommendationToFocusArea(response: HttpResponseBase): Observable<DADeliverableFocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableFocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDADeliverables(focusAreaId: string): Observable<DADeliverableFocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/deliverables/{focusAreaId}";
        if (focusAreaId === undefined || focusAreaId === null)
            throw new Error("The parameter 'focusAreaId' must be defined.");
        url_ = url_.replace("{focusAreaId}", encodeURIComponent("" + focusAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDADeliverables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDADeliverables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableFocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableFocusAreaViewModel[]>;
        }));
    }

    protected processGetDADeliverables(response: HttpResponseBase): Observable<DADeliverableFocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableFocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRiskAssessmentExport(phaseId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/export/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRiskAssessmentExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRiskAssessmentExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetRiskAssessmentExport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRiskAssessmentExportByFocusArea(phaseId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/exportByFocusArea/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRiskAssessmentExportByFocusArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRiskAssessmentExportByFocusArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetRiskAssessmentExportByFocusArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRiskAssessmentExportByDeliverable(phaseId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/exportByDeliverable/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRiskAssessmentExportByDeliverable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRiskAssessmentExportByDeliverable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetRiskAssessmentExportByDeliverable(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCustomFocusAreaForProject(phaseId: string, viewModel: FocusAreaCreateOrUpdateViewModel): Observable<FocusAreaViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/CreateCustomFocusAreaForProject/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomFocusAreaForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomFocusAreaForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaViewModel>;
        }));
    }

    protected processCreateCustomFocusAreaForProject(response: HttpResponseBase): Observable<FocusAreaViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCustomFocusAreaForProject(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/DeleteCustomFocusAreaForProject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomFocusAreaForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomFocusAreaForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteCustomFocusAreaForProject(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(viewModel: FocusAreaCreateOrUpdateViewModel): Observable<FocusAreaViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FocusAreaViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<FocusAreaViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FocusAreaViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FocusAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatement(viewModel: FocusAreaUpdateStatementViewModel): Observable<FocusAreaViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/statement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaViewModel>;
        }));
    }

    protected processUpdateStatement(response: HttpResponseBase): Observable<FocusAreaViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePositionFocusArea(id: string, direction: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/ChangePositionFocusArea/{id}/{direction}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (direction === undefined || direction === null)
            throw new Error("The parameter 'direction' must be defined.");
        url_ = url_.replace("{direction}", encodeURIComponent("" + direction));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePositionFocusArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePositionFocusArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangePositionFocusArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<FocusAreaViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/RiskAssessment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FocusAreaViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FocusAreaViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FocusAreaViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FocusAreaViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SharePointPeerPoolDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getApprovedPeerPoolUsers(): Observable<string[]> {
        let url_ = this.baseUrl + "/DAEngineer/SharePointPeerPool/GetApprovedPeerPoolUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedPeerPoolUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedPeerPoolUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetApprovedPeerPoolUsers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SMEDisciplineDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSMEDisciplinesForPhase(phaseId: string): Observable<SMEDisciplineViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinesForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinesForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineViewModel[]>;
        }));
    }

    protected processGetSMEDisciplinesForPhase(response: HttpResponseBase): Observable<SMEDisciplineViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplineViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplinePeerPool(id: string): Observable<SMEDisciplinePeerPoolViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/PeerPoolDiscipline/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinePeerPool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinePeerPool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolViewModel>;
        }));
    }

    protected processGetSMEDisciplinePeerPool(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplinesPeerPoolForPhase(phaseId: string): Observable<SMEDisciplinePeerPoolViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/PeerPoolForPhase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinesPeerPoolForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinesPeerPoolForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolViewModel[]>;
        }));
    }

    protected processGetSMEDisciplinesPeerPoolForPhase(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplinePeerPoolViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplinePeerPoolWithProjectAndDADeliverables(disciplineId: string): Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/PeerPoolForSME/{disciplineId}";
        if (disciplineId === undefined || disciplineId === null)
            throw new Error("The parameter 'disciplineId' must be defined.");
        url_ = url_.replace("{disciplineId}", encodeURIComponent("" + disciplineId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinePeerPoolWithProjectAndDADeliverables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinePeerPoolWithProjectAndDADeliverables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel>;
        }));
    }

    protected processGetSMEDisciplinePeerPoolWithProjectAndDADeliverables(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: SMEDisciplinePeerPoolViewModel): Observable<SMEDisciplinePeerPoolViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/SMEDisciplinePeerPool/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplineConfigCodes(projectId: string): Observable<string[]> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/GetSMEDisciplineConfigCodes/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplineConfigCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplineConfigCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSMEDisciplineConfigCodes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSMEDisciplineConfigs(): Observable<SMEDisciplineConfigViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/GetAllSMEDisciplineConfigs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSMEDisciplineConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSMEDisciplineConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineConfigViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineConfigViewModel[]>;
        }));
    }

    protected processGetAllSMEDisciplineConfigs(response: HttpResponseBase): Observable<SMEDisciplineConfigViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplineConfigViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplineConfigPeerPool(id: string): Observable<SMEDisciplineConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/PeerPoolDisciplineConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplineConfigPeerPool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplineConfigPeerPool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineConfigViewModel>;
        }));
    }

    protected processGetSMEDisciplineConfigPeerPool(response: HttpResponseBase): Observable<SMEDisciplineConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplineConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIsDADisciplineAssignedToUser(phaseId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/GetIsDADisciplineAssignedToUser/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsDADisciplineAssignedToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsDADisciplineAssignedToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetIsDADisciplineAssignedToUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCustomSMEDisciplineConfig(viewModel: SMEDisciplineConfigViewModel): Observable<SMEDisciplineConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/CreateCustomSMEDisciplineConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomSMEDisciplineConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomSMEDisciplineConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineConfigViewModel>;
        }));
    }

    protected processCreateCustomSMEDisciplineConfig(response: HttpResponseBase): Observable<SMEDisciplineConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplineConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCustomSMEDisciplineConfig(id: string, viewModel: SMEDisciplineConfigViewModel): Observable<SMEDisciplineConfigViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/UpdateCustomSMEDisciplineConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomSMEDisciplineConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomSMEDisciplineConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineConfigViewModel>;
        }));
    }

    protected processUpdateCustomSMEDisciplineConfig(response: HttpResponseBase): Observable<SMEDisciplineConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplineConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCustomSMEDisciplineConfig(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/DeleteCustomSMEDisciplineConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomSMEDisciplineConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomSMEDisciplineConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteCustomSMEDisciplineConfig(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCustomSMEDisciplineForProject(viewModel: SMEDisciplineCreateOrUpdateViewModel): Observable<SMEDisciplinePeerPoolViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/CreateCustomSMEDisciplineForProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomSMEDisciplineForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomSMEDisciplineForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolViewModel>;
        }));
    }

    protected processCreateCustomSMEDisciplineForProject(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCustomSMEDisciplineForProject(id: string, viewModel: SMEDisciplineCreateOrUpdateViewModel): Observable<SMEDisciplinePeerPoolViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/UpdateCustomSMEDisciplineForProject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomSMEDisciplineForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomSMEDisciplineForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolViewModel>;
        }));
    }

    protected processUpdateCustomSMEDisciplineForProject(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCustomSMEDisciplineForProject(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/DeleteCustomSMEDisciplineForProject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomSMEDisciplineForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomSMEDisciplineForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteCustomSMEDisciplineForProject(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplinesWithCodesForPhase(phaseId: string): Observable<SMEDisciplineViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/SMEDiscipline/DisciplinesWithCodes/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinesWithCodesForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinesWithCodesForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplineViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplineViewModel[]>;
        }));
    }

    protected processGetSMEDisciplinesWithCodesForPhase(response: HttpResponseBase): Observable<SMEDisciplineViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplineViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StaffDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllStaffForPhase(phaseId: string): Observable<StaffViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Staff/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStaffForPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStaffForPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffViewModel[]>;
        }));
    }

    protected processGetAllStaffForPhase(response: HttpResponseBase): Observable<StaffViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StaffViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCustomStaffForProject(phaseId: string, viewModel: StaffViewModel): Observable<StaffViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Staff/CreateCustomStaffForProject/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomStaffForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomStaffForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffViewModel>;
        }));
    }

    protected processCreateCustomStaffForProject(response: HttpResponseBase): Observable<StaffViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(viewModel: StaffViewModel): Observable<StaffViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Staff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StaffViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<StaffViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/Staff";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StaffViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StaffViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePositionStaff(id: string, direction: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/Staff/ChangePositionStaff/{id}/{direction}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (direction === undefined || direction === null)
            throw new Error("The parameter 'direction' must be defined.");
        url_ = url_.replace("{direction}", encodeURIComponent("" + direction));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePositionStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePositionStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangePositionStaff(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCustomStaffForProject(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/Staff/DeleteCustomStaffForProject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomStaffForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomStaffForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteCustomStaffForProject(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<StaffViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Staff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<StaffViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TORDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getByPhaseId(phaseId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/TOR/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPhaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPhaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetByPhaseId(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkloadEstimateAdditionalCheckDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEstimatesForAdditionalChecksInPhase(phaseId: string): Observable<CheckWithWorkloadEstimatesViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimateAdditionalCheck/phase/{phaseId}/checks";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstimatesForAdditionalChecksInPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimatesForAdditionalChecksInPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckWithWorkloadEstimatesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckWithWorkloadEstimatesViewModel[]>;
        }));
    }

    protected processGetEstimatesForAdditionalChecksInPhase(response: HttpResponseBase): Observable<CheckWithWorkloadEstimatesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckWithWorkloadEstimatesViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPhaseEstimatesPerDiscipline(phaseId: string): Observable<WorkloadEstimateWithStatisticsAdditionalCheckViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimateAdditionalCheck/phase/{phaseId}/disciplines";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhaseEstimatesPerDiscipline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhaseEstimatesPerDiscipline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateWithStatisticsAdditionalCheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateWithStatisticsAdditionalCheckViewModel[]>;
        }));
    }

    protected processGetPhaseEstimatesPerDiscipline(response: HttpResponseBase): Observable<WorkloadEstimateWithStatisticsAdditionalCheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkloadEstimateWithStatisticsAdditionalCheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdateRange(changes: WorkloadEstimateChangeAdditionalCheckViewModel[]): Observable<WorkloadEstimateAdditionalCheckViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimateAdditionalCheck/createOrUpdateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateAdditionalCheckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateAdditionalCheckViewModel[]>;
        }));
    }

    protected processCreateOrUpdateRange(response: HttpResponseBase): Observable<WorkloadEstimateAdditionalCheckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkloadEstimateAdditionalCheckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdate(change: WorkloadEstimateChangeAdditionalCheckViewModel): Observable<WorkloadEstimateAdditionalCheckViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimateAdditionalCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(change);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateAdditionalCheckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateAdditionalCheckViewModel>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<WorkloadEstimateAdditionalCheckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkloadEstimateAdditionalCheckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkloadEstimateCarryOverObservationDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCarryOverObservationsWithEstimates(phaseId: string): Observable<CarryOverObservationWithEstimateViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimateCarryOverObservation/GetCarryOverObservationsWithEstimates/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarryOverObservationsWithEstimates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarryOverObservationsWithEstimates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarryOverObservationWithEstimateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarryOverObservationWithEstimateViewModel[]>;
        }));
    }

    protected processGetCarryOverObservationsWithEstimates(response: HttpResponseBase): Observable<CarryOverObservationWithEstimateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarryOverObservationWithEstimateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setEstimate(change: WorkloadEstimateChangeCarryOverObservationViewModel): Observable<WorkloadEstimateCarryOverObservationViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimateCarryOverObservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(change);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEstimate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEstimate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateCarryOverObservationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateCarryOverObservationViewModel>;
        }));
    }

    protected processSetEstimate(response: HttpResponseBase): Observable<WorkloadEstimateCarryOverObservationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkloadEstimateCarryOverObservationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkloadEstimateDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createOrUpdate(change: WorkloadEstimateChangeViewModel): Observable<WorkloadEstimateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(change);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateViewModel>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<WorkloadEstimateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkloadEstimateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(viewModel: WorkloadEstimateViewModel): Observable<WorkloadEstimateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WorkloadEstimateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkloadEstimateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<WorkloadEstimateViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WorkloadEstimateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkloadEstimateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdateRange(changes: WorkloadEstimateChangeViewModel[]): Observable<WorkloadEstimateViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate/createOrUpdateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateViewModel[]>;
        }));
    }

    protected processCreateOrUpdateRange(response: HttpResponseBase): Observable<WorkloadEstimateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkloadEstimateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEstimatesForDeliverablesInPhase(phaseId: string): Observable<DADeliverableWithWorkloadEstimatesViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate/phase/{phaseId}/deliverables";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstimatesForDeliverablesInPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimatesForDeliverablesInPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DADeliverableWithWorkloadEstimatesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DADeliverableWithWorkloadEstimatesViewModel[]>;
        }));
    }

    protected processGetEstimatesForDeliverablesInPhase(response: HttpResponseBase): Observable<DADeliverableWithWorkloadEstimatesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DADeliverableWithWorkloadEstimatesViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPhaseEstimatesPerDiscipline(phaseId: string): Observable<WorkloadEstimateWithStatisticsViewModel[]> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate/phase/{phaseId}/disciplines";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhaseEstimatesPerDiscipline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhaseEstimatesPerDiscipline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateWithStatisticsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateWithStatisticsViewModel[]>;
        }));
    }

    protected processGetPhaseEstimatesPerDiscipline(response: HttpResponseBase): Observable<WorkloadEstimateWithStatisticsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkloadEstimateWithStatisticsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalPhaseEstimates(phaseId: string): Observable<WorkplanEstimatesPlanViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate/phase/{phaseId}/workplanEstimatesPlan";
        if (phaseId === undefined || phaseId === null)
            throw new Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalPhaseEstimates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalPhaseEstimates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkplanEstimatesPlanViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkplanEstimatesPlanViewModel>;
        }));
    }

    protected processGetTotalPhaseEstimates(response: HttpResponseBase): Observable<WorkplanEstimatesPlanViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkplanEstimatesPlanViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, viewModel: WorkloadEstimateViewModel): Observable<WorkloadEstimateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WorkloadEstimateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkloadEstimateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<WorkloadEstimateViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/WorkloadEstimate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkloadEstimateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkloadEstimateViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<WorkloadEstimateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkloadEstimateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkplanDAEngineerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(newWorkplanViewModel: NewWorkplanViewModel): Observable<ProjectViewModel> {
        let url_ = this.baseUrl + "/DAEngineer/Workplan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newWorkplanViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FeatureToggleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getFeatureToggleConfig(role: string | undefined): Observable<FeatureToggleEntryViewModel[]> {
        let url_ = this.baseUrl + "/FeatureToggle?";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatureToggleConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatureToggleConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureToggleEntryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureToggleEntryViewModel[]>;
        }));
    }

    protected processGetFeatureToggleConfig(response: HttpResponseBase): Observable<FeatureToggleEntryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureToggleEntryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCurrentUserConfigOrDefault(): Observable<UserConfigViewModel> {
        let url_ = this.baseUrl + "/UserConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserConfigOrDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserConfigOrDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfigViewModel>;
        }));
    }

    protected processGetCurrentUserConfigOrDefault(response: HttpResponseBase): Observable<UserConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCurrentUserConfig(userConfig: UserConfigViewModel): Observable<UserConfigViewModel> {
        let url_ = this.baseUrl + "/UserConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfigViewModel>;
        }));
    }

    protected processUpdateCurrentUserConfig(response: HttpResponseBase): Observable<UserConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUserData(oid: string | undefined): Observable<UserDataViewModel> {
        let url_ = this.baseUrl + "/UserData?";
        if (oid === null)
            throw new Error("The parameter 'oid' cannot be null.");
        else if (oid !== undefined)
            url_ += "oid=" + encodeURIComponent("" + oid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDataViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDataViewModel>;
        }));
    }

    protected processGetUserData(response: HttpResponseBase): Observable<UserDataViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDataViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExceptionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getHasUserExceptionAccess(): Observable<boolean> {
        let url_ = this.baseUrl + "/Exceptions/hasUserExceptionAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHasUserExceptionAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHasUserExceptionAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetHasUserExceptionAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExceptions(): Observable<PeerPoolExceptionViewModel[]> {
        let url_ = this.baseUrl + "/Exceptions/exceptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeerPoolExceptionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeerPoolExceptionViewModel[]>;
        }));
    }

    protected processGetExceptions(response: HttpResponseBase): Observable<PeerPoolExceptionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeerPoolExceptionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncExceptions(exceptions: PeerPoolExceptionViewModel[]): Observable<PeerPoolExceptionViewModel[]> {
        let url_ = this.baseUrl + "/Exceptions/syncExceptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exceptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeerPoolExceptionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeerPoolExceptionViewModel[]>;
        }));
    }

    protected processSyncExceptions(response: HttpResponseBase): Observable<PeerPoolExceptionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeerPoolExceptionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GlobalAdminsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getHasUserGlobalAdminAccess(): Observable<boolean> {
        let url_ = this.baseUrl + "/GlobalAdmins/hasUserGlobalAdminAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHasUserGlobalAdminAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHasUserGlobalAdminAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetHasUserGlobalAdminAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGlobalAdmins(): Observable<GlobalAdminViewModel[]> {
        let url_ = this.baseUrl + "/GlobalAdmins/globalAdmins";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalAdmins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalAdminViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalAdminViewModel[]>;
        }));
    }

    protected processGetGlobalAdmins(response: HttpResponseBase): Observable<GlobalAdminViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalAdminViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncGlobalAdmins(globalAdmins: GlobalAdminViewModel[]): Observable<GlobalAdminViewModel[]> {
        let url_ = this.baseUrl + "/GlobalAdmins/syncGlobalAdmins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(globalAdmins);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncGlobalAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncGlobalAdmins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalAdminViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalAdminViewModel[]>;
        }));
    }

    protected processSyncGlobalAdmins(response: HttpResponseBase): Observable<GlobalAdminViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalAdminViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplicationVersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<ApplicationVersionViewModel> {
        let url_ = this.baseUrl + "/ApplicationVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationVersionViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SharePointPeerPoolChapterManagerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getApprovedPeerPoolUsers(): Observable<string[]> {
        let url_ = this.baseUrl + "/ChapterManager/SharePointPeerPool/GetApprovedPeerPoolUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedPeerPoolUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedPeerPoolUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetApprovedPeerPoolUsers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SMEDisciplineChapterManagerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSMEDisciplinesPeerPool(): Observable<SMEDisciplinePeerPoolWithProjectPhaseViewModel[]> {
        let url_ = this.baseUrl + "/ChapterManager/SMEDiscipline/PeerPoolForChapterManager";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinesPeerPool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinesPeerPool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseViewModel[]>;
        }));
    }

    protected processGetSMEDisciplinesPeerPool(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolWithProjectPhaseViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMEDisciplinePeerPoolWithProjectPhaseViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMEDisciplinePeerPool(disciplineId: string): Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel> {
        let url_ = this.baseUrl + "/ChapterManager/SMEDiscipline/PeerPoolForChapterManager/{disciplineId}";
        if (disciplineId === undefined || disciplineId === null)
            throw new Error("The parameter 'disciplineId' must be defined.");
        url_ = url_.replace("{disciplineId}", encodeURIComponent("" + disciplineId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMEDisciplinePeerPool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMEDisciplinePeerPool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel>;
        }));
    }

    protected processGetSMEDisciplinePeerPool(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acceptDiscipline(disciplineId: string, primarySme: string | undefined, secondarySme: string | undefined): Observable<SMEDisciplinePeerPoolViewModel> {
        let url_ = this.baseUrl + "/ChapterManager/SMEDiscipline/SMEDisciplinePeerPoolAccept/{disciplineId}?";
        if (disciplineId === undefined || disciplineId === null)
            throw new Error("The parameter 'disciplineId' must be defined.");
        url_ = url_.replace("{disciplineId}", encodeURIComponent("" + disciplineId));
        if (primarySme === null)
            throw new Error("The parameter 'primarySme' cannot be null.");
        else if (primarySme !== undefined)
            url_ += "primarySme=" + encodeURIComponent("" + primarySme) + "&";
        if (secondarySme === null)
            throw new Error("The parameter 'secondarySme' cannot be null.");
        else if (secondarySme !== undefined)
            url_ += "secondarySme=" + encodeURIComponent("" + secondarySme) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptDiscipline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptDiscipline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolViewModel>;
        }));
    }

    protected processAcceptDiscipline(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    returnDiscipline(disciplineId: string): Observable<SMEDisciplinePeerPoolViewModel> {
        let url_ = this.baseUrl + "/ChapterManager/SMEDiscipline/SMEDisciplinePeerPoolReturn/{disciplineId}";
        if (disciplineId === undefined || disciplineId === null)
            throw new Error("The parameter 'disciplineId' must be defined.");
        url_ = url_.replace("{disciplineId}", encodeURIComponent("" + disciplineId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnDiscipline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnDiscipline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolViewModel>;
        }));
    }

    protected processReturnDiscipline(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    chapterManagerChange(disciplineId: string, newChapterManager: string): Observable<SMEDisciplinePeerPoolViewModel> {
        let url_ = this.baseUrl + "/ChapterManager/SMEDiscipline/SMEDisciplineChapterManagerChange/{disciplineId}";
        if (disciplineId === undefined || disciplineId === null)
            throw new Error("The parameter 'disciplineId' must be defined.");
        url_ = url_.replace("{disciplineId}", encodeURIComponent("" + disciplineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newChapterManager);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChapterManagerChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChapterManagerChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMEDisciplinePeerPoolViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMEDisciplinePeerPoolViewModel>;
        }));
    }

    protected processChapterManagerChange(response: HttpResponseBase): Observable<SMEDisciplinePeerPoolViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMEDisciplinePeerPoolViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class DADeliverableBaseViewModel implements IDADeliverableBaseViewModel {
    id!: string;
    title?: string | undefined;
    definition?: string | undefined;
    deliverableDiscipline?: string | undefined;
    drsCode?: string | undefined;
    docType?: string | undefined;
    deliverableId?: string | undefined;
    daStage?: string | undefined;
    isAdHoc!: boolean;
    origin!: string;
    taggedFocusAreasCount!: number;
    anchorNumber?: string | undefined;

    constructor(data?: IDADeliverableBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.definition = _data["definition"];
            this.deliverableDiscipline = _data["deliverableDiscipline"];
            this.drsCode = _data["drsCode"];
            this.docType = _data["docType"];
            this.deliverableId = _data["deliverableId"];
            this.daStage = _data["daStage"];
            this.isAdHoc = _data["isAdHoc"];
            this.origin = _data["origin"];
            this.taggedFocusAreasCount = _data["taggedFocusAreasCount"];
            this.anchorNumber = _data["anchorNumber"];
        }
    }

    static fromJS(data: any): DADeliverableBaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableBaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["definition"] = this.definition;
        data["deliverableDiscipline"] = this.deliverableDiscipline;
        data["drsCode"] = this.drsCode;
        data["docType"] = this.docType;
        data["deliverableId"] = this.deliverableId;
        data["daStage"] = this.daStage;
        data["isAdHoc"] = this.isAdHoc;
        data["origin"] = this.origin;
        data["taggedFocusAreasCount"] = this.taggedFocusAreasCount;
        data["anchorNumber"] = this.anchorNumber;
        return data;
    }
}

export interface IDADeliverableBaseViewModel {
    id: string;
    title?: string | undefined;
    definition?: string | undefined;
    deliverableDiscipline?: string | undefined;
    drsCode?: string | undefined;
    docType?: string | undefined;
    deliverableId?: string | undefined;
    daStage?: string | undefined;
    isAdHoc: boolean;
    origin: string;
    taggedFocusAreasCount: number;
    anchorNumber?: string | undefined;
}

export class DADeliverableTemplateViewModel extends DADeliverableBaseViewModel implements IDADeliverableTemplateViewModel {
    onshore!: boolean;
    offshore!: boolean;
    projectPhaseId!: string;
    daDeliverablePhaseGuidelines!: DADeliverablePhaseGuidelineViewModel[];

    constructor(data?: IDADeliverableTemplateViewModel) {
        super(data);
        if (!data) {
            this.daDeliverablePhaseGuidelines = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.onshore = _data["onshore"];
            this.offshore = _data["offshore"];
            this.projectPhaseId = _data["projectPhaseId"];
            if (Array.isArray(_data["daDeliverablePhaseGuidelines"])) {
                this.daDeliverablePhaseGuidelines = [] as any;
                for (let item of _data["daDeliverablePhaseGuidelines"])
                    this.daDeliverablePhaseGuidelines!.push(DADeliverablePhaseGuidelineViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DADeliverableTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onshore"] = this.onshore;
        data["offshore"] = this.offshore;
        data["projectPhaseId"] = this.projectPhaseId;
        if (Array.isArray(this.daDeliverablePhaseGuidelines)) {
            data["daDeliverablePhaseGuidelines"] = [];
            for (let item of this.daDeliverablePhaseGuidelines)
                data["daDeliverablePhaseGuidelines"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDADeliverableTemplateViewModel extends IDADeliverableBaseViewModel {
    onshore: boolean;
    offshore: boolean;
    projectPhaseId: string;
    daDeliverablePhaseGuidelines: DADeliverablePhaseGuidelineViewModel[];
}

export class DADeliverableTemplateTableViewModel extends DADeliverableTemplateViewModel implements IDADeliverableTemplateTableViewModel {
    typicallyDASampled!: boolean;
    typicallyNOJVProvided!: boolean;
    deliverableCategory!: string;
    deliverableClassId!: string;
    daDeliverableTemplateId?: string | undefined;
    hasDeliverable!: boolean;
    hasMapping!: boolean;
    projectPhasesIds!: string;

    constructor(data?: IDADeliverableTemplateTableViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typicallyDASampled = _data["typicallyDASampled"];
            this.typicallyNOJVProvided = _data["typicallyNOJVProvided"];
            this.deliverableCategory = _data["deliverableCategory"];
            this.deliverableClassId = _data["deliverableClassId"];
            this.daDeliverableTemplateId = _data["daDeliverableTemplateId"];
            this.hasDeliverable = _data["hasDeliverable"];
            this.hasMapping = _data["hasMapping"];
            this.projectPhasesIds = _data["projectPhasesIds"];
        }
    }

    static fromJS(data: any): DADeliverableTemplateTableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableTemplateTableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typicallyDASampled"] = this.typicallyDASampled;
        data["typicallyNOJVProvided"] = this.typicallyNOJVProvided;
        data["deliverableCategory"] = this.deliverableCategory;
        data["deliverableClassId"] = this.deliverableClassId;
        data["daDeliverableTemplateId"] = this.daDeliverableTemplateId;
        data["hasDeliverable"] = this.hasDeliverable;
        data["hasMapping"] = this.hasMapping;
        data["projectPhasesIds"] = this.projectPhasesIds;
        super.toJSON(data);
        return data;
    }
}

export interface IDADeliverableTemplateTableViewModel extends IDADeliverableTemplateViewModel {
    typicallyDASampled: boolean;
    typicallyNOJVProvided: boolean;
    deliverableCategory: string;
    deliverableClassId: string;
    daDeliverableTemplateId?: string | undefined;
    hasDeliverable: boolean;
    hasMapping: boolean;
    projectPhasesIds: string;
}

export class DADeliverableDetailsViewModel extends DADeliverableTemplateTableViewModel implements IDADeliverableDetailsViewModel {
    projectDeliverables!: ProjectDeliverableViewModel[];
    daDeliverablesTagFocusAreas!: DADeliverableTagFocusAreaViewModel[];
    totalHours!: number;

    constructor(data?: IDADeliverableDetailsViewModel) {
        super(data);
        if (!data) {
            this.projectDeliverables = [];
            this.daDeliverablesTagFocusAreas = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["projectDeliverables"])) {
                this.projectDeliverables = [] as any;
                for (let item of _data["projectDeliverables"])
                    this.projectDeliverables!.push(ProjectDeliverableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["daDeliverablesTagFocusAreas"])) {
                this.daDeliverablesTagFocusAreas = [] as any;
                for (let item of _data["daDeliverablesTagFocusAreas"])
                    this.daDeliverablesTagFocusAreas!.push(DADeliverableTagFocusAreaViewModel.fromJS(item));
            }
            this.totalHours = _data["totalHours"];
        }
    }

    static fromJS(data: any): DADeliverableDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectDeliverables)) {
            data["projectDeliverables"] = [];
            for (let item of this.projectDeliverables)
                data["projectDeliverables"].push(item.toJSON());
        }
        if (Array.isArray(this.daDeliverablesTagFocusAreas)) {
            data["daDeliverablesTagFocusAreas"] = [];
            for (let item of this.daDeliverablesTagFocusAreas)
                data["daDeliverablesTagFocusAreas"].push(item.toJSON());
        }
        data["totalHours"] = this.totalHours;
        super.toJSON(data);
        return data;
    }
}

export interface IDADeliverableDetailsViewModel extends IDADeliverableTemplateTableViewModel {
    projectDeliverables: ProjectDeliverableViewModel[];
    daDeliverablesTagFocusAreas: DADeliverableTagFocusAreaViewModel[];
    totalHours: number;
}

export class ProjectDeliverableBaseViewModel implements IProjectDeliverableBaseViewModel {
    id!: string;
    name!: string;
    type?: string | undefined;
    discipline!: string;
    projectPhaseId!: string;
    projectPhase?: ProjectPhaseViewModel | undefined;

    constructor(data?: IProjectDeliverableBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.discipline = _data["discipline"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseViewModel.fromJS(_data["projectPhase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectDeliverableBaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableBaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["discipline"] = this.discipline;
        data["projectPhaseId"] = this.projectPhaseId;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectDeliverableBaseViewModel {
    id: string;
    name: string;
    type?: string | undefined;
    discipline: string;
    projectPhaseId: string;
    projectPhase?: ProjectPhaseViewModel | undefined;
}

export class ProjectDeliverableViewModel extends ProjectDeliverableBaseViewModel implements IProjectDeliverableViewModel {
    createdBy!: string;
    createdAt!: string;
    updatedBy!: string;
    updatedAt!: string;
    documentNumbers?: string[] | undefined;
    anchorNumber?: number | undefined;
    contractor?: string | undefined;
    isCarryOver!: boolean;
    hasObservationToolDocumentLoaded!: boolean;
    isSSR!: boolean;

    constructor(data?: IProjectDeliverableViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"];
            if (Array.isArray(_data["documentNumbers"])) {
                this.documentNumbers = [] as any;
                for (let item of _data["documentNumbers"])
                    this.documentNumbers!.push(item);
            }
            this.anchorNumber = _data["anchorNumber"];
            this.contractor = _data["contractor"];
            this.isCarryOver = _data["isCarryOver"];
            this.hasObservationToolDocumentLoaded = _data["hasObservationToolDocumentLoaded"];
            this.isSSR = _data["isSSR"];
        }
    }

    static fromJS(data: any): ProjectDeliverableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt;
        if (Array.isArray(this.documentNumbers)) {
            data["documentNumbers"] = [];
            for (let item of this.documentNumbers)
                data["documentNumbers"].push(item);
        }
        data["anchorNumber"] = this.anchorNumber;
        data["contractor"] = this.contractor;
        data["isCarryOver"] = this.isCarryOver;
        data["hasObservationToolDocumentLoaded"] = this.hasObservationToolDocumentLoaded;
        data["isSSR"] = this.isSSR;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectDeliverableViewModel extends IProjectDeliverableBaseViewModel {
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    documentNumbers?: string[] | undefined;
    anchorNumber?: number | undefined;
    contractor?: string | undefined;
    isCarryOver: boolean;
    hasObservationToolDocumentLoaded: boolean;
    isSSR: boolean;
}

export class ProjectPhaseViewModel implements IProjectPhaseViewModel {
    id!: string;
    phaseId?: string | undefined;
    projectId!: string;
    plannedStartDate?: string | undefined;
    plannedCompletionDate?: string | undefined;
    workplanStatus?: string | undefined;
    phaseClosedDate?: string | undefined;
    daLead?: string | undefined;
    daSupports?: string[] | undefined;
    daManager?: string | undefined;
    projectContacts?: string[] | undefined;
    createdBy!: string;
    createdAt!: string;
    updatedBy!: string;
    updatedAt!: string;
    themes?: string[] | undefined;
    leadBy!: string;
    billingRateUSD!: number;
    daTime!: number;
    ipimsDomain?: string | undefined;
    isReadOnly!: boolean;
    smeMargin!: number;
    readinessCheckId?: string | undefined;
    readinessCheck?: ReadinessCheckViewModel | undefined;
    valueRecognitionNotes?: string | undefined;
    engagementDate?: string | undefined;
    engagementType?: string | undefined;
    lastWorkplanSharedDate?: string | undefined;

    constructor(data?: IProjectPhaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phaseId = _data["phaseId"];
            this.projectId = _data["projectId"];
            this.plannedStartDate = _data["plannedStartDate"];
            this.plannedCompletionDate = _data["plannedCompletionDate"];
            this.workplanStatus = _data["workplanStatus"];
            this.phaseClosedDate = _data["phaseClosedDate"];
            this.daLead = _data["daLead"];
            if (Array.isArray(_data["daSupports"])) {
                this.daSupports = [] as any;
                for (let item of _data["daSupports"])
                    this.daSupports!.push(item);
            }
            this.daManager = _data["daManager"];
            if (Array.isArray(_data["projectContacts"])) {
                this.projectContacts = [] as any;
                for (let item of _data["projectContacts"])
                    this.projectContacts!.push(item);
            }
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"];
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(item);
            }
            this.leadBy = _data["leadBy"];
            this.billingRateUSD = _data["billingRateUSD"];
            this.daTime = _data["daTime"];
            this.ipimsDomain = _data["ipimsDomain"];
            this.isReadOnly = _data["isReadOnly"];
            this.smeMargin = _data["smeMargin"];
            this.readinessCheckId = _data["readinessCheckId"];
            this.readinessCheck = _data["readinessCheck"] ? ReadinessCheckViewModel.fromJS(_data["readinessCheck"]) : <any>undefined;
            this.valueRecognitionNotes = _data["valueRecognitionNotes"];
            this.engagementDate = _data["engagementDate"];
            this.engagementType = _data["engagementType"];
            this.lastWorkplanSharedDate = _data["lastWorkplanSharedDate"];
        }
    }

    static fromJS(data: any): ProjectPhaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPhaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phaseId"] = this.phaseId;
        data["projectId"] = this.projectId;
        data["plannedStartDate"] = this.plannedStartDate;
        data["plannedCompletionDate"] = this.plannedCompletionDate;
        data["workplanStatus"] = this.workplanStatus;
        data["phaseClosedDate"] = this.phaseClosedDate;
        data["daLead"] = this.daLead;
        if (Array.isArray(this.daSupports)) {
            data["daSupports"] = [];
            for (let item of this.daSupports)
                data["daSupports"].push(item);
        }
        data["daManager"] = this.daManager;
        if (Array.isArray(this.projectContacts)) {
            data["projectContacts"] = [];
            for (let item of this.projectContacts)
                data["projectContacts"].push(item);
        }
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item);
        }
        data["leadBy"] = this.leadBy;
        data["billingRateUSD"] = this.billingRateUSD;
        data["daTime"] = this.daTime;
        data["ipimsDomain"] = this.ipimsDomain;
        data["isReadOnly"] = this.isReadOnly;
        data["smeMargin"] = this.smeMargin;
        data["readinessCheckId"] = this.readinessCheckId;
        data["readinessCheck"] = this.readinessCheck ? this.readinessCheck.toJSON() : <any>undefined;
        data["valueRecognitionNotes"] = this.valueRecognitionNotes;
        data["engagementDate"] = this.engagementDate;
        data["engagementType"] = this.engagementType;
        data["lastWorkplanSharedDate"] = this.lastWorkplanSharedDate;
        return data;
    }
}

export interface IProjectPhaseViewModel {
    id: string;
    phaseId?: string | undefined;
    projectId: string;
    plannedStartDate?: string | undefined;
    plannedCompletionDate?: string | undefined;
    workplanStatus?: string | undefined;
    phaseClosedDate?: string | undefined;
    daLead?: string | undefined;
    daSupports?: string[] | undefined;
    daManager?: string | undefined;
    projectContacts?: string[] | undefined;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    themes?: string[] | undefined;
    leadBy: string;
    billingRateUSD: number;
    daTime: number;
    ipimsDomain?: string | undefined;
    isReadOnly: boolean;
    smeMargin: number;
    readinessCheckId?: string | undefined;
    readinessCheck?: ReadinessCheckViewModel | undefined;
    valueRecognitionNotes?: string | undefined;
    engagementDate?: string | undefined;
    engagementType?: string | undefined;
    lastWorkplanSharedDate?: string | undefined;
}

export class ObservationToolMetricsReadinessCheckViewModel implements IObservationToolMetricsReadinessCheckViewModel {
    deliverables?: ObservationToolMetricsReadinessCheckItemsViewModel | undefined;
    observations?: ObservationToolMetricsReadinessCheckItemsViewModel | undefined;
    checks?: ObservationToolMetricsReadinessCheckItemsViewModel | undefined;

    constructor(data?: IObservationToolMetricsReadinessCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliverables = _data["deliverables"] ? ObservationToolMetricsReadinessCheckItemsViewModel.fromJS(_data["deliverables"]) : <any>undefined;
            this.observations = _data["observations"] ? ObservationToolMetricsReadinessCheckItemsViewModel.fromJS(_data["observations"]) : <any>undefined;
            this.checks = _data["checks"] ? ObservationToolMetricsReadinessCheckItemsViewModel.fromJS(_data["checks"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ObservationToolMetricsReadinessCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsReadinessCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliverables"] = this.deliverables ? this.deliverables.toJSON() : <any>undefined;
        data["observations"] = this.observations ? this.observations.toJSON() : <any>undefined;
        data["checks"] = this.checks ? this.checks.toJSON() : <any>undefined;
        return data;
    }
}

export interface IObservationToolMetricsReadinessCheckViewModel {
    deliverables?: ObservationToolMetricsReadinessCheckItemsViewModel | undefined;
    observations?: ObservationToolMetricsReadinessCheckItemsViewModel | undefined;
    checks?: ObservationToolMetricsReadinessCheckItemsViewModel | undefined;
}

export class ReadinessCheckViewModel extends ObservationToolMetricsReadinessCheckViewModel implements IReadinessCheckViewModel {
    id?: string | undefined;
    phaseId?: string | undefined;
    metricsForDeliverables?: ObservationToolMetricsDeliverablesViewModel | undefined;
    metricsForObservations?: ObservationToolObservationViewModel | undefined;
    metricsForAdditionalChecks?: ObservationToolCheckViewModel | undefined;
    summaryAssessment?: string | undefined;
    risksToProceed?: string | undefined;
    reviewResults?: string | undefined;
    completed!: boolean;
    completedDate?: string | undefined;
    observationToolWithDisciplinesReviewDAOverridden!: ObservationToolDashboardViewModel[];

    constructor(data?: IReadinessCheckViewModel) {
        super(data);
        if (!data) {
            this.observationToolWithDisciplinesReviewDAOverridden = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.phaseId = _data["phaseId"];
            this.metricsForDeliverables = _data["metricsForDeliverables"] ? ObservationToolMetricsDeliverablesViewModel.fromJS(_data["metricsForDeliverables"]) : <any>undefined;
            this.metricsForObservations = _data["metricsForObservations"] ? ObservationToolObservationViewModel.fromJS(_data["metricsForObservations"]) : <any>undefined;
            this.metricsForAdditionalChecks = _data["metricsForAdditionalChecks"] ? ObservationToolCheckViewModel.fromJS(_data["metricsForAdditionalChecks"]) : <any>undefined;
            this.summaryAssessment = _data["summaryAssessment"];
            this.risksToProceed = _data["risksToProceed"];
            this.reviewResults = _data["reviewResults"];
            this.completed = _data["completed"];
            this.completedDate = _data["completedDate"];
            if (Array.isArray(_data["observationToolWithDisciplinesReviewDAOverridden"])) {
                this.observationToolWithDisciplinesReviewDAOverridden = [] as any;
                for (let item of _data["observationToolWithDisciplinesReviewDAOverridden"])
                    this.observationToolWithDisciplinesReviewDAOverridden!.push(ObservationToolDashboardViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReadinessCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadinessCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phaseId"] = this.phaseId;
        data["metricsForDeliverables"] = this.metricsForDeliverables ? this.metricsForDeliverables.toJSON() : <any>undefined;
        data["metricsForObservations"] = this.metricsForObservations ? this.metricsForObservations.toJSON() : <any>undefined;
        data["metricsForAdditionalChecks"] = this.metricsForAdditionalChecks ? this.metricsForAdditionalChecks.toJSON() : <any>undefined;
        data["summaryAssessment"] = this.summaryAssessment;
        data["risksToProceed"] = this.risksToProceed;
        data["reviewResults"] = this.reviewResults;
        data["completed"] = this.completed;
        data["completedDate"] = this.completedDate;
        if (Array.isArray(this.observationToolWithDisciplinesReviewDAOverridden)) {
            data["observationToolWithDisciplinesReviewDAOverridden"] = [];
            for (let item of this.observationToolWithDisciplinesReviewDAOverridden)
                data["observationToolWithDisciplinesReviewDAOverridden"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IReadinessCheckViewModel extends IObservationToolMetricsReadinessCheckViewModel {
    id?: string | undefined;
    phaseId?: string | undefined;
    metricsForDeliverables?: ObservationToolMetricsDeliverablesViewModel | undefined;
    metricsForObservations?: ObservationToolObservationViewModel | undefined;
    metricsForAdditionalChecks?: ObservationToolCheckViewModel | undefined;
    summaryAssessment?: string | undefined;
    risksToProceed?: string | undefined;
    reviewResults?: string | undefined;
    completed: boolean;
    completedDate?: string | undefined;
    observationToolWithDisciplinesReviewDAOverridden: ObservationToolDashboardViewModel[];
}

export class ObservationToolMetricsDeliverablesViewModel implements IObservationToolMetricsDeliverablesViewModel {
    pendingDeliverablesAssigned!: number;
    underReview!: number;
    underReviewDisciplines!: ObservationToolMetricsDeliverablesDisciplineTotalViewModel[];
    reviewComplete!: number;
    reviewCompleteDisciplines!: ObservationToolMetricsDeliverablesDisciplineTotalViewModel[];

    constructor(data?: IObservationToolMetricsDeliverablesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.underReviewDisciplines = [];
            this.reviewCompleteDisciplines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingDeliverablesAssigned = _data["pendingDeliverablesAssigned"];
            this.underReview = _data["underReview"];
            if (Array.isArray(_data["underReviewDisciplines"])) {
                this.underReviewDisciplines = [] as any;
                for (let item of _data["underReviewDisciplines"])
                    this.underReviewDisciplines!.push(ObservationToolMetricsDeliverablesDisciplineTotalViewModel.fromJS(item));
            }
            this.reviewComplete = _data["reviewComplete"];
            if (Array.isArray(_data["reviewCompleteDisciplines"])) {
                this.reviewCompleteDisciplines = [] as any;
                for (let item of _data["reviewCompleteDisciplines"])
                    this.reviewCompleteDisciplines!.push(ObservationToolMetricsDeliverablesDisciplineTotalViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObservationToolMetricsDeliverablesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsDeliverablesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingDeliverablesAssigned"] = this.pendingDeliverablesAssigned;
        data["underReview"] = this.underReview;
        if (Array.isArray(this.underReviewDisciplines)) {
            data["underReviewDisciplines"] = [];
            for (let item of this.underReviewDisciplines)
                data["underReviewDisciplines"].push(item.toJSON());
        }
        data["reviewComplete"] = this.reviewComplete;
        if (Array.isArray(this.reviewCompleteDisciplines)) {
            data["reviewCompleteDisciplines"] = [];
            for (let item of this.reviewCompleteDisciplines)
                data["reviewCompleteDisciplines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObservationToolMetricsDeliverablesViewModel {
    pendingDeliverablesAssigned: number;
    underReview: number;
    underReviewDisciplines: ObservationToolMetricsDeliverablesDisciplineTotalViewModel[];
    reviewComplete: number;
    reviewCompleteDisciplines: ObservationToolMetricsDeliverablesDisciplineTotalViewModel[];
}

export class ObservationToolMetricsDeliverablesDisciplineTotalViewModel implements IObservationToolMetricsDeliverablesDisciplineTotalViewModel {
    smeDiscipline!: SMEDisciplineInObservationViewModel;
    isReviewDAOverridden!: boolean;
    total!: number;
    longestStandingInReview!: string;
    documents!: ObservationToolDocumentViewModel[];
    pendingDocuments!: number;

    constructor(data?: IObservationToolMetricsDeliverablesDisciplineTotalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.smeDiscipline = new SMEDisciplineInObservationViewModel();
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineInObservationViewModel.fromJS(_data["smeDiscipline"]) : new SMEDisciplineInObservationViewModel();
            this.isReviewDAOverridden = _data["isReviewDAOverridden"];
            this.total = _data["total"];
            this.longestStandingInReview = _data["longestStandingInReview"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            this.pendingDocuments = _data["pendingDocuments"];
        }
    }

    static fromJS(data: any): ObservationToolMetricsDeliverablesDisciplineTotalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsDeliverablesDisciplineTotalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        data["isReviewDAOverridden"] = this.isReviewDAOverridden;
        data["total"] = this.total;
        data["longestStandingInReview"] = this.longestStandingInReview;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["pendingDocuments"] = this.pendingDocuments;
        return data;
    }
}

export interface IObservationToolMetricsDeliverablesDisciplineTotalViewModel {
    smeDiscipline: SMEDisciplineInObservationViewModel;
    isReviewDAOverridden: boolean;
    total: number;
    longestStandingInReview: string;
    documents: ObservationToolDocumentViewModel[];
    pendingDocuments: number;
}

export class SMEDisciplineInObservationViewModel implements ISMEDisciplineInObservationViewModel {
    id!: string;
    name!: string;
    description?: string | undefined;
    disciplineCode!: string;
    isAssignedToCurrentUser!: boolean;
    assignments!: SMEDisciplineAssignmentPeerPoolViewModel[];
    bookmarked!: boolean;

    constructor(data?: ISMEDisciplineInObservationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.disciplineCode = _data["disciplineCode"];
            this.isAssignedToCurrentUser = _data["isAssignedToCurrentUser"];
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(SMEDisciplineAssignmentPeerPoolViewModel.fromJS(item));
            }
            this.bookmarked = _data["bookmarked"];
        }
    }

    static fromJS(data: any): SMEDisciplineInObservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplineInObservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["disciplineCode"] = this.disciplineCode;
        data["isAssignedToCurrentUser"] = this.isAssignedToCurrentUser;
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        data["bookmarked"] = this.bookmarked;
        return data;
    }
}

export interface ISMEDisciplineInObservationViewModel {
    id: string;
    name: string;
    description?: string | undefined;
    disciplineCode: string;
    isAssignedToCurrentUser: boolean;
    assignments: SMEDisciplineAssignmentPeerPoolViewModel[];
    bookmarked: boolean;
}

export class SMEDisciplineAssignmentPeerPoolViewModel implements ISMEDisciplineAssignmentPeerPoolViewModel {
    id!: string;
    userId!: string;
    label!: string;
    userName?: string | undefined;

    constructor(data?: ISMEDisciplineAssignmentPeerPoolViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.label = _data["label"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): SMEDisciplineAssignmentPeerPoolViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplineAssignmentPeerPoolViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["label"] = this.label;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ISMEDisciplineAssignmentPeerPoolViewModel {
    id: string;
    userId: string;
    label: string;
    userName?: string | undefined;
}

export abstract class ObservationToolDocumentBaseViewModel implements IObservationToolDocumentBaseViewModel {
    title!: string;
    url!: string;

    constructor(data?: IObservationToolDocumentBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ObservationToolDocumentBaseViewModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ObservationToolDocumentBaseViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        return data;
    }
}

export interface IObservationToolDocumentBaseViewModel {
    title: string;
    url: string;
}

export class ObservationToolDocumentViewModel extends ObservationToolDocumentBaseViewModel implements IObservationToolDocumentViewModel {
    id!: string;
    observationToolId!: string;
    documentID?: string | undefined;
    documentControlSystemType!: string;
    documentControlSystemId!: string;
    nickname?: string | undefined;
    discipline?: string | undefined;
    isAssigned!: boolean;
    isNotifiedDAToAssignDocuments!: boolean;
    isNew!: boolean;
    createdBy!: string;
    createdByRole!: string;
    issue?: string | undefined;
    currentRevision?: string | undefined;
    dateAssigned?: string | undefined;
    isDeleted!: boolean;
    smeRequiredReviewDocuments!: SMEDocumentsRequiredViewModel[];
    smeReviewedDocuments!: SMEDocumentsReviewedViewModel[];
    smeBookmarkedDocuments!: SMEDocumentsBookmarkedViewModel[];

    constructor(data?: IObservationToolDocumentViewModel) {
        super(data);
        if (!data) {
            this.smeRequiredReviewDocuments = [];
            this.smeReviewedDocuments = [];
            this.smeBookmarkedDocuments = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.documentID = _data["documentID"];
            this.documentControlSystemType = _data["documentControlSystemType"];
            this.documentControlSystemId = _data["documentControlSystemId"];
            this.nickname = _data["nickname"];
            this.discipline = _data["discipline"];
            this.isAssigned = _data["isAssigned"];
            this.isNotifiedDAToAssignDocuments = _data["isNotifiedDAToAssignDocuments"];
            this.isNew = _data["isNew"];
            this.createdBy = _data["createdBy"];
            this.createdByRole = _data["createdByRole"];
            this.issue = _data["issue"];
            this.currentRevision = _data["currentRevision"];
            this.dateAssigned = _data["dateAssigned"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["smeRequiredReviewDocuments"])) {
                this.smeRequiredReviewDocuments = [] as any;
                for (let item of _data["smeRequiredReviewDocuments"])
                    this.smeRequiredReviewDocuments!.push(SMEDocumentsRequiredViewModel.fromJS(item));
            }
            if (Array.isArray(_data["smeReviewedDocuments"])) {
                this.smeReviewedDocuments = [] as any;
                for (let item of _data["smeReviewedDocuments"])
                    this.smeReviewedDocuments!.push(SMEDocumentsReviewedViewModel.fromJS(item));
            }
            if (Array.isArray(_data["smeBookmarkedDocuments"])) {
                this.smeBookmarkedDocuments = [] as any;
                for (let item of _data["smeBookmarkedDocuments"])
                    this.smeBookmarkedDocuments!.push(SMEDocumentsBookmarkedViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObservationToolDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["documentID"] = this.documentID;
        data["documentControlSystemType"] = this.documentControlSystemType;
        data["documentControlSystemId"] = this.documentControlSystemId;
        data["nickname"] = this.nickname;
        data["discipline"] = this.discipline;
        data["isAssigned"] = this.isAssigned;
        data["isNotifiedDAToAssignDocuments"] = this.isNotifiedDAToAssignDocuments;
        data["isNew"] = this.isNew;
        data["createdBy"] = this.createdBy;
        data["createdByRole"] = this.createdByRole;
        data["issue"] = this.issue;
        data["currentRevision"] = this.currentRevision;
        data["dateAssigned"] = this.dateAssigned;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.smeRequiredReviewDocuments)) {
            data["smeRequiredReviewDocuments"] = [];
            for (let item of this.smeRequiredReviewDocuments)
                data["smeRequiredReviewDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.smeReviewedDocuments)) {
            data["smeReviewedDocuments"] = [];
            for (let item of this.smeReviewedDocuments)
                data["smeReviewedDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.smeBookmarkedDocuments)) {
            data["smeBookmarkedDocuments"] = [];
            for (let item of this.smeBookmarkedDocuments)
                data["smeBookmarkedDocuments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolDocumentViewModel extends IObservationToolDocumentBaseViewModel {
    id: string;
    observationToolId: string;
    documentID?: string | undefined;
    documentControlSystemType: string;
    documentControlSystemId: string;
    nickname?: string | undefined;
    discipline?: string | undefined;
    isAssigned: boolean;
    isNotifiedDAToAssignDocuments: boolean;
    isNew: boolean;
    createdBy: string;
    createdByRole: string;
    issue?: string | undefined;
    currentRevision?: string | undefined;
    dateAssigned?: string | undefined;
    isDeleted: boolean;
    smeRequiredReviewDocuments: SMEDocumentsRequiredViewModel[];
    smeReviewedDocuments: SMEDocumentsReviewedViewModel[];
    smeBookmarkedDocuments: SMEDocumentsBookmarkedViewModel[];
}

export class SMEDocumentsRequiredViewModel implements ISMEDocumentsRequiredViewModel {
    id!: string;
    observationToolId!: string;
    disciplineId!: string;
    documentId!: string;

    constructor(data?: ISMEDocumentsRequiredViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.disciplineId = _data["disciplineId"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): SMEDocumentsRequiredViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDocumentsRequiredViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["disciplineId"] = this.disciplineId;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ISMEDocumentsRequiredViewModel {
    id: string;
    observationToolId: string;
    disciplineId: string;
    documentId: string;
}

export class SMEDocumentsReviewedViewModel implements ISMEDocumentsReviewedViewModel {
    id!: string;
    observationToolId!: string;
    disciplineId!: string;
    documentId!: string;

    constructor(data?: ISMEDocumentsReviewedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.disciplineId = _data["disciplineId"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): SMEDocumentsReviewedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDocumentsReviewedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["disciplineId"] = this.disciplineId;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ISMEDocumentsReviewedViewModel {
    id: string;
    observationToolId: string;
    disciplineId: string;
    documentId: string;
}

export class SMEDocumentsBookmarkedViewModel implements ISMEDocumentsBookmarkedViewModel {
    id?: string | undefined;
    observationToolId!: string;
    disciplineId!: string;
    documentId!: string;

    constructor(data?: ISMEDocumentsBookmarkedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.disciplineId = _data["disciplineId"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): SMEDocumentsBookmarkedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDocumentsBookmarkedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["disciplineId"] = this.disciplineId;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ISMEDocumentsBookmarkedViewModel {
    id?: string | undefined;
    observationToolId: string;
    disciplineId: string;
    documentId: string;
}

export abstract class ObservationToolObservationSaveBaseViewModel implements IObservationToolObservationSaveBaseViewModel {
    observationNumber?: number | undefined;
    documentId?: string | undefined;
    document?: ObservationToolDocumentViewModel | undefined;
    observationToolCheckId?: string | undefined;
    observationToolCheck?: ObservationToolCheckViewModel | undefined;
    madeOnRevision?: string | undefined;
    smeDisciplineId!: string;
    smeDiscipline?: SMEDisciplineViewModel | undefined;
    title?: string | undefined;
    respondingToId!: string;
    equipmentNumber?: string | undefined;
    areaSelections?: string | undefined;
    observation?: string | undefined;
    concern?: string | undefined;
    recommendation?: string | undefined;
    daCategory?: string | undefined;
    urgency?: string | undefined;
    timeFrameToAddress?: string | undefined;
    inherentVulnerability?: string | undefined;
    cesImpact!: boolean;
    cesDescription?: string | undefined;
    potentialImpactOnOtherDisciplines?: string[] | undefined;
    potentialImpactOnOtherDisciplinesDescription?: string | undefined;
    orr!: boolean;
    psri!: boolean;
    vAndV!: boolean;
    priority?: string | undefined;
    aiSuggestedUrgency?: string | undefined;
    aiSuggestedPriority?: string | undefined;
    aiSuggestedInherentVulnerability?: string | undefined;
    smeSelectedUrgency?: string | undefined;
    smeSelectedPriority?: string | undefined;
    smeSelectedInherentVulnerability?: string | undefined;
    daComments?: string | undefined;
    isDAObservation!: boolean;

    constructor(data?: IObservationToolObservationSaveBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationNumber = _data["observationNumber"];
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? ObservationToolDocumentViewModel.fromJS(_data["document"]) : <any>undefined;
            this.observationToolCheckId = _data["observationToolCheckId"];
            this.observationToolCheck = _data["observationToolCheck"] ? ObservationToolCheckViewModel.fromJS(_data["observationToolCheck"]) : <any>undefined;
            this.madeOnRevision = _data["madeOnRevision"];
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : <any>undefined;
            this.title = _data["title"];
            this.respondingToId = _data["respondingToId"];
            this.equipmentNumber = _data["equipmentNumber"];
            this.areaSelections = _data["areaSelections"];
            this.observation = _data["observation"];
            this.concern = _data["concern"];
            this.recommendation = _data["recommendation"];
            this.daCategory = _data["daCategory"];
            this.urgency = _data["urgency"];
            this.timeFrameToAddress = _data["timeFrameToAddress"];
            this.inherentVulnerability = _data["inherentVulnerability"];
            this.cesImpact = _data["cesImpact"];
            this.cesDescription = _data["cesDescription"];
            if (Array.isArray(_data["potentialImpactOnOtherDisciplines"])) {
                this.potentialImpactOnOtherDisciplines = [] as any;
                for (let item of _data["potentialImpactOnOtherDisciplines"])
                    this.potentialImpactOnOtherDisciplines!.push(item);
            }
            this.potentialImpactOnOtherDisciplinesDescription = _data["potentialImpactOnOtherDisciplinesDescription"];
            this.orr = _data["orr"];
            this.psri = _data["psri"];
            this.vAndV = _data["vAndV"];
            this.priority = _data["priority"];
            this.aiSuggestedUrgency = _data["aiSuggestedUrgency"];
            this.aiSuggestedPriority = _data["aiSuggestedPriority"];
            this.aiSuggestedInherentVulnerability = _data["aiSuggestedInherentVulnerability"];
            this.smeSelectedUrgency = _data["smeSelectedUrgency"];
            this.smeSelectedPriority = _data["smeSelectedPriority"];
            this.smeSelectedInherentVulnerability = _data["smeSelectedInherentVulnerability"];
            this.daComments = _data["daComments"];
            this.isDAObservation = _data["isDAObservation"];
        }
    }

    static fromJS(data: any): ObservationToolObservationSaveBaseViewModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ObservationToolObservationSaveBaseViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationNumber"] = this.observationNumber;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["observationToolCheckId"] = this.observationToolCheckId;
        data["observationToolCheck"] = this.observationToolCheck ? this.observationToolCheck.toJSON() : <any>undefined;
        data["madeOnRevision"] = this.madeOnRevision;
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["respondingToId"] = this.respondingToId;
        data["equipmentNumber"] = this.equipmentNumber;
        data["areaSelections"] = this.areaSelections;
        data["observation"] = this.observation;
        data["concern"] = this.concern;
        data["recommendation"] = this.recommendation;
        data["daCategory"] = this.daCategory;
        data["urgency"] = this.urgency;
        data["timeFrameToAddress"] = this.timeFrameToAddress;
        data["inherentVulnerability"] = this.inherentVulnerability;
        data["cesImpact"] = this.cesImpact;
        data["cesDescription"] = this.cesDescription;
        if (Array.isArray(this.potentialImpactOnOtherDisciplines)) {
            data["potentialImpactOnOtherDisciplines"] = [];
            for (let item of this.potentialImpactOnOtherDisciplines)
                data["potentialImpactOnOtherDisciplines"].push(item);
        }
        data["potentialImpactOnOtherDisciplinesDescription"] = this.potentialImpactOnOtherDisciplinesDescription;
        data["orr"] = this.orr;
        data["psri"] = this.psri;
        data["vAndV"] = this.vAndV;
        data["priority"] = this.priority;
        data["aiSuggestedUrgency"] = this.aiSuggestedUrgency;
        data["aiSuggestedPriority"] = this.aiSuggestedPriority;
        data["aiSuggestedInherentVulnerability"] = this.aiSuggestedInherentVulnerability;
        data["smeSelectedUrgency"] = this.smeSelectedUrgency;
        data["smeSelectedPriority"] = this.smeSelectedPriority;
        data["smeSelectedInherentVulnerability"] = this.smeSelectedInherentVulnerability;
        data["daComments"] = this.daComments;
        data["isDAObservation"] = this.isDAObservation;
        return data;
    }
}

export interface IObservationToolObservationSaveBaseViewModel {
    observationNumber?: number | undefined;
    documentId?: string | undefined;
    document?: ObservationToolDocumentViewModel | undefined;
    observationToolCheckId?: string | undefined;
    observationToolCheck?: ObservationToolCheckViewModel | undefined;
    madeOnRevision?: string | undefined;
    smeDisciplineId: string;
    smeDiscipline?: SMEDisciplineViewModel | undefined;
    title?: string | undefined;
    respondingToId: string;
    equipmentNumber?: string | undefined;
    areaSelections?: string | undefined;
    observation?: string | undefined;
    concern?: string | undefined;
    recommendation?: string | undefined;
    daCategory?: string | undefined;
    urgency?: string | undefined;
    timeFrameToAddress?: string | undefined;
    inherentVulnerability?: string | undefined;
    cesImpact: boolean;
    cesDescription?: string | undefined;
    potentialImpactOnOtherDisciplines?: string[] | undefined;
    potentialImpactOnOtherDisciplinesDescription?: string | undefined;
    orr: boolean;
    psri: boolean;
    vAndV: boolean;
    priority?: string | undefined;
    aiSuggestedUrgency?: string | undefined;
    aiSuggestedPriority?: string | undefined;
    aiSuggestedInherentVulnerability?: string | undefined;
    smeSelectedUrgency?: string | undefined;
    smeSelectedPriority?: string | undefined;
    smeSelectedInherentVulnerability?: string | undefined;
    daComments?: string | undefined;
    isDAObservation: boolean;
}

export class ObservationToolObservationViewModel extends ObservationToolObservationSaveBaseViewModel implements IObservationToolObservationViewModel {
    id!: string;
    createdBy?: string | undefined;
    createdAt!: string;
    updatedBy!: string;
    updatedAt!: string;
    observationToolId?: string | undefined;
    observationToolCheckId?: string | undefined;
    observationTool?: ObservationToolViewModel | undefined;
    observationToolCheck?: ObservationToolCheckViewModel | undefined;
    status!: string;
    standing?: string | undefined;
    finalObservation?: string | undefined;
    finalConcern?: string | undefined;
    finalRecommendation?: string | undefined;
    actionItem?: string | undefined;
    nextActionWith?: string | undefined;
    isNextActionWithYou!: boolean;
    isDismissed!: boolean;
    isDismissedJustified!: boolean;
    isReturned!: boolean;
    returnsCount!: number;
    vAndVCompleted!: boolean;
    vAndVReady!: boolean;
    vAndV!: boolean;
    observationToolObservationMessages!: ObservationToolObservationMessageViewModel[];
    observationToolObservationNawMessage!: ObservationToolObservationNawMessageViewModel[];
    unreadMessagesCount!: number;
    observationToolObservationDocumentRevisions!: ObservationToolObservationDocumentRevisionViewModel[];
    observationToolObservationAttachments!: ObservationToolObservationAttachmentViewModel[];
    p3ActionCompleted!: boolean;
    p3ActionCompletedDescription?: string | undefined;
    isAssignedToCurrentUser!: boolean;
    observationToolObservationCarryOvers!: ObservationToolObservationCarryOverViewModel[];
    carryOvers?: string | undefined;
    openedAt?: string | undefined;
    firstProjectNAWAt?: string | undefined;
    completedAt?: string | undefined;
    nawMessage?: string | undefined;
    attentionItemReminders!: AttentionItemReminderViewModel[];
    isDAObservation!: boolean;
    returnedAt?: string | undefined;
    actionTakenAt?: string | undefined;
    dismissedAt?: string | undefined;

    constructor(data?: IObservationToolObservationViewModel) {
        super(data);
        if (!data) {
            this.observationToolObservationMessages = [];
            this.observationToolObservationNawMessage = [];
            this.observationToolObservationDocumentRevisions = [];
            this.observationToolObservationAttachments = [];
            this.observationToolObservationCarryOvers = [];
            this.attentionItemReminders = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"];
            this.observationToolId = _data["observationToolId"];
            this.observationToolCheckId = _data["observationToolCheckId"];
            this.observationTool = _data["observationTool"] ? ObservationToolViewModel.fromJS(_data["observationTool"]) : <any>undefined;
            this.observationToolCheck = _data["observationToolCheck"] ? ObservationToolCheckViewModel.fromJS(_data["observationToolCheck"]) : <any>undefined;
            this.status = _data["status"];
            this.standing = _data["standing"];
            this.finalObservation = _data["finalObservation"];
            this.finalConcern = _data["finalConcern"];
            this.finalRecommendation = _data["finalRecommendation"];
            this.actionItem = _data["actionItem"];
            this.nextActionWith = _data["nextActionWith"];
            this.isNextActionWithYou = _data["isNextActionWithYou"];
            this.isDismissed = _data["isDismissed"];
            this.isDismissedJustified = _data["isDismissedJustified"];
            this.isReturned = _data["isReturned"];
            this.returnsCount = _data["returnsCount"];
            this.vAndVCompleted = _data["vAndVCompleted"];
            this.vAndVReady = _data["vAndVReady"];
            this.vAndV = _data["vAndV"];
            if (Array.isArray(_data["observationToolObservationMessages"])) {
                this.observationToolObservationMessages = [] as any;
                for (let item of _data["observationToolObservationMessages"])
                    this.observationToolObservationMessages!.push(ObservationToolObservationMessageViewModel.fromJS(item));
            }
            if (Array.isArray(_data["observationToolObservationNawMessage"])) {
                this.observationToolObservationNawMessage = [] as any;
                for (let item of _data["observationToolObservationNawMessage"])
                    this.observationToolObservationNawMessage!.push(ObservationToolObservationNawMessageViewModel.fromJS(item));
            }
            this.unreadMessagesCount = _data["unreadMessagesCount"];
            if (Array.isArray(_data["observationToolObservationDocumentRevisions"])) {
                this.observationToolObservationDocumentRevisions = [] as any;
                for (let item of _data["observationToolObservationDocumentRevisions"])
                    this.observationToolObservationDocumentRevisions!.push(ObservationToolObservationDocumentRevisionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["observationToolObservationAttachments"])) {
                this.observationToolObservationAttachments = [] as any;
                for (let item of _data["observationToolObservationAttachments"])
                    this.observationToolObservationAttachments!.push(ObservationToolObservationAttachmentViewModel.fromJS(item));
            }
            this.p3ActionCompleted = _data["p3ActionCompleted"];
            this.p3ActionCompletedDescription = _data["p3ActionCompletedDescription"];
            this.isAssignedToCurrentUser = _data["isAssignedToCurrentUser"];
            if (Array.isArray(_data["observationToolObservationCarryOvers"])) {
                this.observationToolObservationCarryOvers = [] as any;
                for (let item of _data["observationToolObservationCarryOvers"])
                    this.observationToolObservationCarryOvers!.push(ObservationToolObservationCarryOverViewModel.fromJS(item));
            }
            this.carryOvers = _data["carryOvers"];
            this.openedAt = _data["openedAt"];
            this.firstProjectNAWAt = _data["firstProjectNAWAt"];
            this.completedAt = _data["completedAt"];
            this.nawMessage = _data["nawMessage"];
            if (Array.isArray(_data["attentionItemReminders"])) {
                this.attentionItemReminders = [] as any;
                for (let item of _data["attentionItemReminders"])
                    this.attentionItemReminders!.push(AttentionItemReminderViewModel.fromJS(item));
            }
            this.isDAObservation = _data["isDAObservation"];
            this.returnedAt = _data["returnedAt"];
            this.actionTakenAt = _data["actionTakenAt"];
            this.dismissedAt = _data["dismissedAt"];
        }
    }

    static fromJS(data: any): ObservationToolObservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt;
        data["observationToolId"] = this.observationToolId;
        data["observationToolCheckId"] = this.observationToolCheckId;
        data["observationTool"] = this.observationTool ? this.observationTool.toJSON() : <any>undefined;
        data["observationToolCheck"] = this.observationToolCheck ? this.observationToolCheck.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["standing"] = this.standing;
        data["finalObservation"] = this.finalObservation;
        data["finalConcern"] = this.finalConcern;
        data["finalRecommendation"] = this.finalRecommendation;
        data["actionItem"] = this.actionItem;
        data["nextActionWith"] = this.nextActionWith;
        data["isNextActionWithYou"] = this.isNextActionWithYou;
        data["isDismissed"] = this.isDismissed;
        data["isDismissedJustified"] = this.isDismissedJustified;
        data["isReturned"] = this.isReturned;
        data["returnsCount"] = this.returnsCount;
        data["vAndVCompleted"] = this.vAndVCompleted;
        data["vAndVReady"] = this.vAndVReady;
        data["vAndV"] = this.vAndV;
        if (Array.isArray(this.observationToolObservationMessages)) {
            data["observationToolObservationMessages"] = [];
            for (let item of this.observationToolObservationMessages)
                data["observationToolObservationMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.observationToolObservationNawMessage)) {
            data["observationToolObservationNawMessage"] = [];
            for (let item of this.observationToolObservationNawMessage)
                data["observationToolObservationNawMessage"].push(item.toJSON());
        }
        data["unreadMessagesCount"] = this.unreadMessagesCount;
        if (Array.isArray(this.observationToolObservationDocumentRevisions)) {
            data["observationToolObservationDocumentRevisions"] = [];
            for (let item of this.observationToolObservationDocumentRevisions)
                data["observationToolObservationDocumentRevisions"].push(item.toJSON());
        }
        if (Array.isArray(this.observationToolObservationAttachments)) {
            data["observationToolObservationAttachments"] = [];
            for (let item of this.observationToolObservationAttachments)
                data["observationToolObservationAttachments"].push(item.toJSON());
        }
        data["p3ActionCompleted"] = this.p3ActionCompleted;
        data["p3ActionCompletedDescription"] = this.p3ActionCompletedDescription;
        data["isAssignedToCurrentUser"] = this.isAssignedToCurrentUser;
        if (Array.isArray(this.observationToolObservationCarryOvers)) {
            data["observationToolObservationCarryOvers"] = [];
            for (let item of this.observationToolObservationCarryOvers)
                data["observationToolObservationCarryOvers"].push(item.toJSON());
        }
        data["carryOvers"] = this.carryOvers;
        data["openedAt"] = this.openedAt;
        data["firstProjectNAWAt"] = this.firstProjectNAWAt;
        data["completedAt"] = this.completedAt;
        data["nawMessage"] = this.nawMessage;
        if (Array.isArray(this.attentionItemReminders)) {
            data["attentionItemReminders"] = [];
            for (let item of this.attentionItemReminders)
                data["attentionItemReminders"].push(item.toJSON());
        }
        data["isDAObservation"] = this.isDAObservation;
        data["returnedAt"] = this.returnedAt;
        data["actionTakenAt"] = this.actionTakenAt;
        data["dismissedAt"] = this.dismissedAt;
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolObservationViewModel extends IObservationToolObservationSaveBaseViewModel {
    id: string;
    createdBy?: string | undefined;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    observationToolId?: string | undefined;
    observationToolCheckId?: string | undefined;
    observationTool?: ObservationToolViewModel | undefined;
    observationToolCheck?: ObservationToolCheckViewModel | undefined;
    status: string;
    standing?: string | undefined;
    finalObservation?: string | undefined;
    finalConcern?: string | undefined;
    finalRecommendation?: string | undefined;
    actionItem?: string | undefined;
    nextActionWith?: string | undefined;
    isNextActionWithYou: boolean;
    isDismissed: boolean;
    isDismissedJustified: boolean;
    isReturned: boolean;
    returnsCount: number;
    vAndVCompleted: boolean;
    vAndVReady: boolean;
    vAndV: boolean;
    observationToolObservationMessages: ObservationToolObservationMessageViewModel[];
    observationToolObservationNawMessage: ObservationToolObservationNawMessageViewModel[];
    unreadMessagesCount: number;
    observationToolObservationDocumentRevisions: ObservationToolObservationDocumentRevisionViewModel[];
    observationToolObservationAttachments: ObservationToolObservationAttachmentViewModel[];
    p3ActionCompleted: boolean;
    p3ActionCompletedDescription?: string | undefined;
    isAssignedToCurrentUser: boolean;
    observationToolObservationCarryOvers: ObservationToolObservationCarryOverViewModel[];
    carryOvers?: string | undefined;
    openedAt?: string | undefined;
    firstProjectNAWAt?: string | undefined;
    completedAt?: string | undefined;
    nawMessage?: string | undefined;
    attentionItemReminders: AttentionItemReminderViewModel[];
    isDAObservation: boolean;
    returnedAt?: string | undefined;
    actionTakenAt?: string | undefined;
    dismissedAt?: string | undefined;
}

export class ObservationToolViewModel implements IObservationToolViewModel {
    id!: string;
    isReviewed!: boolean;
    projectDeliverable!: ProjectDeliverableViewModel;
    unreadMessagesCount!: number;
    deliverableFlags!: ObservationToolDeliverableFlagViewModel[];
    completedAt?: string | undefined;
    firstDAOverriddenAt?: string | undefined;

    constructor(data?: IObservationToolViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projectDeliverable = new ProjectDeliverableViewModel();
            this.deliverableFlags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isReviewed = _data["isReviewed"];
            this.projectDeliverable = _data["projectDeliverable"] ? ProjectDeliverableViewModel.fromJS(_data["projectDeliverable"]) : new ProjectDeliverableViewModel();
            this.unreadMessagesCount = _data["unreadMessagesCount"];
            if (Array.isArray(_data["deliverableFlags"])) {
                this.deliverableFlags = [] as any;
                for (let item of _data["deliverableFlags"])
                    this.deliverableFlags!.push(ObservationToolDeliverableFlagViewModel.fromJS(item));
            }
            this.completedAt = _data["completedAt"];
            this.firstDAOverriddenAt = _data["firstDAOverriddenAt"];
        }
    }

    static fromJS(data: any): ObservationToolViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isReviewed"] = this.isReviewed;
        data["projectDeliverable"] = this.projectDeliverable ? this.projectDeliverable.toJSON() : <any>undefined;
        data["unreadMessagesCount"] = this.unreadMessagesCount;
        if (Array.isArray(this.deliverableFlags)) {
            data["deliverableFlags"] = [];
            for (let item of this.deliverableFlags)
                data["deliverableFlags"].push(item.toJSON());
        }
        data["completedAt"] = this.completedAt;
        data["firstDAOverriddenAt"] = this.firstDAOverriddenAt;
        return data;
    }
}

export interface IObservationToolViewModel {
    id: string;
    isReviewed: boolean;
    projectDeliverable: ProjectDeliverableViewModel;
    unreadMessagesCount: number;
    deliverableFlags: ObservationToolDeliverableFlagViewModel[];
    completedAt?: string | undefined;
    firstDAOverriddenAt?: string | undefined;
}

export class ObservationToolDeliverableFlagViewModel implements IObservationToolDeliverableFlagViewModel {
    id!: string;
    observationToolId!: string;
    description?: string | undefined;
    createdByRole!: string;
    isResolved!: boolean;
    resolvedResponse?: string | undefined;
    createdBy!: string;
    createdAt!: string;

    constructor(data?: IObservationToolDeliverableFlagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.description = _data["description"];
            this.createdByRole = _data["createdByRole"];
            this.isResolved = _data["isResolved"];
            this.resolvedResponse = _data["resolvedResponse"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
        }
    }

    static fromJS(data: any): ObservationToolDeliverableFlagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDeliverableFlagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["description"] = this.description;
        data["createdByRole"] = this.createdByRole;
        data["isResolved"] = this.isResolved;
        data["resolvedResponse"] = this.resolvedResponse;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface IObservationToolDeliverableFlagViewModel {
    id: string;
    observationToolId: string;
    description?: string | undefined;
    createdByRole: string;
    isResolved: boolean;
    resolvedResponse?: string | undefined;
    createdBy: string;
    createdAt: string;
}

export class ObservationToolCheckViewModel implements IObservationToolCheckViewModel {
    id!: string;
    status!: string;
    check!: CheckViewModel;
    workloadEstimateAdditionalCheck?: WorkloadEstimateAdditionalCheckViewModel | undefined;
    linkedDeliverables!: ProjectDeliverableViewModel[];
    notes?: string | undefined;
    checkCompletionTrackingList!: CheckCompletionTrackingViewModel[];
    observationToolCheckMessages!: ObservationToolCheckMessageViewModel[];
    observations!: ObservationToolObservationViewModel[];

    constructor(data?: IObservationToolCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.check = new CheckViewModel();
            this.linkedDeliverables = [];
            this.checkCompletionTrackingList = [];
            this.observationToolCheckMessages = [];
            this.observations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.check = _data["check"] ? CheckViewModel.fromJS(_data["check"]) : new CheckViewModel();
            this.workloadEstimateAdditionalCheck = _data["workloadEstimateAdditionalCheck"] ? WorkloadEstimateAdditionalCheckViewModel.fromJS(_data["workloadEstimateAdditionalCheck"]) : <any>undefined;
            if (Array.isArray(_data["linkedDeliverables"])) {
                this.linkedDeliverables = [] as any;
                for (let item of _data["linkedDeliverables"])
                    this.linkedDeliverables!.push(ProjectDeliverableViewModel.fromJS(item));
            }
            this.notes = _data["notes"];
            if (Array.isArray(_data["checkCompletionTrackingList"])) {
                this.checkCompletionTrackingList = [] as any;
                for (let item of _data["checkCompletionTrackingList"])
                    this.checkCompletionTrackingList!.push(CheckCompletionTrackingViewModel.fromJS(item));
            }
            if (Array.isArray(_data["observationToolCheckMessages"])) {
                this.observationToolCheckMessages = [] as any;
                for (let item of _data["observationToolCheckMessages"])
                    this.observationToolCheckMessages!.push(ObservationToolCheckMessageViewModel.fromJS(item));
            }
            if (Array.isArray(_data["observations"])) {
                this.observations = [] as any;
                for (let item of _data["observations"])
                    this.observations!.push(ObservationToolObservationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObservationToolCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["check"] = this.check ? this.check.toJSON() : <any>undefined;
        data["workloadEstimateAdditionalCheck"] = this.workloadEstimateAdditionalCheck ? this.workloadEstimateAdditionalCheck.toJSON() : <any>undefined;
        if (Array.isArray(this.linkedDeliverables)) {
            data["linkedDeliverables"] = [];
            for (let item of this.linkedDeliverables)
                data["linkedDeliverables"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        if (Array.isArray(this.checkCompletionTrackingList)) {
            data["checkCompletionTrackingList"] = [];
            for (let item of this.checkCompletionTrackingList)
                data["checkCompletionTrackingList"].push(item.toJSON());
        }
        if (Array.isArray(this.observationToolCheckMessages)) {
            data["observationToolCheckMessages"] = [];
            for (let item of this.observationToolCheckMessages)
                data["observationToolCheckMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.observations)) {
            data["observations"] = [];
            for (let item of this.observations)
                data["observations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObservationToolCheckViewModel {
    id: string;
    status: string;
    check: CheckViewModel;
    workloadEstimateAdditionalCheck?: WorkloadEstimateAdditionalCheckViewModel | undefined;
    linkedDeliverables: ProjectDeliverableViewModel[];
    notes?: string | undefined;
    checkCompletionTrackingList: CheckCompletionTrackingViewModel[];
    observationToolCheckMessages: ObservationToolCheckMessageViewModel[];
    observations: ObservationToolObservationViewModel[];
}

export class CheckViewModel implements ICheckViewModel {
    id?: string | undefined;
    projectPhaseId!: string;
    type!: string;
    owner!: string;
    scopeOfReview!: string;
    comments?: string | undefined;
    deliverableKeywords?: string | undefined;
    requiresProjectDeliverables!: boolean;
    isMandatoryCheck!: boolean;
    mandatoryCheckTemplateId?: string | undefined;
    smeComments?: string | undefined;

    constructor(data?: ICheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.type = _data["type"];
            this.owner = _data["owner"];
            this.scopeOfReview = _data["scopeOfReview"];
            this.comments = _data["comments"];
            this.deliverableKeywords = _data["deliverableKeywords"];
            this.requiresProjectDeliverables = _data["requiresProjectDeliverables"];
            this.isMandatoryCheck = _data["isMandatoryCheck"];
            this.mandatoryCheckTemplateId = _data["mandatoryCheckTemplateId"];
            this.smeComments = _data["smeComments"];
        }
    }

    static fromJS(data: any): CheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectPhaseId"] = this.projectPhaseId;
        data["type"] = this.type;
        data["owner"] = this.owner;
        data["scopeOfReview"] = this.scopeOfReview;
        data["comments"] = this.comments;
        data["deliverableKeywords"] = this.deliverableKeywords;
        data["requiresProjectDeliverables"] = this.requiresProjectDeliverables;
        data["isMandatoryCheck"] = this.isMandatoryCheck;
        data["mandatoryCheckTemplateId"] = this.mandatoryCheckTemplateId;
        data["smeComments"] = this.smeComments;
        return data;
    }
}

export interface ICheckViewModel {
    id?: string | undefined;
    projectPhaseId: string;
    type: string;
    owner: string;
    scopeOfReview: string;
    comments?: string | undefined;
    deliverableKeywords?: string | undefined;
    requiresProjectDeliverables: boolean;
    isMandatoryCheck: boolean;
    mandatoryCheckTemplateId?: string | undefined;
    smeComments?: string | undefined;
}

export class WorkloadEstimateAdditionalCheckViewModel implements IWorkloadEstimateAdditionalCheckViewModel {
    id!: string;
    hours!: number;
    checkId!: string;
    smeDisciplineId!: string;
    smeDiscipline!: SMEDisciplineViewModel;

    constructor(data?: IWorkloadEstimateAdditionalCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.smeDiscipline = new SMEDisciplineViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hours = _data["hours"];
            this.checkId = _data["checkId"];
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : new SMEDisciplineViewModel();
        }
    }

    static fromJS(data: any): WorkloadEstimateAdditionalCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkloadEstimateAdditionalCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hours"] = this.hours;
        data["checkId"] = this.checkId;
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkloadEstimateAdditionalCheckViewModel {
    id: string;
    hours: number;
    checkId: string;
    smeDisciplineId: string;
    smeDiscipline: SMEDisciplineViewModel;
}

export class SMEDisciplineViewModel implements ISMEDisciplineViewModel {
    id!: string;
    name!: string;
    description?: string | undefined;
    disciplineCode!: string;
    projectPhaseId!: string;
    smeDisciplineConfigId!: string;
    status!: string;
    baselineWorkloadEstimates!: BaselineWorkloadEstimateViewModel[];
    workloadEstimates!: WorkloadEstimateViewModel[];
    assignments!: SMEDisciplineAssignmentPeerPoolViewModel[];

    constructor(data?: ISMEDisciplineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.baselineWorkloadEstimates = [];
            this.workloadEstimates = [];
            this.assignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.disciplineCode = _data["disciplineCode"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.smeDisciplineConfigId = _data["smeDisciplineConfigId"];
            this.status = _data["status"];
            if (Array.isArray(_data["baselineWorkloadEstimates"])) {
                this.baselineWorkloadEstimates = [] as any;
                for (let item of _data["baselineWorkloadEstimates"])
                    this.baselineWorkloadEstimates!.push(BaselineWorkloadEstimateViewModel.fromJS(item));
            }
            if (Array.isArray(_data["workloadEstimates"])) {
                this.workloadEstimates = [] as any;
                for (let item of _data["workloadEstimates"])
                    this.workloadEstimates!.push(WorkloadEstimateViewModel.fromJS(item));
            }
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(SMEDisciplineAssignmentPeerPoolViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SMEDisciplineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["disciplineCode"] = this.disciplineCode;
        data["projectPhaseId"] = this.projectPhaseId;
        data["smeDisciplineConfigId"] = this.smeDisciplineConfigId;
        data["status"] = this.status;
        if (Array.isArray(this.baselineWorkloadEstimates)) {
            data["baselineWorkloadEstimates"] = [];
            for (let item of this.baselineWorkloadEstimates)
                data["baselineWorkloadEstimates"].push(item.toJSON());
        }
        if (Array.isArray(this.workloadEstimates)) {
            data["workloadEstimates"] = [];
            for (let item of this.workloadEstimates)
                data["workloadEstimates"].push(item.toJSON());
        }
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISMEDisciplineViewModel {
    id: string;
    name: string;
    description?: string | undefined;
    disciplineCode: string;
    projectPhaseId: string;
    smeDisciplineConfigId: string;
    status: string;
    baselineWorkloadEstimates: BaselineWorkloadEstimateViewModel[];
    workloadEstimates: WorkloadEstimateViewModel[];
    assignments: SMEDisciplineAssignmentPeerPoolViewModel[];
}

export class BaselineWorkloadEstimateViewModel implements IBaselineWorkloadEstimateViewModel {
    id!: string;
    hours!: number;
    daDeliverableId!: string;
    smeDisciplineConfigId!: string;
    smeDisciplineConfig!: SMEDisciplineConfigViewModel;

    constructor(data?: IBaselineWorkloadEstimateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.smeDisciplineConfig = new SMEDisciplineConfigViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hours = _data["hours"];
            this.daDeliverableId = _data["daDeliverableId"];
            this.smeDisciplineConfigId = _data["smeDisciplineConfigId"];
            this.smeDisciplineConfig = _data["smeDisciplineConfig"] ? SMEDisciplineConfigViewModel.fromJS(_data["smeDisciplineConfig"]) : new SMEDisciplineConfigViewModel();
        }
    }

    static fromJS(data: any): BaselineWorkloadEstimateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaselineWorkloadEstimateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hours"] = this.hours;
        data["daDeliverableId"] = this.daDeliverableId;
        data["smeDisciplineConfigId"] = this.smeDisciplineConfigId;
        data["smeDisciplineConfig"] = this.smeDisciplineConfig ? this.smeDisciplineConfig.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaselineWorkloadEstimateViewModel {
    id: string;
    hours: number;
    daDeliverableId: string;
    smeDisciplineConfigId: string;
    smeDisciplineConfig: SMEDisciplineConfigViewModel;
}

export class SMEDisciplineConfigViewModel implements ISMEDisciplineConfigViewModel {
    id?: string | undefined;
    name!: string;
    description?: string | undefined;
    code?: string | undefined;
    chapterManagers?: string[] | undefined;
    chapterManagersNames?: string | undefined;
    projectId?: string | undefined;
    dateDeleted?: string | undefined;

    constructor(data?: ISMEDisciplineConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.code = _data["code"];
            if (Array.isArray(_data["chapterManagers"])) {
                this.chapterManagers = [] as any;
                for (let item of _data["chapterManagers"])
                    this.chapterManagers!.push(item);
            }
            this.chapterManagersNames = _data["chapterManagersNames"];
            this.projectId = _data["projectId"];
            this.dateDeleted = _data["dateDeleted"];
        }
    }

    static fromJS(data: any): SMEDisciplineConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplineConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["code"] = this.code;
        if (Array.isArray(this.chapterManagers)) {
            data["chapterManagers"] = [];
            for (let item of this.chapterManagers)
                data["chapterManagers"].push(item);
        }
        data["chapterManagersNames"] = this.chapterManagersNames;
        data["projectId"] = this.projectId;
        data["dateDeleted"] = this.dateDeleted;
        return data;
    }
}

export interface ISMEDisciplineConfigViewModel {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    code?: string | undefined;
    chapterManagers?: string[] | undefined;
    chapterManagersNames?: string | undefined;
    projectId?: string | undefined;
    dateDeleted?: string | undefined;
}

export class WorkloadEstimateViewModel implements IWorkloadEstimateViewModel {
    id!: string;
    hours!: number;
    daDeliverableId!: string;
    smeDisciplineId!: string;
    smeDiscipline!: SMEDisciplineViewModel;

    constructor(data?: IWorkloadEstimateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.smeDiscipline = new SMEDisciplineViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hours = _data["hours"];
            this.daDeliverableId = _data["daDeliverableId"];
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : new SMEDisciplineViewModel();
        }
    }

    static fromJS(data: any): WorkloadEstimateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkloadEstimateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hours"] = this.hours;
        data["daDeliverableId"] = this.daDeliverableId;
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkloadEstimateViewModel {
    id: string;
    hours: number;
    daDeliverableId: string;
    smeDisciplineId: string;
    smeDiscipline: SMEDisciplineViewModel;
}

export class CheckCompletionTrackingViewModel implements ICheckCompletionTrackingViewModel {
    id!: string;
    observationToolId!: string;
    markedComplete!: boolean;
    observationToolCheckId!: string;
    observationTool!: ObservationToolViewModel;

    constructor(data?: ICheckCompletionTrackingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.observationTool = new ObservationToolViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.markedComplete = _data["markedComplete"];
            this.observationToolCheckId = _data["observationToolCheckId"];
            this.observationTool = _data["observationTool"] ? ObservationToolViewModel.fromJS(_data["observationTool"]) : new ObservationToolViewModel();
        }
    }

    static fromJS(data: any): CheckCompletionTrackingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCompletionTrackingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["markedComplete"] = this.markedComplete;
        data["observationToolCheckId"] = this.observationToolCheckId;
        data["observationTool"] = this.observationTool ? this.observationTool.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICheckCompletionTrackingViewModel {
    id: string;
    observationToolId: string;
    markedComplete: boolean;
    observationToolCheckId: string;
    observationTool: ObservationToolViewModel;
}

export abstract class MessageBaseViewModel implements IMessageBaseViewModel {
    id!: string;
    message!: string;
    createdByRole!: string;
    createdBy?: string | undefined;
    createdAt!: string;
    updatedAt!: string;
    read!: boolean;

    constructor(data?: IMessageBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.createdByRole = _data["createdByRole"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedAt = _data["updatedAt"];
            this.read = _data["read"];
        }
    }

    static fromJS(data: any): MessageBaseViewModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MessageBaseViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["createdByRole"] = this.createdByRole;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedAt"] = this.updatedAt;
        data["read"] = this.read;
        return data;
    }
}

export interface IMessageBaseViewModel {
    id: string;
    message: string;
    createdByRole: string;
    createdBy?: string | undefined;
    createdAt: string;
    updatedAt: string;
    read: boolean;
}

export class ObservationToolCheckMessageViewModel extends MessageBaseViewModel implements IObservationToolCheckMessageViewModel {
    observationToolCheckId!: string;

    constructor(data?: IObservationToolCheckMessageViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.observationToolCheckId = _data["observationToolCheckId"];
        }
    }

    static fromJS(data: any): ObservationToolCheckMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolCheckMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationToolCheckId"] = this.observationToolCheckId;
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolCheckMessageViewModel extends IMessageBaseViewModel {
    observationToolCheckId: string;
}

export class ObservationToolObservationMessageViewModel extends MessageBaseViewModel implements IObservationToolObservationMessageViewModel {
    observationToolObservationId!: string;
    isPublished!: boolean;
    currentChannel!: string;
    isShared!: boolean;

    constructor(data?: IObservationToolObservationMessageViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.isPublished = _data["isPublished"];
            this.currentChannel = _data["currentChannel"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): ObservationToolObservationMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["isPublished"] = this.isPublished;
        data["currentChannel"] = this.currentChannel;
        data["isShared"] = this.isShared;
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolObservationMessageViewModel extends IMessageBaseViewModel {
    observationToolObservationId: string;
    isPublished: boolean;
    currentChannel: string;
    isShared: boolean;
}

export class ObservationToolObservationNawMessageViewModel implements IObservationToolObservationNawMessageViewModel {
    id!: string;
    observationToolObservationId!: string;
    nextActionWith!: string;
    createdAt!: string;
    updatedAt!: string;

    constructor(data?: IObservationToolObservationNawMessageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.nextActionWith = _data["nextActionWith"];
            this.createdAt = _data["createdAt"];
            this.updatedAt = _data["updatedAt"];
        }
    }

    static fromJS(data: any): ObservationToolObservationNawMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationNawMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["nextActionWith"] = this.nextActionWith;
        data["createdAt"] = this.createdAt;
        data["updatedAt"] = this.updatedAt;
        return data;
    }
}

export interface IObservationToolObservationNawMessageViewModel {
    id: string;
    observationToolObservationId: string;
    nextActionWith: string;
    createdAt: string;
    updatedAt: string;
}

export class ObservationToolObservationDocumentRevisionViewModel implements IObservationToolObservationDocumentRevisionViewModel {
    id!: string;
    observationToolObservationId!: string;
    documentID?: string | undefined;
    documentControlSystemType!: string;
    documentControlSystemId!: string;
    title!: string;
    url!: string;
    discipline?: string | undefined;
    issue?: string | undefined;
    currentRevision?: string | undefined;
    isFinalRevision!: boolean;

    constructor(data?: IObservationToolObservationDocumentRevisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.documentID = _data["documentID"];
            this.documentControlSystemType = _data["documentControlSystemType"];
            this.documentControlSystemId = _data["documentControlSystemId"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.discipline = _data["discipline"];
            this.issue = _data["issue"];
            this.currentRevision = _data["currentRevision"];
            this.isFinalRevision = _data["isFinalRevision"];
        }
    }

    static fromJS(data: any): ObservationToolObservationDocumentRevisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationDocumentRevisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["documentID"] = this.documentID;
        data["documentControlSystemType"] = this.documentControlSystemType;
        data["documentControlSystemId"] = this.documentControlSystemId;
        data["title"] = this.title;
        data["url"] = this.url;
        data["discipline"] = this.discipline;
        data["issue"] = this.issue;
        data["currentRevision"] = this.currentRevision;
        data["isFinalRevision"] = this.isFinalRevision;
        return data;
    }
}

export interface IObservationToolObservationDocumentRevisionViewModel {
    id: string;
    observationToolObservationId: string;
    documentID?: string | undefined;
    documentControlSystemType: string;
    documentControlSystemId: string;
    title: string;
    url: string;
    discipline?: string | undefined;
    issue?: string | undefined;
    currentRevision?: string | undefined;
    isFinalRevision: boolean;
}

export class ObservationToolObservationAttachmentViewModel implements IObservationToolObservationAttachmentViewModel {
    id!: string;
    observationToolObservationId!: string;
    documentID?: string | undefined;
    documentControlSystemType!: string;
    documentControlSystemId!: string;
    title!: string;
    url!: string;
    discipline?: string | undefined;

    constructor(data?: IObservationToolObservationAttachmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.documentID = _data["documentID"];
            this.documentControlSystemType = _data["documentControlSystemType"];
            this.documentControlSystemId = _data["documentControlSystemId"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.discipline = _data["discipline"];
        }
    }

    static fromJS(data: any): ObservationToolObservationAttachmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationAttachmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["documentID"] = this.documentID;
        data["documentControlSystemType"] = this.documentControlSystemType;
        data["documentControlSystemId"] = this.documentControlSystemId;
        data["title"] = this.title;
        data["url"] = this.url;
        data["discipline"] = this.discipline;
        return data;
    }
}

export interface IObservationToolObservationAttachmentViewModel {
    id: string;
    observationToolObservationId: string;
    documentID?: string | undefined;
    documentControlSystemType: string;
    documentControlSystemId: string;
    title: string;
    url: string;
    discipline?: string | undefined;
}

export class ObservationToolObservationCarryOverViewModel implements IObservationToolObservationCarryOverViewModel {
    id!: string;
    observationToolObservationId!: string;
    projectPhaseId!: string;
    projectPhase?: ProjectPhaseViewModel | undefined;

    constructor(data?: IObservationToolObservationCarryOverViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseViewModel.fromJS(_data["projectPhase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ObservationToolObservationCarryOverViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationCarryOverViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["projectPhaseId"] = this.projectPhaseId;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        return data;
    }
}

export interface IObservationToolObservationCarryOverViewModel {
    id: string;
    observationToolObservationId: string;
    projectPhaseId: string;
    projectPhase?: ProjectPhaseViewModel | undefined;
}

export class AttentionItemReminderViewModel implements IAttentionItemReminderViewModel {
    id!: string;
    createdAt!: string;
    observationToolObservationId?: string | undefined;
    observationToolId?: string | undefined;
    attentionItemReminderDisciplines!: AttentionItemReminderDisciplineViewModel[];
    createdBy!: string;

    constructor(data?: IAttentionItemReminderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attentionItemReminderDisciplines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.observationToolId = _data["observationToolId"];
            if (Array.isArray(_data["attentionItemReminderDisciplines"])) {
                this.attentionItemReminderDisciplines = [] as any;
                for (let item of _data["attentionItemReminderDisciplines"])
                    this.attentionItemReminderDisciplines!.push(AttentionItemReminderDisciplineViewModel.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): AttentionItemReminderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttentionItemReminderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["observationToolId"] = this.observationToolId;
        if (Array.isArray(this.attentionItemReminderDisciplines)) {
            data["attentionItemReminderDisciplines"] = [];
            for (let item of this.attentionItemReminderDisciplines)
                data["attentionItemReminderDisciplines"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IAttentionItemReminderViewModel {
    id: string;
    createdAt: string;
    observationToolObservationId?: string | undefined;
    observationToolId?: string | undefined;
    attentionItemReminderDisciplines: AttentionItemReminderDisciplineViewModel[];
    createdBy: string;
}

export class AttentionItemReminderDisciplineViewModel implements IAttentionItemReminderDisciplineViewModel {
    smeDisciplineId!: string;
    smeDiscipline!: SMEDisciplineViewModel;

    constructor(data?: IAttentionItemReminderDisciplineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.smeDiscipline = new SMEDisciplineViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : new SMEDisciplineViewModel();
        }
    }

    static fromJS(data: any): AttentionItemReminderDisciplineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttentionItemReminderDisciplineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAttentionItemReminderDisciplineViewModel {
    smeDisciplineId: string;
    smeDiscipline: SMEDisciplineViewModel;
}

export class ObservationToolDashboardViewModel extends ObservationToolViewModel implements IObservationToolDashboardViewModel {
    hasNotAssignedDocument!: boolean;
    documents!: ObservationToolDocumentViewModel[];
    documentsCount!: number;
    observationsCount!: number;
    actionsCount!: number;
    lastActivity?: string | undefined;
    isAttentionItem!: boolean;
    totalHours?: number | undefined;
    hasP1Observations!: boolean;
    hasP2Observations!: boolean;
    hasP3Observations!: boolean;
    smeDisciplines?: SMEDisciplineInObservationViewModel[] | undefined;
    observationToolDisciplines!: ObservationToolDisciplineViewModel[];
    isReviewedForSME!: boolean;
    createdAt?: string | undefined;
    dateFirstDocumentAssigned?: string | undefined;
    isViewed!: boolean;
    reviewedForSMEAt?: string | undefined;

    constructor(data?: IObservationToolDashboardViewModel) {
        super(data);
        if (!data) {
            this.documents = [];
            this.observationToolDisciplines = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasNotAssignedDocument = _data["hasNotAssignedDocument"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            this.documentsCount = _data["documentsCount"];
            this.observationsCount = _data["observationsCount"];
            this.actionsCount = _data["actionsCount"];
            this.lastActivity = _data["lastActivity"];
            this.isAttentionItem = _data["isAttentionItem"];
            this.totalHours = _data["totalHours"];
            this.hasP1Observations = _data["hasP1Observations"];
            this.hasP2Observations = _data["hasP2Observations"];
            this.hasP3Observations = _data["hasP3Observations"];
            if (Array.isArray(_data["smeDisciplines"])) {
                this.smeDisciplines = [] as any;
                for (let item of _data["smeDisciplines"])
                    this.smeDisciplines!.push(SMEDisciplineInObservationViewModel.fromJS(item));
            }
            if (Array.isArray(_data["observationToolDisciplines"])) {
                this.observationToolDisciplines = [] as any;
                for (let item of _data["observationToolDisciplines"])
                    this.observationToolDisciplines!.push(ObservationToolDisciplineViewModel.fromJS(item));
            }
            this.isReviewedForSME = _data["isReviewedForSME"];
            this.createdAt = _data["createdAt"];
            this.dateFirstDocumentAssigned = _data["dateFirstDocumentAssigned"];
            this.isViewed = _data["isViewed"];
            this.reviewedForSMEAt = _data["reviewedForSMEAt"];
        }
    }

    static fromJS(data: any): ObservationToolDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasNotAssignedDocument"] = this.hasNotAssignedDocument;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["documentsCount"] = this.documentsCount;
        data["observationsCount"] = this.observationsCount;
        data["actionsCount"] = this.actionsCount;
        data["lastActivity"] = this.lastActivity;
        data["isAttentionItem"] = this.isAttentionItem;
        data["totalHours"] = this.totalHours;
        data["hasP1Observations"] = this.hasP1Observations;
        data["hasP2Observations"] = this.hasP2Observations;
        data["hasP3Observations"] = this.hasP3Observations;
        if (Array.isArray(this.smeDisciplines)) {
            data["smeDisciplines"] = [];
            for (let item of this.smeDisciplines)
                data["smeDisciplines"].push(item.toJSON());
        }
        if (Array.isArray(this.observationToolDisciplines)) {
            data["observationToolDisciplines"] = [];
            for (let item of this.observationToolDisciplines)
                data["observationToolDisciplines"].push(item.toJSON());
        }
        data["isReviewedForSME"] = this.isReviewedForSME;
        data["createdAt"] = this.createdAt;
        data["dateFirstDocumentAssigned"] = this.dateFirstDocumentAssigned;
        data["isViewed"] = this.isViewed;
        data["reviewedForSMEAt"] = this.reviewedForSMEAt;
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolDashboardViewModel extends IObservationToolViewModel {
    hasNotAssignedDocument: boolean;
    documents: ObservationToolDocumentViewModel[];
    documentsCount: number;
    observationsCount: number;
    actionsCount: number;
    lastActivity?: string | undefined;
    isAttentionItem: boolean;
    totalHours?: number | undefined;
    hasP1Observations: boolean;
    hasP2Observations: boolean;
    hasP3Observations: boolean;
    smeDisciplines?: SMEDisciplineInObservationViewModel[] | undefined;
    observationToolDisciplines: ObservationToolDisciplineViewModel[];
    isReviewedForSME: boolean;
    createdAt?: string | undefined;
    dateFirstDocumentAssigned?: string | undefined;
    isViewed: boolean;
    reviewedForSMEAt?: string | undefined;
}

export class ObservationToolDisciplineViewModel implements IObservationToolDisciplineViewModel {
    id!: string;
    observationToolId!: string;
    observationTool!: ObservationToolViewModel;
    smeDisciplineId!: string;
    smeDiscipline!: SMEDisciplineViewModel;
    isReviewed!: boolean;
    isReviewDAOverridden!: boolean;
    overrideReason?: string | undefined;
    reviewedAt?: string | undefined;
    daOverriddenAt?: string | undefined;

    constructor(data?: IObservationToolDisciplineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.observationTool = new ObservationToolViewModel();
            this.smeDiscipline = new SMEDisciplineViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.observationTool = _data["observationTool"] ? ObservationToolViewModel.fromJS(_data["observationTool"]) : new ObservationToolViewModel();
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : new SMEDisciplineViewModel();
            this.isReviewed = _data["isReviewed"];
            this.isReviewDAOverridden = _data["isReviewDAOverridden"];
            this.overrideReason = _data["overrideReason"];
            this.reviewedAt = _data["reviewedAt"];
            this.daOverriddenAt = _data["daOverriddenAt"];
        }
    }

    static fromJS(data: any): ObservationToolDisciplineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDisciplineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["observationTool"] = this.observationTool ? this.observationTool.toJSON() : <any>undefined;
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        data["isReviewed"] = this.isReviewed;
        data["isReviewDAOverridden"] = this.isReviewDAOverridden;
        data["overrideReason"] = this.overrideReason;
        data["reviewedAt"] = this.reviewedAt;
        data["daOverriddenAt"] = this.daOverriddenAt;
        return data;
    }
}

export interface IObservationToolDisciplineViewModel {
    id: string;
    observationToolId: string;
    observationTool: ObservationToolViewModel;
    smeDisciplineId: string;
    smeDiscipline: SMEDisciplineViewModel;
    isReviewed: boolean;
    isReviewDAOverridden: boolean;
    overrideReason?: string | undefined;
    reviewedAt?: string | undefined;
    daOverriddenAt?: string | undefined;
}

export class ObservationToolMetricsReadinessCheckItemsViewModel implements IObservationToolMetricsReadinessCheckItemsViewModel {
    pending!: number;
    working!: number;
    complete!: number;

    constructor(data?: IObservationToolMetricsReadinessCheckItemsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pending = _data["pending"];
            this.working = _data["working"];
            this.complete = _data["complete"];
        }
    }

    static fromJS(data: any): ObservationToolMetricsReadinessCheckItemsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsReadinessCheckItemsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pending"] = this.pending;
        data["working"] = this.working;
        data["complete"] = this.complete;
        return data;
    }
}

export interface IObservationToolMetricsReadinessCheckItemsViewModel {
    pending: number;
    working: number;
    complete: number;
}

export class DADeliverableTagFocusAreaViewModel implements IDADeliverableTagFocusAreaViewModel {
    id!: string;
    daDeliverableId!: string;
    daDeliverable?: DADeliverableViewModel | undefined;
    focusAreaId!: string;
    focusArea?: FocusAreaViewModel | undefined;
    isRecommended!: boolean;

    constructor(data?: IDADeliverableTagFocusAreaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.daDeliverableId = _data["daDeliverableId"];
            this.daDeliverable = _data["daDeliverable"] ? DADeliverableViewModel.fromJS(_data["daDeliverable"]) : <any>undefined;
            this.focusAreaId = _data["focusAreaId"];
            this.focusArea = _data["focusArea"] ? FocusAreaViewModel.fromJS(_data["focusArea"]) : <any>undefined;
            this.isRecommended = _data["isRecommended"];
        }
    }

    static fromJS(data: any): DADeliverableTagFocusAreaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableTagFocusAreaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["daDeliverableId"] = this.daDeliverableId;
        data["daDeliverable"] = this.daDeliverable ? this.daDeliverable.toJSON() : <any>undefined;
        data["focusAreaId"] = this.focusAreaId;
        data["focusArea"] = this.focusArea ? this.focusArea.toJSON() : <any>undefined;
        data["isRecommended"] = this.isRecommended;
        return data;
    }
}

export interface IDADeliverableTagFocusAreaViewModel {
    id: string;
    daDeliverableId: string;
    daDeliverable?: DADeliverableViewModel | undefined;
    focusAreaId: string;
    focusArea?: FocusAreaViewModel | undefined;
    isRecommended: boolean;
}

export class DADeliverableViewModel extends DADeliverableBaseViewModel implements IDADeliverableViewModel {
    daDeliverableTemplateId?: string | undefined;
    projectPhaseId!: string;
    createdBy?: string | undefined;
    createdAt?: string | undefined;
    updatedBy?: string | undefined;
    updatedAt?: string | undefined;
    daDeliverablesTagFocusAreas?: DADeliverableTagFocusAreaViewModel[] | undefined;

    constructor(data?: IDADeliverableViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.daDeliverableTemplateId = _data["daDeliverableTemplateId"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"];
            if (Array.isArray(_data["daDeliverablesTagFocusAreas"])) {
                this.daDeliverablesTagFocusAreas = [] as any;
                for (let item of _data["daDeliverablesTagFocusAreas"])
                    this.daDeliverablesTagFocusAreas!.push(DADeliverableTagFocusAreaViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DADeliverableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daDeliverableTemplateId"] = this.daDeliverableTemplateId;
        data["projectPhaseId"] = this.projectPhaseId;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt;
        if (Array.isArray(this.daDeliverablesTagFocusAreas)) {
            data["daDeliverablesTagFocusAreas"] = [];
            for (let item of this.daDeliverablesTagFocusAreas)
                data["daDeliverablesTagFocusAreas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDADeliverableViewModel extends IDADeliverableBaseViewModel {
    daDeliverableTemplateId?: string | undefined;
    projectPhaseId: string;
    createdBy?: string | undefined;
    createdAt?: string | undefined;
    updatedBy?: string | undefined;
    updatedAt?: string | undefined;
    daDeliverablesTagFocusAreas?: DADeliverableTagFocusAreaViewModel[] | undefined;
}

export class FocusAreaCreateOrUpdateViewModel implements IFocusAreaCreateOrUpdateViewModel {
    id!: string;
    focusAreaConfigId?: string | undefined;
    title!: string;
    definition?: string | undefined;
    projectId?: string | undefined;
    projectPhaseId!: string;
    displayDeliverables!: boolean;
    order?: number | undefined;
    value?: string | undefined;
    statement?: string | undefined;
    done!: boolean;
    isAdHoc!: boolean;

    constructor(data?: IFocusAreaCreateOrUpdateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.focusAreaConfigId = _data["focusAreaConfigId"];
            this.title = _data["title"];
            this.definition = _data["definition"];
            this.projectId = _data["projectId"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.displayDeliverables = _data["displayDeliverables"];
            this.order = _data["order"];
            this.value = _data["value"];
            this.statement = _data["statement"];
            this.done = _data["done"];
            this.isAdHoc = _data["isAdHoc"];
        }
    }

    static fromJS(data: any): FocusAreaCreateOrUpdateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FocusAreaCreateOrUpdateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["focusAreaConfigId"] = this.focusAreaConfigId;
        data["title"] = this.title;
        data["definition"] = this.definition;
        data["projectId"] = this.projectId;
        data["projectPhaseId"] = this.projectPhaseId;
        data["displayDeliverables"] = this.displayDeliverables;
        data["order"] = this.order;
        data["value"] = this.value;
        data["statement"] = this.statement;
        data["done"] = this.done;
        data["isAdHoc"] = this.isAdHoc;
        return data;
    }
}

export interface IFocusAreaCreateOrUpdateViewModel {
    id: string;
    focusAreaConfigId?: string | undefined;
    title: string;
    definition?: string | undefined;
    projectId?: string | undefined;
    projectPhaseId: string;
    displayDeliverables: boolean;
    order?: number | undefined;
    value?: string | undefined;
    statement?: string | undefined;
    done: boolean;
    isAdHoc: boolean;
}

export class FocusAreaViewModel extends FocusAreaCreateOrUpdateViewModel implements IFocusAreaViewModel {
    taggedDeliverablesCount!: number;
    createdBy!: string;
    createdAt!: string;
    updatedBy!: string;
    updatedAt!: string;
    daDeliverablesFocusAreas!: DADeliverableFocusAreaViewModel[];

    constructor(data?: IFocusAreaViewModel) {
        super(data);
        if (!data) {
            this.daDeliverablesFocusAreas = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taggedDeliverablesCount = _data["taggedDeliverablesCount"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"];
            if (Array.isArray(_data["daDeliverablesFocusAreas"])) {
                this.daDeliverablesFocusAreas = [] as any;
                for (let item of _data["daDeliverablesFocusAreas"])
                    this.daDeliverablesFocusAreas!.push(DADeliverableFocusAreaViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FocusAreaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FocusAreaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taggedDeliverablesCount"] = this.taggedDeliverablesCount;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt;
        if (Array.isArray(this.daDeliverablesFocusAreas)) {
            data["daDeliverablesFocusAreas"] = [];
            for (let item of this.daDeliverablesFocusAreas)
                data["daDeliverablesFocusAreas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFocusAreaViewModel extends IFocusAreaCreateOrUpdateViewModel {
    taggedDeliverablesCount: number;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    daDeliverablesFocusAreas: DADeliverableFocusAreaViewModel[];
}

export class DADeliverableFocusAreaViewModel extends DADeliverableBaseViewModel implements IDADeliverableFocusAreaViewModel {
    daDeliverableTemplateId!: string;
    hasDeliverable!: boolean;
    isTaggedToCurrentFocusArea!: boolean;
    hasMapping!: boolean;
    projectPhaseId!: string;
    isRecommended!: boolean;

    constructor(data?: IDADeliverableFocusAreaViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.daDeliverableTemplateId = _data["daDeliverableTemplateId"];
            this.hasDeliverable = _data["hasDeliverable"];
            this.isTaggedToCurrentFocusArea = _data["isTaggedToCurrentFocusArea"];
            this.hasMapping = _data["hasMapping"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.isRecommended = _data["isRecommended"];
        }
    }

    static fromJS(data: any): DADeliverableFocusAreaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableFocusAreaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daDeliverableTemplateId"] = this.daDeliverableTemplateId;
        data["hasDeliverable"] = this.hasDeliverable;
        data["isTaggedToCurrentFocusArea"] = this.isTaggedToCurrentFocusArea;
        data["hasMapping"] = this.hasMapping;
        data["projectPhaseId"] = this.projectPhaseId;
        data["isRecommended"] = this.isRecommended;
        super.toJSON(data);
        return data;
    }
}

export interface IDADeliverableFocusAreaViewModel extends IDADeliverableBaseViewModel {
    daDeliverableTemplateId: string;
    hasDeliverable: boolean;
    isTaggedToCurrentFocusArea: boolean;
    hasMapping: boolean;
    projectPhaseId: string;
    isRecommended: boolean;
}

export class DADeliverablePhaseGuidelineViewModel implements IDADeliverablePhaseGuidelineViewModel {
    projectPhaseTemplate!: ProjectPhaseTemplateViewModel;
    deliverableCategory!: string;
    typicallyNOJVProvided!: boolean;
    typicallyDASampled!: boolean;
    daDeliverableTemplateId!: string;
    daDeliverableTemplate!: DADeliverableTemplateViewModel;
    workloadEstimates!: BaselineWorkloadEstimateViewModel[];

    constructor(data?: IDADeliverablePhaseGuidelineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projectPhaseTemplate = new ProjectPhaseTemplateViewModel();
            this.daDeliverableTemplate = new DADeliverableTemplateViewModel();
            this.workloadEstimates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectPhaseTemplate = _data["projectPhaseTemplate"] ? ProjectPhaseTemplateViewModel.fromJS(_data["projectPhaseTemplate"]) : new ProjectPhaseTemplateViewModel();
            this.deliverableCategory = _data["deliverableCategory"];
            this.typicallyNOJVProvided = _data["typicallyNOJVProvided"];
            this.typicallyDASampled = _data["typicallyDASampled"];
            this.daDeliverableTemplateId = _data["daDeliverableTemplateId"];
            this.daDeliverableTemplate = _data["daDeliverableTemplate"] ? DADeliverableTemplateViewModel.fromJS(_data["daDeliverableTemplate"]) : new DADeliverableTemplateViewModel();
            if (Array.isArray(_data["workloadEstimates"])) {
                this.workloadEstimates = [] as any;
                for (let item of _data["workloadEstimates"])
                    this.workloadEstimates!.push(BaselineWorkloadEstimateViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DADeliverablePhaseGuidelineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverablePhaseGuidelineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectPhaseTemplate"] = this.projectPhaseTemplate ? this.projectPhaseTemplate.toJSON() : <any>undefined;
        data["deliverableCategory"] = this.deliverableCategory;
        data["typicallyNOJVProvided"] = this.typicallyNOJVProvided;
        data["typicallyDASampled"] = this.typicallyDASampled;
        data["daDeliverableTemplateId"] = this.daDeliverableTemplateId;
        data["daDeliverableTemplate"] = this.daDeliverableTemplate ? this.daDeliverableTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.workloadEstimates)) {
            data["workloadEstimates"] = [];
            for (let item of this.workloadEstimates)
                data["workloadEstimates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDADeliverablePhaseGuidelineViewModel {
    projectPhaseTemplate: ProjectPhaseTemplateViewModel;
    deliverableCategory: string;
    typicallyNOJVProvided: boolean;
    typicallyDASampled: boolean;
    daDeliverableTemplateId: string;
    daDeliverableTemplate: DADeliverableTemplateViewModel;
    workloadEstimates: BaselineWorkloadEstimateViewModel[];
}

export class ProjectPhaseTemplateViewModel implements IProjectPhaseTemplateViewModel {
    phaseId!: string;

    constructor(data?: IProjectPhaseTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phaseId = _data["phaseId"];
        }
    }

    static fromJS(data: any): ProjectPhaseTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPhaseTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phaseId"] = this.phaseId;
        return data;
    }
}

export interface IProjectPhaseTemplateViewModel {
    phaseId: string;
}

export class IPIMSDocumentsSearchViewModel implements IIPIMSDocumentsSearchViewModel {
    total!: number;
    limit!: number;
    ipimsDocuments?: IPIMSDocumentsViewModel[] | undefined;
    exceededLimit!: boolean;

    constructor(data?: IIPIMSDocumentsSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["ipimsDocuments"])) {
                this.ipimsDocuments = [] as any;
                for (let item of _data["ipimsDocuments"])
                    this.ipimsDocuments!.push(IPIMSDocumentsViewModel.fromJS(item));
            }
            this.exceededLimit = _data["exceededLimit"];
        }
    }

    static fromJS(data: any): IPIMSDocumentsSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IPIMSDocumentsSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["limit"] = this.limit;
        if (Array.isArray(this.ipimsDocuments)) {
            data["ipimsDocuments"] = [];
            for (let item of this.ipimsDocuments)
                data["ipimsDocuments"].push(item.toJSON());
        }
        data["exceededLimit"] = this.exceededLimit;
        return data;
    }
}

export interface IIPIMSDocumentsSearchViewModel {
    total: number;
    limit: number;
    ipimsDocuments?: IPIMSDocumentsViewModel[] | undefined;
    exceededLimit: boolean;
}

export class IPIMSDocumentsViewModel implements IIPIMSDocumentsViewModel {
    primKey!: string;
    documentID!: string;
    domain!: string;
    documentURL!: string;
    drsCode?: string | undefined;
    discipline?: string | undefined;
    currentRevision?: string | undefined;
    title?: string | undefined;
    created!: string;
    updated!: string;
    currentStep?: string | undefined;

    constructor(data?: IIPIMSDocumentsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primKey = _data["primKey"];
            this.documentID = _data["documentID"];
            this.domain = _data["domain"];
            this.documentURL = _data["documentURL"];
            this.drsCode = _data["drsCode"];
            this.discipline = _data["discipline"];
            this.currentRevision = _data["currentRevision"];
            this.title = _data["title"];
            this.created = _data["created"];
            this.updated = _data["updated"];
            this.currentStep = _data["currentStep"];
        }
    }

    static fromJS(data: any): IPIMSDocumentsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IPIMSDocumentsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primKey"] = this.primKey;
        data["documentID"] = this.documentID;
        data["domain"] = this.domain;
        data["documentURL"] = this.documentURL;
        data["drsCode"] = this.drsCode;
        data["discipline"] = this.discipline;
        data["currentRevision"] = this.currentRevision;
        data["title"] = this.title;
        data["created"] = this.created;
        data["updated"] = this.updated;
        data["currentStep"] = this.currentStep;
        return data;
    }
}

export interface IIPIMSDocumentsViewModel {
    primKey: string;
    documentID: string;
    domain: string;
    documentURL: string;
    drsCode?: string | undefined;
    discipline?: string | undefined;
    currentRevision?: string | undefined;
    title?: string | undefined;
    created: string;
    updated: string;
    currentStep?: string | undefined;
}

export class IPIMSDomain implements IIPIMSDomain {
    domain!: string;

    constructor(data?: IIPIMSDomain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): IPIMSDomain {
        data = typeof data === 'object' ? data : {};
        let result = new IPIMSDomain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        return data;
    }
}

export interface IIPIMSDomain {
    domain: string;
}

export class ObservationToolCheckDashboardViewModel implements IObservationToolCheckDashboardViewModel {
    id!: string;
    type!: string;
    owner!: string;
    scopeOfReview!: string;
    comments?: string | undefined;
    deliverableKeywords?: string | undefined;
    requiresProjectDeliverables!: boolean;
    status!: string;
    workloadEstimateAdditionalCheckId!: string;
    checkId!: string;
    smeDiscipline!: SMEDisciplineViewModel;
    isAttentionItem!: boolean;
    isMandatoryCheck!: boolean;

    constructor(data?: IObservationToolCheckDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.smeDiscipline = new SMEDisciplineViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.owner = _data["owner"];
            this.scopeOfReview = _data["scopeOfReview"];
            this.comments = _data["comments"];
            this.deliverableKeywords = _data["deliverableKeywords"];
            this.requiresProjectDeliverables = _data["requiresProjectDeliverables"];
            this.status = _data["status"];
            this.workloadEstimateAdditionalCheckId = _data["workloadEstimateAdditionalCheckId"];
            this.checkId = _data["checkId"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : new SMEDisciplineViewModel();
            this.isAttentionItem = _data["isAttentionItem"];
            this.isMandatoryCheck = _data["isMandatoryCheck"];
        }
    }

    static fromJS(data: any): ObservationToolCheckDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolCheckDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["owner"] = this.owner;
        data["scopeOfReview"] = this.scopeOfReview;
        data["comments"] = this.comments;
        data["deliverableKeywords"] = this.deliverableKeywords;
        data["requiresProjectDeliverables"] = this.requiresProjectDeliverables;
        data["status"] = this.status;
        data["workloadEstimateAdditionalCheckId"] = this.workloadEstimateAdditionalCheckId;
        data["checkId"] = this.checkId;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        data["isAttentionItem"] = this.isAttentionItem;
        data["isMandatoryCheck"] = this.isMandatoryCheck;
        return data;
    }
}

export interface IObservationToolCheckDashboardViewModel {
    id: string;
    type: string;
    owner: string;
    scopeOfReview: string;
    comments?: string | undefined;
    deliverableKeywords?: string | undefined;
    requiresProjectDeliverables: boolean;
    status: string;
    workloadEstimateAdditionalCheckId: string;
    checkId: string;
    smeDiscipline: SMEDisciplineViewModel;
    isAttentionItem: boolean;
    isMandatoryCheck: boolean;
}

export class ObservationToolDetailsViewModel extends ObservationToolViewModel implements IObservationToolDetailsViewModel {
    documents!: ObservationToolDocumentViewModel[];
    observations!: ObservationToolObservationViewModel[];
    activities!: ObservationToolActivityViewModel[];
    smeDisciplines!: SMEDisciplineInObservationViewModel[];
    observationToolDisciplines!: ObservationToolDisciplineViewModel[];
    deliverableFlags!: ObservationToolDeliverableFlagViewModel[];
    deliverableNotes!: ObservationToolDeliverableNoteViewModel[];
    daDeliverables!: DADeliverableWithWorkloadEstimatesDetailsViewModel[];
    checks!: ObservationToolCheckViewModel[];
    attentionItemReminders!: AttentionItemReminderViewModel[];

    constructor(data?: IObservationToolDetailsViewModel) {
        super(data);
        if (!data) {
            this.documents = [];
            this.observations = [];
            this.activities = [];
            this.smeDisciplines = [];
            this.observationToolDisciplines = [];
            this.deliverableFlags = [];
            this.deliverableNotes = [];
            this.daDeliverables = [];
            this.checks = [];
            this.attentionItemReminders = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["observations"])) {
                this.observations = [] as any;
                for (let item of _data["observations"])
                    this.observations!.push(ObservationToolObservationViewModel.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ObservationToolActivityViewModel.fromJS(item));
            }
            if (Array.isArray(_data["smeDisciplines"])) {
                this.smeDisciplines = [] as any;
                for (let item of _data["smeDisciplines"])
                    this.smeDisciplines!.push(SMEDisciplineInObservationViewModel.fromJS(item));
            }
            if (Array.isArray(_data["observationToolDisciplines"])) {
                this.observationToolDisciplines = [] as any;
                for (let item of _data["observationToolDisciplines"])
                    this.observationToolDisciplines!.push(ObservationToolDisciplineViewModel.fromJS(item));
            }
            if (Array.isArray(_data["deliverableFlags"])) {
                this.deliverableFlags = [] as any;
                for (let item of _data["deliverableFlags"])
                    this.deliverableFlags!.push(ObservationToolDeliverableFlagViewModel.fromJS(item));
            }
            if (Array.isArray(_data["deliverableNotes"])) {
                this.deliverableNotes = [] as any;
                for (let item of _data["deliverableNotes"])
                    this.deliverableNotes!.push(ObservationToolDeliverableNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["daDeliverables"])) {
                this.daDeliverables = [] as any;
                for (let item of _data["daDeliverables"])
                    this.daDeliverables!.push(DADeliverableWithWorkloadEstimatesDetailsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["checks"])) {
                this.checks = [] as any;
                for (let item of _data["checks"])
                    this.checks!.push(ObservationToolCheckViewModel.fromJS(item));
            }
            if (Array.isArray(_data["attentionItemReminders"])) {
                this.attentionItemReminders = [] as any;
                for (let item of _data["attentionItemReminders"])
                    this.attentionItemReminders!.push(AttentionItemReminderViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObservationToolDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.observations)) {
            data["observations"] = [];
            for (let item of this.observations)
                data["observations"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        if (Array.isArray(this.smeDisciplines)) {
            data["smeDisciplines"] = [];
            for (let item of this.smeDisciplines)
                data["smeDisciplines"].push(item.toJSON());
        }
        if (Array.isArray(this.observationToolDisciplines)) {
            data["observationToolDisciplines"] = [];
            for (let item of this.observationToolDisciplines)
                data["observationToolDisciplines"].push(item.toJSON());
        }
        if (Array.isArray(this.deliverableFlags)) {
            data["deliverableFlags"] = [];
            for (let item of this.deliverableFlags)
                data["deliverableFlags"].push(item.toJSON());
        }
        if (Array.isArray(this.deliverableNotes)) {
            data["deliverableNotes"] = [];
            for (let item of this.deliverableNotes)
                data["deliverableNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.daDeliverables)) {
            data["daDeliverables"] = [];
            for (let item of this.daDeliverables)
                data["daDeliverables"].push(item.toJSON());
        }
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item.toJSON());
        }
        if (Array.isArray(this.attentionItemReminders)) {
            data["attentionItemReminders"] = [];
            for (let item of this.attentionItemReminders)
                data["attentionItemReminders"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolDetailsViewModel extends IObservationToolViewModel {
    documents: ObservationToolDocumentViewModel[];
    observations: ObservationToolObservationViewModel[];
    activities: ObservationToolActivityViewModel[];
    smeDisciplines: SMEDisciplineInObservationViewModel[];
    observationToolDisciplines: ObservationToolDisciplineViewModel[];
    deliverableFlags: ObservationToolDeliverableFlagViewModel[];
    deliverableNotes: ObservationToolDeliverableNoteViewModel[];
    daDeliverables: DADeliverableWithWorkloadEstimatesDetailsViewModel[];
    checks: ObservationToolCheckViewModel[];
    attentionItemReminders: AttentionItemReminderViewModel[];
}

export class ObservationToolActivityViewModel implements IObservationToolActivityViewModel {
    id!: string;
    createdBy?: string | undefined;
    createdAt!: string;
    observationToolId?: string | undefined;
    observationToolCheckId?: string | undefined;
    type!: string;
    templateResources!: ObservationToolActivityTemplateResourceViewModel[];
    userRole!: string;
    smeDisciplineId?: string | undefined;
    smeDiscipline?: SMEDisciplineInObservationViewModel | undefined;

    constructor(data?: IObservationToolActivityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.templateResources = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.observationToolId = _data["observationToolId"];
            this.observationToolCheckId = _data["observationToolCheckId"];
            this.type = _data["type"];
            if (Array.isArray(_data["templateResources"])) {
                this.templateResources = [] as any;
                for (let item of _data["templateResources"])
                    this.templateResources!.push(ObservationToolActivityTemplateResourceViewModel.fromJS(item));
            }
            this.userRole = _data["userRole"];
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineInObservationViewModel.fromJS(_data["smeDiscipline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ObservationToolActivityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolActivityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["observationToolId"] = this.observationToolId;
        data["observationToolCheckId"] = this.observationToolCheckId;
        data["type"] = this.type;
        if (Array.isArray(this.templateResources)) {
            data["templateResources"] = [];
            for (let item of this.templateResources)
                data["templateResources"].push(item.toJSON());
        }
        data["userRole"] = this.userRole;
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IObservationToolActivityViewModel {
    id: string;
    createdBy?: string | undefined;
    createdAt: string;
    observationToolId?: string | undefined;
    observationToolCheckId?: string | undefined;
    type: string;
    templateResources: ObservationToolActivityTemplateResourceViewModel[];
    userRole: string;
    smeDisciplineId?: string | undefined;
    smeDiscipline?: SMEDisciplineInObservationViewModel | undefined;
}

export class ObservationToolActivityTemplateResourceViewModel implements IObservationToolActivityTemplateResourceViewModel {
    id!: string;
    observationToolActivityId!: string;
    resourceType!: string;
    resourceValue!: string;

    constructor(data?: IObservationToolActivityTemplateResourceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolActivityId = _data["observationToolActivityId"];
            this.resourceType = _data["resourceType"];
            this.resourceValue = _data["resourceValue"];
        }
    }

    static fromJS(data: any): ObservationToolActivityTemplateResourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolActivityTemplateResourceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolActivityId"] = this.observationToolActivityId;
        data["resourceType"] = this.resourceType;
        data["resourceValue"] = this.resourceValue;
        return data;
    }
}

export interface IObservationToolActivityTemplateResourceViewModel {
    id: string;
    observationToolActivityId: string;
    resourceType: string;
    resourceValue: string;
}

export class ObservationToolDeliverableNoteViewModel implements IObservationToolDeliverableNoteViewModel {
    id!: string;
    observationToolId!: string;
    observationToolDocumentId?: string | undefined;
    observationToolDocument?: ObservationToolDocumentViewModel | undefined;
    title?: string | undefined;
    description?: string | undefined;
    createdBy!: string;
    createdAt!: string;

    constructor(data?: IObservationToolDeliverableNoteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.observationToolDocumentId = _data["observationToolDocumentId"];
            this.observationToolDocument = _data["observationToolDocument"] ? ObservationToolDocumentViewModel.fromJS(_data["observationToolDocument"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
        }
    }

    static fromJS(data: any): ObservationToolDeliverableNoteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDeliverableNoteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["observationToolDocumentId"] = this.observationToolDocumentId;
        data["observationToolDocument"] = this.observationToolDocument ? this.observationToolDocument.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface IObservationToolDeliverableNoteViewModel {
    id: string;
    observationToolId: string;
    observationToolDocumentId?: string | undefined;
    observationToolDocument?: ObservationToolDocumentViewModel | undefined;
    title?: string | undefined;
    description?: string | undefined;
    createdBy: string;
    createdAt: string;
}

export class DADeliverableWithWorkloadEstimatesDetailsViewModel extends DADeliverableBaseViewModel implements IDADeliverableWithWorkloadEstimatesDetailsViewModel {
    workloadEstimates!: WorkloadEstimateViewModel[];
    hasPermissionToRead!: boolean;

    constructor(data?: IDADeliverableWithWorkloadEstimatesDetailsViewModel) {
        super(data);
        if (!data) {
            this.workloadEstimates = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["workloadEstimates"])) {
                this.workloadEstimates = [] as any;
                for (let item of _data["workloadEstimates"])
                    this.workloadEstimates!.push(WorkloadEstimateViewModel.fromJS(item));
            }
            this.hasPermissionToRead = _data["hasPermissionToRead"];
        }
    }

    static fromJS(data: any): DADeliverableWithWorkloadEstimatesDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableWithWorkloadEstimatesDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workloadEstimates)) {
            data["workloadEstimates"] = [];
            for (let item of this.workloadEstimates)
                data["workloadEstimates"].push(item.toJSON());
        }
        data["hasPermissionToRead"] = this.hasPermissionToRead;
        super.toJSON(data);
        return data;
    }
}

export interface IDADeliverableWithWorkloadEstimatesDetailsViewModel extends IDADeliverableBaseViewModel {
    workloadEstimates: WorkloadEstimateViewModel[];
    hasPermissionToRead: boolean;
}

export class ObservationToolDashboardIndicators implements IObservationToolDashboardIndicators {
    observationsHasIndicator!: boolean;

    constructor(data?: IObservationToolDashboardIndicators) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationsHasIndicator = _data["observationsHasIndicator"];
        }
    }

    static fromJS(data: any): ObservationToolDashboardIndicators {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDashboardIndicators();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationsHasIndicator"] = this.observationsHasIndicator;
        return data;
    }
}

export interface IObservationToolDashboardIndicators {
    observationsHasIndicator: boolean;
}

export class ObservationToolObservationSaveSMEObservationViewModel extends ObservationToolObservationSaveBaseViewModel implements IObservationToolObservationSaveSMEObservationViewModel {

    constructor(data?: IObservationToolObservationSaveSMEObservationViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ObservationToolObservationSaveSMEObservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationSaveSMEObservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolObservationSaveSMEObservationViewModel extends IObservationToolObservationSaveBaseViewModel {
}

export class MarkDisciplineReviewedRequestViewModel implements IMarkDisciplineReviewedRequestViewModel {
    disciplineId!: string;
    selectedDocumentIds!: string[];

    constructor(data?: IMarkDisciplineReviewedRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedDocumentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disciplineId = _data["disciplineId"];
            if (Array.isArray(_data["selectedDocumentIds"])) {
                this.selectedDocumentIds = [] as any;
                for (let item of _data["selectedDocumentIds"])
                    this.selectedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MarkDisciplineReviewedRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkDisciplineReviewedRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disciplineId"] = this.disciplineId;
        if (Array.isArray(this.selectedDocumentIds)) {
            data["selectedDocumentIds"] = [];
            for (let item of this.selectedDocumentIds)
                data["selectedDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IMarkDisciplineReviewedRequestViewModel {
    disciplineId: string;
    selectedDocumentIds: string[];
}

export class ObservationToolObservationMessageReadViewModel implements IObservationToolObservationMessageReadViewModel {
    observationToolObservationMessageId!: string;
    role!: string;

    constructor(data?: IObservationToolObservationMessageReadViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationToolObservationMessageId = _data["observationToolObservationMessageId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ObservationToolObservationMessageReadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationMessageReadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationToolObservationMessageId"] = this.observationToolObservationMessageId;
        data["role"] = this.role;
        return data;
    }
}

export interface IObservationToolObservationMessageReadViewModel {
    observationToolObservationMessageId: string;
    role: string;
}

export class ObservationToolCheckMessageReadViewModel implements IObservationToolCheckMessageReadViewModel {
    observationToolCheckMessageId!: string;
    role!: string;

    constructor(data?: IObservationToolCheckMessageReadViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationToolCheckMessageId = _data["observationToolCheckMessageId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ObservationToolCheckMessageReadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolCheckMessageReadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationToolCheckMessageId"] = this.observationToolCheckMessageId;
        data["role"] = this.role;
        return data;
    }
}

export interface IObservationToolCheckMessageReadViewModel {
    observationToolCheckMessageId: string;
    role: string;
}

export class ObservationToolObservationDashboardViewModel implements IObservationToolObservationDashboardViewModel {
    id!: string;
    observationToolId!: string;
    observationToolViewModel!: ObservationToolViewModel;
    observationNumber?: number | undefined;
    smeDisciplineId!: string;
    smeDiscipline?: SMEDisciplineViewModel | undefined;
    title?: string | undefined;
    vAndV!: boolean;
    vAndVReady!: boolean;
    priority?: string | undefined;
    status!: string;
    standing?: string | undefined;
    nextActionWith!: string;
    isNextActionWithYou!: boolean;
    isDismissed!: boolean;
    isDismissedJustified!: boolean;
    isReturned!: boolean;
    vAndVCompleted!: boolean;
    hasActionItem!: boolean;
    unreadMessagesCount!: number;
    orr!: boolean;
    psri!: boolean;
    timeFrameToAddress?: string | undefined;
    urgency?: string | undefined;
    inherentVulnerability?: string | undefined;
    potentialImpactOnOtherDisciplines?: string[] | undefined;
    createdBy?: string | undefined;
    isAssignedToCurrentUser!: boolean;
    observationToolObservationCarryOvers!: ObservationToolObservationCarryOverViewModel[];
    isCarryOverToCurrentPhase!: boolean;
    daCategory?: string | undefined;
    areaSelections?: string | undefined;
    daComments?: string | undefined;
    openedAt?: string | undefined;
    completedAt?: string | undefined;
    firstProjectNAWAt?: string | undefined;
    attentionItemReminders!: AttentionItemReminderViewModel[];
    isDAObservation!: boolean;

    constructor(data?: IObservationToolObservationDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.observationToolViewModel = new ObservationToolViewModel();
            this.observationToolObservationCarryOvers = [];
            this.attentionItemReminders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolId = _data["observationToolId"];
            this.observationToolViewModel = _data["observationToolViewModel"] ? ObservationToolViewModel.fromJS(_data["observationToolViewModel"]) : new ObservationToolViewModel();
            this.observationNumber = _data["observationNumber"];
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : <any>undefined;
            this.title = _data["title"];
            this.vAndV = _data["vAndV"];
            this.vAndVReady = _data["vAndVReady"];
            this.priority = _data["priority"];
            this.status = _data["status"];
            this.standing = _data["standing"];
            this.nextActionWith = _data["nextActionWith"];
            this.isNextActionWithYou = _data["isNextActionWithYou"];
            this.isDismissed = _data["isDismissed"];
            this.isDismissedJustified = _data["isDismissedJustified"];
            this.isReturned = _data["isReturned"];
            this.vAndVCompleted = _data["vAndVCompleted"];
            this.hasActionItem = _data["hasActionItem"];
            this.unreadMessagesCount = _data["unreadMessagesCount"];
            this.orr = _data["orr"];
            this.psri = _data["psri"];
            this.timeFrameToAddress = _data["timeFrameToAddress"];
            this.urgency = _data["urgency"];
            this.inherentVulnerability = _data["inherentVulnerability"];
            if (Array.isArray(_data["potentialImpactOnOtherDisciplines"])) {
                this.potentialImpactOnOtherDisciplines = [] as any;
                for (let item of _data["potentialImpactOnOtherDisciplines"])
                    this.potentialImpactOnOtherDisciplines!.push(item);
            }
            this.createdBy = _data["createdBy"];
            this.isAssignedToCurrentUser = _data["isAssignedToCurrentUser"];
            if (Array.isArray(_data["observationToolObservationCarryOvers"])) {
                this.observationToolObservationCarryOvers = [] as any;
                for (let item of _data["observationToolObservationCarryOvers"])
                    this.observationToolObservationCarryOvers!.push(ObservationToolObservationCarryOverViewModel.fromJS(item));
            }
            this.isCarryOverToCurrentPhase = _data["isCarryOverToCurrentPhase"];
            this.daCategory = _data["daCategory"];
            this.areaSelections = _data["areaSelections"];
            this.daComments = _data["daComments"];
            this.openedAt = _data["openedAt"];
            this.completedAt = _data["completedAt"];
            this.firstProjectNAWAt = _data["firstProjectNAWAt"];
            if (Array.isArray(_data["attentionItemReminders"])) {
                this.attentionItemReminders = [] as any;
                for (let item of _data["attentionItemReminders"])
                    this.attentionItemReminders!.push(AttentionItemReminderViewModel.fromJS(item));
            }
            this.isDAObservation = _data["isDAObservation"];
        }
    }

    static fromJS(data: any): ObservationToolObservationDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolId"] = this.observationToolId;
        data["observationToolViewModel"] = this.observationToolViewModel ? this.observationToolViewModel.toJSON() : <any>undefined;
        data["observationNumber"] = this.observationNumber;
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["vAndV"] = this.vAndV;
        data["vAndVReady"] = this.vAndVReady;
        data["priority"] = this.priority;
        data["status"] = this.status;
        data["standing"] = this.standing;
        data["nextActionWith"] = this.nextActionWith;
        data["isNextActionWithYou"] = this.isNextActionWithYou;
        data["isDismissed"] = this.isDismissed;
        data["isDismissedJustified"] = this.isDismissedJustified;
        data["isReturned"] = this.isReturned;
        data["vAndVCompleted"] = this.vAndVCompleted;
        data["hasActionItem"] = this.hasActionItem;
        data["unreadMessagesCount"] = this.unreadMessagesCount;
        data["orr"] = this.orr;
        data["psri"] = this.psri;
        data["timeFrameToAddress"] = this.timeFrameToAddress;
        data["urgency"] = this.urgency;
        data["inherentVulnerability"] = this.inherentVulnerability;
        if (Array.isArray(this.potentialImpactOnOtherDisciplines)) {
            data["potentialImpactOnOtherDisciplines"] = [];
            for (let item of this.potentialImpactOnOtherDisciplines)
                data["potentialImpactOnOtherDisciplines"].push(item);
        }
        data["createdBy"] = this.createdBy;
        data["isAssignedToCurrentUser"] = this.isAssignedToCurrentUser;
        if (Array.isArray(this.observationToolObservationCarryOvers)) {
            data["observationToolObservationCarryOvers"] = [];
            for (let item of this.observationToolObservationCarryOvers)
                data["observationToolObservationCarryOvers"].push(item.toJSON());
        }
        data["isCarryOverToCurrentPhase"] = this.isCarryOverToCurrentPhase;
        data["daCategory"] = this.daCategory;
        data["areaSelections"] = this.areaSelections;
        data["daComments"] = this.daComments;
        data["openedAt"] = this.openedAt;
        data["completedAt"] = this.completedAt;
        data["firstProjectNAWAt"] = this.firstProjectNAWAt;
        if (Array.isArray(this.attentionItemReminders)) {
            data["attentionItemReminders"] = [];
            for (let item of this.attentionItemReminders)
                data["attentionItemReminders"].push(item.toJSON());
        }
        data["isDAObservation"] = this.isDAObservation;
        return data;
    }
}

export interface IObservationToolObservationDashboardViewModel {
    id: string;
    observationToolId: string;
    observationToolViewModel: ObservationToolViewModel;
    observationNumber?: number | undefined;
    smeDisciplineId: string;
    smeDiscipline?: SMEDisciplineViewModel | undefined;
    title?: string | undefined;
    vAndV: boolean;
    vAndVReady: boolean;
    priority?: string | undefined;
    status: string;
    standing?: string | undefined;
    nextActionWith: string;
    isNextActionWithYou: boolean;
    isDismissed: boolean;
    isDismissedJustified: boolean;
    isReturned: boolean;
    vAndVCompleted: boolean;
    hasActionItem: boolean;
    unreadMessagesCount: number;
    orr: boolean;
    psri: boolean;
    timeFrameToAddress?: string | undefined;
    urgency?: string | undefined;
    inherentVulnerability?: string | undefined;
    potentialImpactOnOtherDisciplines?: string[] | undefined;
    createdBy?: string | undefined;
    isAssignedToCurrentUser: boolean;
    observationToolObservationCarryOvers: ObservationToolObservationCarryOverViewModel[];
    isCarryOverToCurrentPhase: boolean;
    daCategory?: string | undefined;
    areaSelections?: string | undefined;
    daComments?: string | undefined;
    openedAt?: string | undefined;
    completedAt?: string | undefined;
    firstProjectNAWAt?: string | undefined;
    attentionItemReminders: AttentionItemReminderViewModel[];
    isDAObservation: boolean;
}

export class ProjectViewModel implements IProjectViewModel {
    id!: string;
    name!: string;
    description!: string;
    currentPhaseId?: string | undefined;
    currentPhase?: ProjectPhaseViewModel | undefined;
    phases!: ProjectPhaseViewModel[];
    createdBy!: string;
    createdAt!: string;
    updatedBy!: string;
    updatedAt!: string;
    nojv!: boolean;
    onShore!: boolean;
    offShore!: boolean;
    businessUnitId?: string | undefined;
    businessUnit?: BusinessUnitViewModel | undefined;
    isReadOnly!: boolean;
    userAnonymity!: boolean;
    valueRecognitionLegendUpdated!: string;
    archived!: boolean;
    deleted!: boolean;
    assetClassId?: string | undefined;
    assetClass?: AssetClassViewModel | undefined;
    chargeCode?: string | undefined;
    audit!: boolean;

    constructor(data?: IProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.phases = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.currentPhaseId = _data["currentPhaseId"];
            this.currentPhase = _data["currentPhase"] ? ProjectPhaseViewModel.fromJS(_data["currentPhase"]) : <any>undefined;
            if (Array.isArray(_data["phases"])) {
                this.phases = [] as any;
                for (let item of _data["phases"])
                    this.phases!.push(ProjectPhaseViewModel.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"];
            this.nojv = _data["nojv"];
            this.onShore = _data["onShore"];
            this.offShore = _data["offShore"];
            this.businessUnitId = _data["businessUnitId"];
            this.businessUnit = _data["businessUnit"] ? BusinessUnitViewModel.fromJS(_data["businessUnit"]) : <any>undefined;
            this.isReadOnly = _data["isReadOnly"];
            this.userAnonymity = _data["userAnonymity"];
            this.valueRecognitionLegendUpdated = _data["valueRecognitionLegendUpdated"];
            this.archived = _data["archived"];
            this.deleted = _data["deleted"];
            this.assetClassId = _data["assetClassId"];
            this.assetClass = _data["assetClass"] ? AssetClassViewModel.fromJS(_data["assetClass"]) : <any>undefined;
            this.chargeCode = _data["chargeCode"];
            this.audit = _data["audit"];
        }
    }

    static fromJS(data: any): ProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["currentPhaseId"] = this.currentPhaseId;
        data["currentPhase"] = this.currentPhase ? this.currentPhase.toJSON() : <any>undefined;
        if (Array.isArray(this.phases)) {
            data["phases"] = [];
            for (let item of this.phases)
                data["phases"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt;
        data["nojv"] = this.nojv;
        data["onShore"] = this.onShore;
        data["offShore"] = this.offShore;
        data["businessUnitId"] = this.businessUnitId;
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        data["isReadOnly"] = this.isReadOnly;
        data["userAnonymity"] = this.userAnonymity;
        data["valueRecognitionLegendUpdated"] = this.valueRecognitionLegendUpdated;
        data["archived"] = this.archived;
        data["deleted"] = this.deleted;
        data["assetClassId"] = this.assetClassId;
        data["assetClass"] = this.assetClass ? this.assetClass.toJSON() : <any>undefined;
        data["chargeCode"] = this.chargeCode;
        data["audit"] = this.audit;
        return data;
    }
}

export interface IProjectViewModel {
    id: string;
    name: string;
    description: string;
    currentPhaseId?: string | undefined;
    currentPhase?: ProjectPhaseViewModel | undefined;
    phases: ProjectPhaseViewModel[];
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    nojv: boolean;
    onShore: boolean;
    offShore: boolean;
    businessUnitId?: string | undefined;
    businessUnit?: BusinessUnitViewModel | undefined;
    isReadOnly: boolean;
    userAnonymity: boolean;
    valueRecognitionLegendUpdated: string;
    archived: boolean;
    deleted: boolean;
    assetClassId?: string | undefined;
    assetClass?: AssetClassViewModel | undefined;
    chargeCode?: string | undefined;
    audit: boolean;
}

export class BusinessUnitViewModel implements IBusinessUnitViewModel {
    id!: string;
    name!: string;
    code!: string;
    region!: string;
    softDelete!: boolean;

    constructor(data?: IBusinessUnitViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.region = _data["region"];
            this.softDelete = _data["softDelete"];
        }
    }

    static fromJS(data: any): BusinessUnitViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessUnitViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["region"] = this.region;
        data["softDelete"] = this.softDelete;
        return data;
    }
}

export interface IBusinessUnitViewModel {
    id: string;
    name: string;
    code: string;
    region: string;
    softDelete: boolean;
}

export class AssetClassViewModel implements IAssetClassViewModel {
    id!: string;
    name!: string;

    constructor(data?: IAssetClassViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AssetClassViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssetClassViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAssetClassViewModel {
    id: string;
    name: string;
}

export class ProjectPhaseWithProjectViewModel extends ProjectPhaseViewModel implements IProjectPhaseWithProjectViewModel {
    project?: ProjectViewModel | undefined;

    constructor(data?: IProjectPhaseWithProjectViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.project = _data["project"] ? ProjectViewModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectPhaseWithProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPhaseWithProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectPhaseWithProjectViewModel extends IProjectPhaseViewModel {
    project?: ProjectViewModel | undefined;
}

export class SMEDisciplinePeerPoolViewModel implements ISMEDisciplinePeerPoolViewModel {
    id!: string;
    name?: string | undefined;
    disciplineCode!: string;
    totalHours!: number;
    status!: string;
    isRiskBasedAssessment!: boolean;
    alwaysIncludeInPeerPool!: boolean;
    active!: boolean;
    assignments!: SMEDisciplineAssignmentPeerPoolViewModel[];
    isAdHoc!: boolean;

    constructor(data?: ISMEDisciplinePeerPoolViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.disciplineCode = _data["disciplineCode"];
            this.totalHours = _data["totalHours"];
            this.status = _data["status"];
            this.isRiskBasedAssessment = _data["isRiskBasedAssessment"];
            this.alwaysIncludeInPeerPool = _data["alwaysIncludeInPeerPool"];
            this.active = _data["active"];
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(SMEDisciplineAssignmentPeerPoolViewModel.fromJS(item));
            }
            this.isAdHoc = _data["isAdHoc"];
        }
    }

    static fromJS(data: any): SMEDisciplinePeerPoolViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplinePeerPoolViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["disciplineCode"] = this.disciplineCode;
        data["totalHours"] = this.totalHours;
        data["status"] = this.status;
        data["isRiskBasedAssessment"] = this.isRiskBasedAssessment;
        data["alwaysIncludeInPeerPool"] = this.alwaysIncludeInPeerPool;
        data["active"] = this.active;
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        data["isAdHoc"] = this.isAdHoc;
        return data;
    }
}

export interface ISMEDisciplinePeerPoolViewModel {
    id: string;
    name?: string | undefined;
    disciplineCode: string;
    totalHours: number;
    status: string;
    isRiskBasedAssessment: boolean;
    alwaysIncludeInPeerPool: boolean;
    active: boolean;
    assignments: SMEDisciplineAssignmentPeerPoolViewModel[];
    isAdHoc: boolean;
}

export class SMEDisciplinePeerPoolWithProjectPhaseViewModel extends SMEDisciplinePeerPoolViewModel implements ISMEDisciplinePeerPoolWithProjectPhaseViewModel {
    projectPhase?: ProjectPhaseWithProjectViewModel | undefined;

    constructor(data?: ISMEDisciplinePeerPoolWithProjectPhaseViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseWithProjectViewModel.fromJS(_data["projectPhase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SMEDisciplinePeerPoolWithProjectPhaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplinePeerPoolWithProjectPhaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISMEDisciplinePeerPoolWithProjectPhaseViewModel extends ISMEDisciplinePeerPoolViewModel {
    projectPhase?: ProjectPhaseWithProjectViewModel | undefined;
}

export class SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel extends SMEDisciplinePeerPoolWithProjectPhaseViewModel implements ISMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel {
    daDeliverables?: DADeliverableViewModel[] | undefined;
    checks?: CheckViewModel[] | undefined;

    constructor(data?: ISMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["daDeliverables"])) {
                this.daDeliverables = [] as any;
                for (let item of _data["daDeliverables"])
                    this.daDeliverables!.push(DADeliverableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["checks"])) {
                this.checks = [] as any;
                for (let item of _data["checks"])
                    this.checks!.push(CheckViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.daDeliverables)) {
            data["daDeliverables"] = [];
            for (let item of this.daDeliverables)
                data["daDeliverables"].push(item.toJSON());
        }
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISMEDisciplinePeerPoolWithProjectPhaseAndDADeliverablesViewModel extends ISMEDisciplinePeerPoolWithProjectPhaseViewModel {
    daDeliverables?: DADeliverableViewModel[] | undefined;
    checks?: CheckViewModel[] | undefined;
}

export class DADeliverableFormViewModel implements IDADeliverableFormViewModel {
    id!: string;
    title!: string;
    definition?: string | undefined;
    deliverableDiscipline!: string;
    drsCode?: string | undefined;
    docType!: string;
    deliverableId?: string | undefined;
    isAdHoc!: boolean;
    daDeliverablesTagFocusAreasIds?: string[] | undefined;
    daDeliverablesTagFocusAreasIdsToCreate?: string[] | undefined;

    constructor(data?: IDADeliverableFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.definition = _data["definition"];
            this.deliverableDiscipline = _data["deliverableDiscipline"];
            this.drsCode = _data["drsCode"];
            this.docType = _data["docType"];
            this.deliverableId = _data["deliverableId"];
            this.isAdHoc = _data["isAdHoc"];
            if (Array.isArray(_data["daDeliverablesTagFocusAreasIds"])) {
                this.daDeliverablesTagFocusAreasIds = [] as any;
                for (let item of _data["daDeliverablesTagFocusAreasIds"])
                    this.daDeliverablesTagFocusAreasIds!.push(item);
            }
            if (Array.isArray(_data["daDeliverablesTagFocusAreasIdsToCreate"])) {
                this.daDeliverablesTagFocusAreasIdsToCreate = [] as any;
                for (let item of _data["daDeliverablesTagFocusAreasIdsToCreate"])
                    this.daDeliverablesTagFocusAreasIdsToCreate!.push(item);
            }
        }
    }

    static fromJS(data: any): DADeliverableFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["definition"] = this.definition;
        data["deliverableDiscipline"] = this.deliverableDiscipline;
        data["drsCode"] = this.drsCode;
        data["docType"] = this.docType;
        data["deliverableId"] = this.deliverableId;
        data["isAdHoc"] = this.isAdHoc;
        if (Array.isArray(this.daDeliverablesTagFocusAreasIds)) {
            data["daDeliverablesTagFocusAreasIds"] = [];
            for (let item of this.daDeliverablesTagFocusAreasIds)
                data["daDeliverablesTagFocusAreasIds"].push(item);
        }
        if (Array.isArray(this.daDeliverablesTagFocusAreasIdsToCreate)) {
            data["daDeliverablesTagFocusAreasIdsToCreate"] = [];
            for (let item of this.daDeliverablesTagFocusAreasIdsToCreate)
                data["daDeliverablesTagFocusAreasIdsToCreate"].push(item);
        }
        return data;
    }
}

export interface IDADeliverableFormViewModel {
    id: string;
    title: string;
    definition?: string | undefined;
    deliverableDiscipline: string;
    drsCode?: string | undefined;
    docType: string;
    deliverableId?: string | undefined;
    isAdHoc: boolean;
    daDeliverablesTagFocusAreasIds?: string[] | undefined;
    daDeliverablesTagFocusAreasIdsToCreate?: string[] | undefined;
}

export class DeliverableMasterViewModel extends DADeliverableViewModel implements IDeliverableMasterViewModel {
    projectDeliverableTitle?: string | undefined;
    observationToolId?: string | undefined;
    deliverableCategory?: string | undefined;
    hasMapping!: boolean;
    projectDeliverableIsCarryover!: boolean;
    mappingCreatedAt?: string | undefined;
    projectDeliverableId?: string | undefined;
    messages!: DeliverableMessageViewModel[];

    constructor(data?: IDeliverableMasterViewModel) {
        super(data);
        if (!data) {
            this.messages = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectDeliverableTitle = _data["projectDeliverableTitle"];
            this.observationToolId = _data["observationToolId"];
            this.deliverableCategory = _data["deliverableCategory"];
            this.hasMapping = _data["hasMapping"];
            this.projectDeliverableIsCarryover = _data["projectDeliverableIsCarryover"];
            this.mappingCreatedAt = _data["mappingCreatedAt"];
            this.projectDeliverableId = _data["projectDeliverableId"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(DeliverableMessageViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliverableMasterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverableMasterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectDeliverableTitle"] = this.projectDeliverableTitle;
        data["observationToolId"] = this.observationToolId;
        data["deliverableCategory"] = this.deliverableCategory;
        data["hasMapping"] = this.hasMapping;
        data["projectDeliverableIsCarryover"] = this.projectDeliverableIsCarryover;
        data["mappingCreatedAt"] = this.mappingCreatedAt;
        data["projectDeliverableId"] = this.projectDeliverableId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeliverableMasterViewModel extends IDADeliverableViewModel {
    projectDeliverableTitle?: string | undefined;
    observationToolId?: string | undefined;
    deliverableCategory?: string | undefined;
    hasMapping: boolean;
    projectDeliverableIsCarryover: boolean;
    mappingCreatedAt?: string | undefined;
    projectDeliverableId?: string | undefined;
    messages: DeliverableMessageViewModel[];
}

export class DeliverableMessageViewModel extends MessageBaseViewModel implements IDeliverableMessageViewModel {
    daDeliverableId!: string;
    projectDeliverableId!: string;

    constructor(data?: IDeliverableMessageViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.daDeliverableId = _data["daDeliverableId"];
            this.projectDeliverableId = _data["projectDeliverableId"];
        }
    }

    static fromJS(data: any): DeliverableMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverableMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daDeliverableId"] = this.daDeliverableId;
        data["projectDeliverableId"] = this.projectDeliverableId;
        super.toJSON(data);
        return data;
    }
}

export interface IDeliverableMessageViewModel extends IMessageBaseViewModel {
    daDeliverableId: string;
    projectDeliverableId: string;
}

export class DeliverableMessageReadViewModel implements IDeliverableMessageReadViewModel {
    deliverableMessageId!: string;
    role!: string;

    constructor(data?: IDeliverableMessageReadViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliverableMessageId = _data["deliverableMessageId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): DeliverableMessageReadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverableMessageReadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliverableMessageId"] = this.deliverableMessageId;
        data["role"] = this.role;
        return data;
    }
}

export interface IDeliverableMessageReadViewModel {
    deliverableMessageId: string;
    role: string;
}

export class ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel implements IObservationToolProjectDeliverableIPIMSDocumentMatchViewModel {
    documentID!: string;
    projectDeliverableName!: string;
    projectDeliverableType?: string | undefined;
    projectDeliverableDiscipline!: string;
    ipimsDocumentTitle!: string;
    ipimsDocumentDiscipline?: string | undefined;
    ipimsDocumentRevision?: string | undefined;
    documentPrimaryKey!: string;
    projectDeliverableID!: string;

    constructor(data?: IObservationToolProjectDeliverableIPIMSDocumentMatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["documentID"];
            this.projectDeliverableName = _data["projectDeliverableName"];
            this.projectDeliverableType = _data["projectDeliverableType"];
            this.projectDeliverableDiscipline = _data["projectDeliverableDiscipline"];
            this.ipimsDocumentTitle = _data["ipimsDocumentTitle"];
            this.ipimsDocumentDiscipline = _data["ipimsDocumentDiscipline"];
            this.ipimsDocumentRevision = _data["ipimsDocumentRevision"];
            this.documentPrimaryKey = _data["documentPrimaryKey"];
            this.projectDeliverableID = _data["projectDeliverableID"];
        }
    }

    static fromJS(data: any): ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolProjectDeliverableIPIMSDocumentMatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentID"] = this.documentID;
        data["projectDeliverableName"] = this.projectDeliverableName;
        data["projectDeliverableType"] = this.projectDeliverableType;
        data["projectDeliverableDiscipline"] = this.projectDeliverableDiscipline;
        data["ipimsDocumentTitle"] = this.ipimsDocumentTitle;
        data["ipimsDocumentDiscipline"] = this.ipimsDocumentDiscipline;
        data["ipimsDocumentRevision"] = this.ipimsDocumentRevision;
        data["documentPrimaryKey"] = this.documentPrimaryKey;
        data["projectDeliverableID"] = this.projectDeliverableID;
        return data;
    }
}

export interface IObservationToolProjectDeliverableIPIMSDocumentMatchViewModel {
    documentID: string;
    projectDeliverableName: string;
    projectDeliverableType?: string | undefined;
    projectDeliverableDiscipline: string;
    ipimsDocumentTitle: string;
    ipimsDocumentDiscipline?: string | undefined;
    ipimsDocumentRevision?: string | undefined;
    documentPrimaryKey: string;
    projectDeliverableID: string;
}

export class ObservationToolIPIMSDocumentOneToOneAssignViewModel implements IObservationToolIPIMSDocumentOneToOneAssignViewModel {
    projectDeliverableID!: string;
    documentPrimaryKey!: string;
    observationToolId!: string;

    constructor(data?: IObservationToolIPIMSDocumentOneToOneAssignViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectDeliverableID = _data["projectDeliverableID"];
            this.documentPrimaryKey = _data["documentPrimaryKey"];
            this.observationToolId = _data["observationToolId"];
        }
    }

    static fromJS(data: any): ObservationToolIPIMSDocumentOneToOneAssignViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolIPIMSDocumentOneToOneAssignViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectDeliverableID"] = this.projectDeliverableID;
        data["documentPrimaryKey"] = this.documentPrimaryKey;
        data["observationToolId"] = this.observationToolId;
        return data;
    }
}

export interface IObservationToolIPIMSDocumentOneToOneAssignViewModel {
    projectDeliverableID: string;
    documentPrimaryKey: string;
    observationToolId: string;
}

export class ObservationToolDocumentLoadViewModel extends ObservationToolDocumentBaseViewModel implements IObservationToolDocumentLoadViewModel {

    constructor(data?: IObservationToolDocumentLoadViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ObservationToolDocumentLoadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDocumentLoadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolDocumentLoadViewModel extends IObservationToolDocumentBaseViewModel {
}

export class ObservationToolDocumentsFromFolderUpdateViewModel implements IObservationToolDocumentsFromFolderUpdateViewModel {
    documentsIdsToDelete!: string[];
    documentsToUpdate!: ObservationToolDocumentViewModel[];
    documentsToCreate!: ObservationToolDocumentLoadViewModel[];

    constructor(data?: IObservationToolDocumentsFromFolderUpdateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documentsIdsToDelete = [];
            this.documentsToUpdate = [];
            this.documentsToCreate = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentsIdsToDelete"])) {
                this.documentsIdsToDelete = [] as any;
                for (let item of _data["documentsIdsToDelete"])
                    this.documentsIdsToDelete!.push(item);
            }
            if (Array.isArray(_data["documentsToUpdate"])) {
                this.documentsToUpdate = [] as any;
                for (let item of _data["documentsToUpdate"])
                    this.documentsToUpdate!.push(ObservationToolDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["documentsToCreate"])) {
                this.documentsToCreate = [] as any;
                for (let item of _data["documentsToCreate"])
                    this.documentsToCreate!.push(ObservationToolDocumentLoadViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObservationToolDocumentsFromFolderUpdateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDocumentsFromFolderUpdateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentsIdsToDelete)) {
            data["documentsIdsToDelete"] = [];
            for (let item of this.documentsIdsToDelete)
                data["documentsIdsToDelete"].push(item);
        }
        if (Array.isArray(this.documentsToUpdate)) {
            data["documentsToUpdate"] = [];
            for (let item of this.documentsToUpdate)
                data["documentsToUpdate"].push(item.toJSON());
        }
        if (Array.isArray(this.documentsToCreate)) {
            data["documentsToCreate"] = [];
            for (let item of this.documentsToCreate)
                data["documentsToCreate"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObservationToolDocumentsFromFolderUpdateViewModel {
    documentsIdsToDelete: string[];
    documentsToUpdate: ObservationToolDocumentViewModel[];
    documentsToCreate: ObservationToolDocumentLoadViewModel[];
}

export class AttentionItemSettingViewModel implements IAttentionItemSettingViewModel {
    id!: string;
    projectId!: string;
    setting!: number;
    createdBy!: string;
    createdAt!: string;
    updatedBy!: string;
    updatedAt!: string;

    constructor(data?: IAttentionItemSettingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.setting = _data["setting"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"];
        }
    }

    static fromJS(data: any): AttentionItemSettingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttentionItemSettingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["setting"] = this.setting;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt;
        return data;
    }
}

export interface IAttentionItemSettingViewModel {
    id: string;
    projectId: string;
    setting: number;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
}

export class MandatoryCheckTemplateViewModel implements IMandatoryCheckTemplateViewModel {
    id?: string | undefined;
    owner!: string;
    scopeOfReview!: string;
    relevantPhases!: string[];

    constructor(data?: IMandatoryCheckTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relevantPhases = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.owner = _data["owner"];
            this.scopeOfReview = _data["scopeOfReview"];
            if (Array.isArray(_data["relevantPhases"])) {
                this.relevantPhases = [] as any;
                for (let item of _data["relevantPhases"])
                    this.relevantPhases!.push(item);
            }
        }
    }

    static fromJS(data: any): MandatoryCheckTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MandatoryCheckTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owner"] = this.owner;
        data["scopeOfReview"] = this.scopeOfReview;
        if (Array.isArray(this.relevantPhases)) {
            data["relevantPhases"] = [];
            for (let item of this.relevantPhases)
                data["relevantPhases"].push(item);
        }
        return data;
    }
}

export interface IMandatoryCheckTemplateViewModel {
    id?: string | undefined;
    owner: string;
    scopeOfReview: string;
    relevantPhases: string[];
}

export class CheckWithMappingsViewModel extends CheckViewModel implements ICheckWithMappingsViewModel {
    projectDeliverableIds!: string[];

    constructor(data?: ICheckWithMappingsViewModel) {
        super(data);
        if (!data) {
            this.projectDeliverableIds = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["projectDeliverableIds"])) {
                this.projectDeliverableIds = [] as any;
                for (let item of _data["projectDeliverableIds"])
                    this.projectDeliverableIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckWithMappingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckWithMappingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectDeliverableIds)) {
            data["projectDeliverableIds"] = [];
            for (let item of this.projectDeliverableIds)
                data["projectDeliverableIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICheckWithMappingsViewModel extends ICheckViewModel {
    projectDeliverableIds: string[];
}

export class DADeliverableWithWorkloadEstimatesViewModel implements IDADeliverableWithWorkloadEstimatesViewModel {
    id!: string;
    title?: string | undefined;
    docType?: string | undefined;
    deliverableDiscipline?: string | undefined;
    deliverableCategory?: string | undefined;
    workloadEstimates!: WorkloadEstimateWithStatisticsViewModel[];
    totalHours!: number;
    origin!: string;
    taggedFocusAreasCount!: number;

    constructor(data?: IDADeliverableWithWorkloadEstimatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workloadEstimates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.docType = _data["docType"];
            this.deliverableDiscipline = _data["deliverableDiscipline"];
            this.deliverableCategory = _data["deliverableCategory"];
            if (Array.isArray(_data["workloadEstimates"])) {
                this.workloadEstimates = [] as any;
                for (let item of _data["workloadEstimates"])
                    this.workloadEstimates!.push(WorkloadEstimateWithStatisticsViewModel.fromJS(item));
            }
            this.totalHours = _data["totalHours"];
            this.origin = _data["origin"];
            this.taggedFocusAreasCount = _data["taggedFocusAreasCount"];
        }
    }

    static fromJS(data: any): DADeliverableWithWorkloadEstimatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableWithWorkloadEstimatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["docType"] = this.docType;
        data["deliverableDiscipline"] = this.deliverableDiscipline;
        data["deliverableCategory"] = this.deliverableCategory;
        if (Array.isArray(this.workloadEstimates)) {
            data["workloadEstimates"] = [];
            for (let item of this.workloadEstimates)
                data["workloadEstimates"].push(item.toJSON());
        }
        data["totalHours"] = this.totalHours;
        data["origin"] = this.origin;
        data["taggedFocusAreasCount"] = this.taggedFocusAreasCount;
        return data;
    }
}

export interface IDADeliverableWithWorkloadEstimatesViewModel {
    id: string;
    title?: string | undefined;
    docType?: string | undefined;
    deliverableDiscipline?: string | undefined;
    deliverableCategory?: string | undefined;
    workloadEstimates: WorkloadEstimateWithStatisticsViewModel[];
    totalHours: number;
    origin: string;
    taggedFocusAreasCount: number;
}

export class WorkloadEstimateWithStatisticsViewModel extends WorkloadEstimateViewModel implements IWorkloadEstimateWithStatisticsViewModel {
    numberOfDeliverables!: number;
    averageNumberOfHours!: number;

    constructor(data?: IWorkloadEstimateWithStatisticsViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.numberOfDeliverables = _data["numberOfDeliverables"];
            this.averageNumberOfHours = _data["averageNumberOfHours"];
        }
    }

    static fromJS(data: any): WorkloadEstimateWithStatisticsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkloadEstimateWithStatisticsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfDeliverables"] = this.numberOfDeliverables;
        data["averageNumberOfHours"] = this.averageNumberOfHours;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkloadEstimateWithStatisticsViewModel extends IWorkloadEstimateViewModel {
    numberOfDeliverables: number;
    averageNumberOfHours: number;
}

export class DADeliverableWithMappingsViewModel extends DADeliverableViewModel implements IDADeliverableWithMappingsViewModel {
    projectDeliverableIdList!: string[];

    constructor(data?: IDADeliverableWithMappingsViewModel) {
        super(data);
        if (!data) {
            this.projectDeliverableIdList = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["projectDeliverableIdList"])) {
                this.projectDeliverableIdList = [] as any;
                for (let item of _data["projectDeliverableIdList"])
                    this.projectDeliverableIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DADeliverableWithMappingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableWithMappingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectDeliverableIdList)) {
            data["projectDeliverableIdList"] = [];
            for (let item of this.projectDeliverableIdList)
                data["projectDeliverableIdList"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDADeliverableWithMappingsViewModel extends IDADeliverableViewModel {
    projectDeliverableIdList: string[];
}

export class ADAPModelValidator implements IADAPModelValidator {
    entityDescription!: string;
    errors!: string[];
    isValid!: boolean;

    constructor(data?: IADAPModelValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityDescription = _data["entityDescription"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ADAPModelValidator {
        data = typeof data === 'object' ? data : {};
        let result = new ADAPModelValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityDescription"] = this.entityDescription;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IADAPModelValidator {
    entityDescription: string;
    errors: string[];
    isValid: boolean;
}

export class DADeliverableImportResultViewModel implements IDADeliverableImportResultViewModel {
    entitiesAdded!: DADeliverableViewModel[];
    entitiesUpdated!: DADeliverableViewModel[];
    entitiesRemoved!: DADeliverableViewModel[];

    constructor(data?: IDADeliverableImportResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entitiesAdded = [];
            this.entitiesUpdated = [];
            this.entitiesRemoved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entitiesAdded"])) {
                this.entitiesAdded = [] as any;
                for (let item of _data["entitiesAdded"])
                    this.entitiesAdded!.push(DADeliverableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["entitiesUpdated"])) {
                this.entitiesUpdated = [] as any;
                for (let item of _data["entitiesUpdated"])
                    this.entitiesUpdated!.push(DADeliverableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["entitiesRemoved"])) {
                this.entitiesRemoved = [] as any;
                for (let item of _data["entitiesRemoved"])
                    this.entitiesRemoved!.push(DADeliverableViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DADeliverableImportResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableImportResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entitiesAdded)) {
            data["entitiesAdded"] = [];
            for (let item of this.entitiesAdded)
                data["entitiesAdded"].push(item.toJSON());
        }
        if (Array.isArray(this.entitiesUpdated)) {
            data["entitiesUpdated"] = [];
            for (let item of this.entitiesUpdated)
                data["entitiesUpdated"].push(item.toJSON());
        }
        if (Array.isArray(this.entitiesRemoved)) {
            data["entitiesRemoved"] = [];
            for (let item of this.entitiesRemoved)
                data["entitiesRemoved"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDADeliverableImportResultViewModel {
    entitiesAdded: DADeliverableViewModel[];
    entitiesUpdated: DADeliverableViewModel[];
    entitiesRemoved: DADeliverableViewModel[];
}

export class DADeliverableImportDuplicatesViewModel implements IDADeliverableImportDuplicatesViewModel {
    duplicateByKey!: string;
    duplicateByPropertyName!: string;
    duplicates!: DADeliverableViewModel[];

    constructor(data?: IDADeliverableImportDuplicatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.duplicates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duplicateByKey = _data["duplicateByKey"];
            this.duplicateByPropertyName = _data["duplicateByPropertyName"];
            if (Array.isArray(_data["duplicates"])) {
                this.duplicates = [] as any;
                for (let item of _data["duplicates"])
                    this.duplicates!.push(DADeliverableViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DADeliverableImportDuplicatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DADeliverableImportDuplicatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duplicateByKey"] = this.duplicateByKey;
        data["duplicateByPropertyName"] = this.duplicateByPropertyName;
        if (Array.isArray(this.duplicates)) {
            data["duplicates"] = [];
            for (let item of this.duplicates)
                data["duplicates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDADeliverableImportDuplicatesViewModel {
    duplicateByKey: string;
    duplicateByPropertyName: string;
    duplicates: DADeliverableViewModel[];
}

export class DeliverableManagerOverviewViewModel implements IDeliverableManagerOverviewViewModel {
    id!: string;
    deliverable!: DADeliverableViewModel;
    deliverableId!: string;
    projectDeliverable!: ProjectDeliverableViewModel;
    projectDeliverableId!: string;

    constructor(data?: IDeliverableManagerOverviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.deliverable = new DADeliverableViewModel();
            this.projectDeliverable = new ProjectDeliverableViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deliverable = _data["deliverable"] ? DADeliverableViewModel.fromJS(_data["deliverable"]) : new DADeliverableViewModel();
            this.deliverableId = _data["deliverableId"];
            this.projectDeliverable = _data["projectDeliverable"] ? ProjectDeliverableViewModel.fromJS(_data["projectDeliverable"]) : new ProjectDeliverableViewModel();
            this.projectDeliverableId = _data["projectDeliverableId"];
        }
    }

    static fromJS(data: any): DeliverableManagerOverviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverableManagerOverviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deliverable"] = this.deliverable ? this.deliverable.toJSON() : <any>undefined;
        data["deliverableId"] = this.deliverableId;
        data["projectDeliverable"] = this.projectDeliverable ? this.projectDeliverable.toJSON() : <any>undefined;
        data["projectDeliverableId"] = this.projectDeliverableId;
        return data;
    }
}

export interface IDeliverableManagerOverviewViewModel {
    id: string;
    deliverable: DADeliverableViewModel;
    deliverableId: string;
    projectDeliverable: ProjectDeliverableViewModel;
    projectDeliverableId: string;
}

export class GlobalMetricsObservationReturnsViewModel implements IGlobalMetricsObservationReturnsViewModel {
    id!: string;
    smeName?: string | undefined;
    smeId?: string | undefined;
    projectPhase?: ProjectPhaseWithProjectViewModel | undefined;
    totalObservations!: number;
    returnedObservations!: number;
    returnedObservationsWithPriority!: ObservationToolObservationWithPriorityViewModel[];
    smeDisciplineId?: string | undefined;
    smeDisciplineNameAndCode?: string | undefined;
    returnedObservationsList!: ObservationToolObservationViewModel[];

    constructor(data?: IGlobalMetricsObservationReturnsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.returnedObservationsWithPriority = [];
            this.returnedObservationsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.smeName = _data["smeName"];
            this.smeId = _data["smeId"];
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseWithProjectViewModel.fromJS(_data["projectPhase"]) : <any>undefined;
            this.totalObservations = _data["totalObservations"];
            this.returnedObservations = _data["returnedObservations"];
            if (Array.isArray(_data["returnedObservationsWithPriority"])) {
                this.returnedObservationsWithPriority = [] as any;
                for (let item of _data["returnedObservationsWithPriority"])
                    this.returnedObservationsWithPriority!.push(ObservationToolObservationWithPriorityViewModel.fromJS(item));
            }
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.smeDisciplineNameAndCode = _data["smeDisciplineNameAndCode"];
            if (Array.isArray(_data["returnedObservationsList"])) {
                this.returnedObservationsList = [] as any;
                for (let item of _data["returnedObservationsList"])
                    this.returnedObservationsList!.push(ObservationToolObservationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalMetricsObservationReturnsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalMetricsObservationReturnsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["smeName"] = this.smeName;
        data["smeId"] = this.smeId;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        data["totalObservations"] = this.totalObservations;
        data["returnedObservations"] = this.returnedObservations;
        if (Array.isArray(this.returnedObservationsWithPriority)) {
            data["returnedObservationsWithPriority"] = [];
            for (let item of this.returnedObservationsWithPriority)
                data["returnedObservationsWithPriority"].push(item.toJSON());
        }
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["smeDisciplineNameAndCode"] = this.smeDisciplineNameAndCode;
        if (Array.isArray(this.returnedObservationsList)) {
            data["returnedObservationsList"] = [];
            for (let item of this.returnedObservationsList)
                data["returnedObservationsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGlobalMetricsObservationReturnsViewModel {
    id: string;
    smeName?: string | undefined;
    smeId?: string | undefined;
    projectPhase?: ProjectPhaseWithProjectViewModel | undefined;
    totalObservations: number;
    returnedObservations: number;
    returnedObservationsWithPriority: ObservationToolObservationWithPriorityViewModel[];
    smeDisciplineId?: string | undefined;
    smeDisciplineNameAndCode?: string | undefined;
    returnedObservationsList: ObservationToolObservationViewModel[];
}

export class ObservationToolObservationWithPriorityViewModel implements IObservationToolObservationWithPriorityViewModel {
    observationName!: string;
    priority!: string;

    constructor(data?: IObservationToolObservationWithPriorityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationName = _data["observationName"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): ObservationToolObservationWithPriorityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationWithPriorityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationName"] = this.observationName;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IObservationToolObservationWithPriorityViewModel {
    observationName: string;
    priority: string;
}

export class GlobalMetricsObservationActionsTakenViewModel implements IGlobalMetricsObservationActionsTakenViewModel {
    id!: string;
    smeName?: string | undefined;
    smeId?: string | undefined;
    projectPhase?: ProjectPhaseWithProjectViewModel | undefined;
    totalObservations!: number;
    observationsWithActions!: number;
    observationsWithActionsList!: ObservationToolObservationWithPriorityViewModel[];
    observationsWithActionsTakenList!: ObservationToolObservationViewModel[];

    constructor(data?: IGlobalMetricsObservationActionsTakenViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.observationsWithActionsList = [];
            this.observationsWithActionsTakenList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.smeName = _data["smeName"];
            this.smeId = _data["smeId"];
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseWithProjectViewModel.fromJS(_data["projectPhase"]) : <any>undefined;
            this.totalObservations = _data["totalObservations"];
            this.observationsWithActions = _data["observationsWithActions"];
            if (Array.isArray(_data["observationsWithActionsList"])) {
                this.observationsWithActionsList = [] as any;
                for (let item of _data["observationsWithActionsList"])
                    this.observationsWithActionsList!.push(ObservationToolObservationWithPriorityViewModel.fromJS(item));
            }
            if (Array.isArray(_data["observationsWithActionsTakenList"])) {
                this.observationsWithActionsTakenList = [] as any;
                for (let item of _data["observationsWithActionsTakenList"])
                    this.observationsWithActionsTakenList!.push(ObservationToolObservationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalMetricsObservationActionsTakenViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalMetricsObservationActionsTakenViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["smeName"] = this.smeName;
        data["smeId"] = this.smeId;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        data["totalObservations"] = this.totalObservations;
        data["observationsWithActions"] = this.observationsWithActions;
        if (Array.isArray(this.observationsWithActionsList)) {
            data["observationsWithActionsList"] = [];
            for (let item of this.observationsWithActionsList)
                data["observationsWithActionsList"].push(item.toJSON());
        }
        if (Array.isArray(this.observationsWithActionsTakenList)) {
            data["observationsWithActionsTakenList"] = [];
            for (let item of this.observationsWithActionsTakenList)
                data["observationsWithActionsTakenList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGlobalMetricsObservationActionsTakenViewModel {
    id: string;
    smeName?: string | undefined;
    smeId?: string | undefined;
    projectPhase?: ProjectPhaseWithProjectViewModel | undefined;
    totalObservations: number;
    observationsWithActions: number;
    observationsWithActionsList: ObservationToolObservationWithPriorityViewModel[];
    observationsWithActionsTakenList: ObservationToolObservationViewModel[];
}

export class GlobalMetricsDismissedObservationsViewModel implements IGlobalMetricsDismissedObservationsViewModel {
    smeId!: string;
    projectPhase!: ProjectPhaseWithProjectViewModel;
    totalObservations!: number;
    dismissedObservations!: number;
    dismissedObservationsList!: ObservationToolObservationViewModel[];

    constructor(data?: IGlobalMetricsDismissedObservationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projectPhase = new ProjectPhaseWithProjectViewModel();
            this.dismissedObservationsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smeId = _data["smeId"];
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseWithProjectViewModel.fromJS(_data["projectPhase"]) : new ProjectPhaseWithProjectViewModel();
            this.totalObservations = _data["totalObservations"];
            this.dismissedObservations = _data["dismissedObservations"];
            if (Array.isArray(_data["dismissedObservationsList"])) {
                this.dismissedObservationsList = [] as any;
                for (let item of _data["dismissedObservationsList"])
                    this.dismissedObservationsList!.push(ObservationToolObservationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalMetricsDismissedObservationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalMetricsDismissedObservationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smeId"] = this.smeId;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        data["totalObservations"] = this.totalObservations;
        data["dismissedObservations"] = this.dismissedObservations;
        if (Array.isArray(this.dismissedObservationsList)) {
            data["dismissedObservationsList"] = [];
            for (let item of this.dismissedObservationsList)
                data["dismissedObservationsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGlobalMetricsDismissedObservationsViewModel {
    smeId: string;
    projectPhase: ProjectPhaseWithProjectViewModel;
    totalObservations: number;
    dismissedObservations: number;
    dismissedObservationsList: ObservationToolObservationViewModel[];
}

export class GlobalMetricsOverriddenDeliverablesViewModel implements IGlobalMetricsOverriddenDeliverablesViewModel {
    id!: string;
    smeName?: string | undefined;
    smeId?: string | undefined;
    projectPhase?: ProjectPhaseWithProjectViewModel | undefined;
    totalDeliverables!: number;
    overriddenDeliverables!: number;
    overriddenDeliverablesWithDetails!: GlobalMetricsOverriddenDeliverableDetailsViewModel[];
    overriddenDeliverablesList!: ObservationToolViewModel[];

    constructor(data?: IGlobalMetricsOverriddenDeliverablesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.overriddenDeliverablesWithDetails = [];
            this.overriddenDeliverablesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.smeName = _data["smeName"];
            this.smeId = _data["smeId"];
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseWithProjectViewModel.fromJS(_data["projectPhase"]) : <any>undefined;
            this.totalDeliverables = _data["totalDeliverables"];
            this.overriddenDeliverables = _data["overriddenDeliverables"];
            if (Array.isArray(_data["overriddenDeliverablesWithDetails"])) {
                this.overriddenDeliverablesWithDetails = [] as any;
                for (let item of _data["overriddenDeliverablesWithDetails"])
                    this.overriddenDeliverablesWithDetails!.push(GlobalMetricsOverriddenDeliverableDetailsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["overriddenDeliverablesList"])) {
                this.overriddenDeliverablesList = [] as any;
                for (let item of _data["overriddenDeliverablesList"])
                    this.overriddenDeliverablesList!.push(ObservationToolViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalMetricsOverriddenDeliverablesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalMetricsOverriddenDeliverablesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["smeName"] = this.smeName;
        data["smeId"] = this.smeId;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        data["totalDeliverables"] = this.totalDeliverables;
        data["overriddenDeliverables"] = this.overriddenDeliverables;
        if (Array.isArray(this.overriddenDeliverablesWithDetails)) {
            data["overriddenDeliverablesWithDetails"] = [];
            for (let item of this.overriddenDeliverablesWithDetails)
                data["overriddenDeliverablesWithDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.overriddenDeliverablesList)) {
            data["overriddenDeliverablesList"] = [];
            for (let item of this.overriddenDeliverablesList)
                data["overriddenDeliverablesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGlobalMetricsOverriddenDeliverablesViewModel {
    id: string;
    smeName?: string | undefined;
    smeId?: string | undefined;
    projectPhase?: ProjectPhaseWithProjectViewModel | undefined;
    totalDeliverables: number;
    overriddenDeliverables: number;
    overriddenDeliverablesWithDetails: GlobalMetricsOverriddenDeliverableDetailsViewModel[];
    overriddenDeliverablesList: ObservationToolViewModel[];
}

export class GlobalMetricsOverriddenDeliverableDetailsViewModel implements IGlobalMetricsOverriddenDeliverableDetailsViewModel {
    id!: string;
    name!: string;
    overrideReason!: string;

    constructor(data?: IGlobalMetricsOverriddenDeliverableDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.overrideReason = _data["overrideReason"];
        }
    }

    static fromJS(data: any): GlobalMetricsOverriddenDeliverableDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalMetricsOverriddenDeliverableDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["overrideReason"] = this.overrideReason;
        return data;
    }
}

export interface IGlobalMetricsOverriddenDeliverableDetailsViewModel {
    id: string;
    name: string;
    overrideReason: string;
}

export abstract class ValueRecognitionBaseViewModel implements IValueRecognitionBaseViewModel {
    id!: string;
    phaseNumber!: number;
    lossesLow!: number;
    lossesMed!: number;
    lossesHigh!: number;
    mitigationLow!: number;
    mitigationMed!: number;
    mitigationHigh!: number;
    clarification!: number;
    lowUrgencyLowVulnerability!: number;
    lowUrgencyMedVulnerability!: number;
    lowUrgencyHighVulnerability!: number;
    medUrgencyLowVulnerability!: number;
    medUrgencyMedVulnerability!: number;
    medUrgencyHighVulnerability!: number;
    highUrgencyLowVulnerability!: number;
    highUrgencyMedVulnerability!: number;
    highUrgencyHighVulnerability!: number;

    constructor(data?: IValueRecognitionBaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phaseNumber = _data["phaseNumber"];
            this.lossesLow = _data["lossesLow"];
            this.lossesMed = _data["lossesMed"];
            this.lossesHigh = _data["lossesHigh"];
            this.mitigationLow = _data["mitigationLow"];
            this.mitigationMed = _data["mitigationMed"];
            this.mitigationHigh = _data["mitigationHigh"];
            this.clarification = _data["clarification"];
            this.lowUrgencyLowVulnerability = _data["lowUrgencyLowVulnerability"];
            this.lowUrgencyMedVulnerability = _data["lowUrgencyMedVulnerability"];
            this.lowUrgencyHighVulnerability = _data["lowUrgencyHighVulnerability"];
            this.medUrgencyLowVulnerability = _data["medUrgencyLowVulnerability"];
            this.medUrgencyMedVulnerability = _data["medUrgencyMedVulnerability"];
            this.medUrgencyHighVulnerability = _data["medUrgencyHighVulnerability"];
            this.highUrgencyLowVulnerability = _data["highUrgencyLowVulnerability"];
            this.highUrgencyMedVulnerability = _data["highUrgencyMedVulnerability"];
            this.highUrgencyHighVulnerability = _data["highUrgencyHighVulnerability"];
        }
    }

    static fromJS(data: any): ValueRecognitionBaseViewModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueRecognitionBaseViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phaseNumber"] = this.phaseNumber;
        data["lossesLow"] = this.lossesLow;
        data["lossesMed"] = this.lossesMed;
        data["lossesHigh"] = this.lossesHigh;
        data["mitigationLow"] = this.mitigationLow;
        data["mitigationMed"] = this.mitigationMed;
        data["mitigationHigh"] = this.mitigationHigh;
        data["clarification"] = this.clarification;
        data["lowUrgencyLowVulnerability"] = this.lowUrgencyLowVulnerability;
        data["lowUrgencyMedVulnerability"] = this.lowUrgencyMedVulnerability;
        data["lowUrgencyHighVulnerability"] = this.lowUrgencyHighVulnerability;
        data["medUrgencyLowVulnerability"] = this.medUrgencyLowVulnerability;
        data["medUrgencyMedVulnerability"] = this.medUrgencyMedVulnerability;
        data["medUrgencyHighVulnerability"] = this.medUrgencyHighVulnerability;
        data["highUrgencyLowVulnerability"] = this.highUrgencyLowVulnerability;
        data["highUrgencyMedVulnerability"] = this.highUrgencyMedVulnerability;
        data["highUrgencyHighVulnerability"] = this.highUrgencyHighVulnerability;
        return data;
    }
}

export interface IValueRecognitionBaseViewModel {
    id: string;
    phaseNumber: number;
    lossesLow: number;
    lossesMed: number;
    lossesHigh: number;
    mitigationLow: number;
    mitigationMed: number;
    mitigationHigh: number;
    clarification: number;
    lowUrgencyLowVulnerability: number;
    lowUrgencyMedVulnerability: number;
    lowUrgencyHighVulnerability: number;
    medUrgencyLowVulnerability: number;
    medUrgencyMedVulnerability: number;
    medUrgencyHighVulnerability: number;
    highUrgencyLowVulnerability: number;
    highUrgencyMedVulnerability: number;
    highUrgencyHighVulnerability: number;
}

export class GlobalSettingsValueRecognitionViewModel extends ValueRecognitionBaseViewModel implements IGlobalSettingsValueRecognitionViewModel {

    constructor(data?: IGlobalSettingsValueRecognitionViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GlobalSettingsValueRecognitionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSettingsValueRecognitionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGlobalSettingsValueRecognitionViewModel extends IValueRecognitionBaseViewModel {
}

export class EmailToViewModel implements IEmailToViewModel {
    to!: string[];
    body!: string;
    subject!: string;

    constructor(data?: IEmailToViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.to = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            this.body = _data["body"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): EmailToViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailToViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        data["body"] = this.body;
        data["subject"] = this.subject;
        return data;
    }
}

export interface IEmailToViewModel {
    to: string[];
    body: string;
    subject: string;
}

export class AssignmentViewModel implements IAssignmentViewModel {
    id!: string;
    userId!: string;
    role!: string;
    smeDiscipline?: SMEDisciplineViewModel | undefined;
    project!: ProjectViewModel;
    phase!: ProjectPhaseViewModel;
    userName?: string | undefined;

    constructor(data?: IAssignmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.project = new ProjectViewModel();
            this.phase = new ProjectPhaseViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.role = _data["role"];
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : <any>undefined;
            this.project = _data["project"] ? ProjectViewModel.fromJS(_data["project"]) : new ProjectViewModel();
            this.phase = _data["phase"] ? ProjectPhaseViewModel.fromJS(_data["phase"]) : new ProjectPhaseViewModel();
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AssignmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["role"] = this.role;
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["phase"] = this.phase ? this.phase.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAssignmentViewModel {
    id: string;
    userId: string;
    role: string;
    smeDiscipline?: SMEDisciplineViewModel | undefined;
    project: ProjectViewModel;
    phase: ProjectPhaseViewModel;
    userName?: string | undefined;
}

export class MandatoryCheckImportResultViewModel implements IMandatoryCheckImportResultViewModel {
    entitiesAdded!: MandatoryCheckTemplateViewModel[];
    entitiesUpdated!: MandatoryCheckTemplateViewModel[];
    entitiesRemoved!: MandatoryCheckTemplateViewModel[];

    constructor(data?: IMandatoryCheckImportResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entitiesAdded = [];
            this.entitiesUpdated = [];
            this.entitiesRemoved = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entitiesAdded"])) {
                this.entitiesAdded = [] as any;
                for (let item of _data["entitiesAdded"])
                    this.entitiesAdded!.push(MandatoryCheckTemplateViewModel.fromJS(item));
            }
            if (Array.isArray(_data["entitiesUpdated"])) {
                this.entitiesUpdated = [] as any;
                for (let item of _data["entitiesUpdated"])
                    this.entitiesUpdated!.push(MandatoryCheckTemplateViewModel.fromJS(item));
            }
            if (Array.isArray(_data["entitiesRemoved"])) {
                this.entitiesRemoved = [] as any;
                for (let item of _data["entitiesRemoved"])
                    this.entitiesRemoved!.push(MandatoryCheckTemplateViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MandatoryCheckImportResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MandatoryCheckImportResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entitiesAdded)) {
            data["entitiesAdded"] = [];
            for (let item of this.entitiesAdded)
                data["entitiesAdded"].push(item.toJSON());
        }
        if (Array.isArray(this.entitiesUpdated)) {
            data["entitiesUpdated"] = [];
            for (let item of this.entitiesUpdated)
                data["entitiesUpdated"].push(item.toJSON());
        }
        if (Array.isArray(this.entitiesRemoved)) {
            data["entitiesRemoved"] = [];
            for (let item of this.entitiesRemoved)
                data["entitiesRemoved"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMandatoryCheckImportResultViewModel {
    entitiesAdded: MandatoryCheckTemplateViewModel[];
    entitiesUpdated: MandatoryCheckTemplateViewModel[];
    entitiesRemoved: MandatoryCheckTemplateViewModel[];
}

export class ObservationToolObservationSaveDAEngineerViewModel extends ObservationToolObservationViewModel implements IObservationToolObservationSaveDAEngineerViewModel {
    status!: string;
    standing?: string | undefined;
    finalObservation?: string | undefined;
    finalConcern?: string | undefined;
    finalRecommendation?: string | undefined;
    actionItem?: string | undefined;

    constructor(data?: IObservationToolObservationSaveDAEngineerViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.standing = _data["standing"];
            this.finalObservation = _data["finalObservation"];
            this.finalConcern = _data["finalConcern"];
            this.finalRecommendation = _data["finalRecommendation"];
            this.actionItem = _data["actionItem"];
        }
    }

    static fromJS(data: any): ObservationToolObservationSaveDAEngineerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationSaveDAEngineerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["standing"] = this.standing;
        data["finalObservation"] = this.finalObservation;
        data["finalConcern"] = this.finalConcern;
        data["finalRecommendation"] = this.finalRecommendation;
        data["actionItem"] = this.actionItem;
        super.toJSON(data);
        return data;
    }
}

export interface IObservationToolObservationSaveDAEngineerViewModel extends IObservationToolObservationViewModel {
    status: string;
    standing?: string | undefined;
    finalObservation?: string | undefined;
    finalConcern?: string | undefined;
    finalRecommendation?: string | undefined;
    actionItem?: string | undefined;
}

export class MoveToObservationToolVerificationViewModel implements IMoveToObservationToolVerificationViewModel {
    daDeliverablesThatHaveNoEstimates!: DADeliverableViewModel[];
    daDeliverablesThatHaveNoMappings!: DADeliverableViewModel[];
    disciplinesWithEstimatesButNotApproved!: SMEDisciplineViewModel[];
    workplanHasNoProjectDeliverableWithDiscipline!: boolean;
    checksThatRequiresProjectDeliverablesButHaveNoMappings!: CheckViewModel[];
    checksThatHaveNoEstimates!: CheckViewModel[];
    unmatchedCarryOverProjectDeliverables!: ProjectDeliverableViewModel[];

    constructor(data?: IMoveToObservationToolVerificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.daDeliverablesThatHaveNoEstimates = [];
            this.daDeliverablesThatHaveNoMappings = [];
            this.disciplinesWithEstimatesButNotApproved = [];
            this.checksThatRequiresProjectDeliverablesButHaveNoMappings = [];
            this.checksThatHaveNoEstimates = [];
            this.unmatchedCarryOverProjectDeliverables = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["daDeliverablesThatHaveNoEstimates"])) {
                this.daDeliverablesThatHaveNoEstimates = [] as any;
                for (let item of _data["daDeliverablesThatHaveNoEstimates"])
                    this.daDeliverablesThatHaveNoEstimates!.push(DADeliverableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["daDeliverablesThatHaveNoMappings"])) {
                this.daDeliverablesThatHaveNoMappings = [] as any;
                for (let item of _data["daDeliverablesThatHaveNoMappings"])
                    this.daDeliverablesThatHaveNoMappings!.push(DADeliverableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["disciplinesWithEstimatesButNotApproved"])) {
                this.disciplinesWithEstimatesButNotApproved = [] as any;
                for (let item of _data["disciplinesWithEstimatesButNotApproved"])
                    this.disciplinesWithEstimatesButNotApproved!.push(SMEDisciplineViewModel.fromJS(item));
            }
            this.workplanHasNoProjectDeliverableWithDiscipline = _data["workplanHasNoProjectDeliverableWithDiscipline"];
            if (Array.isArray(_data["checksThatRequiresProjectDeliverablesButHaveNoMappings"])) {
                this.checksThatRequiresProjectDeliverablesButHaveNoMappings = [] as any;
                for (let item of _data["checksThatRequiresProjectDeliverablesButHaveNoMappings"])
                    this.checksThatRequiresProjectDeliverablesButHaveNoMappings!.push(CheckViewModel.fromJS(item));
            }
            if (Array.isArray(_data["checksThatHaveNoEstimates"])) {
                this.checksThatHaveNoEstimates = [] as any;
                for (let item of _data["checksThatHaveNoEstimates"])
                    this.checksThatHaveNoEstimates!.push(CheckViewModel.fromJS(item));
            }
            if (Array.isArray(_data["unmatchedCarryOverProjectDeliverables"])) {
                this.unmatchedCarryOverProjectDeliverables = [] as any;
                for (let item of _data["unmatchedCarryOverProjectDeliverables"])
                    this.unmatchedCarryOverProjectDeliverables!.push(ProjectDeliverableViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveToObservationToolVerificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MoveToObservationToolVerificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.daDeliverablesThatHaveNoEstimates)) {
            data["daDeliverablesThatHaveNoEstimates"] = [];
            for (let item of this.daDeliverablesThatHaveNoEstimates)
                data["daDeliverablesThatHaveNoEstimates"].push(item.toJSON());
        }
        if (Array.isArray(this.daDeliverablesThatHaveNoMappings)) {
            data["daDeliverablesThatHaveNoMappings"] = [];
            for (let item of this.daDeliverablesThatHaveNoMappings)
                data["daDeliverablesThatHaveNoMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.disciplinesWithEstimatesButNotApproved)) {
            data["disciplinesWithEstimatesButNotApproved"] = [];
            for (let item of this.disciplinesWithEstimatesButNotApproved)
                data["disciplinesWithEstimatesButNotApproved"].push(item.toJSON());
        }
        data["workplanHasNoProjectDeliverableWithDiscipline"] = this.workplanHasNoProjectDeliverableWithDiscipline;
        if (Array.isArray(this.checksThatRequiresProjectDeliverablesButHaveNoMappings)) {
            data["checksThatRequiresProjectDeliverablesButHaveNoMappings"] = [];
            for (let item of this.checksThatRequiresProjectDeliverablesButHaveNoMappings)
                data["checksThatRequiresProjectDeliverablesButHaveNoMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.checksThatHaveNoEstimates)) {
            data["checksThatHaveNoEstimates"] = [];
            for (let item of this.checksThatHaveNoEstimates)
                data["checksThatHaveNoEstimates"].push(item.toJSON());
        }
        if (Array.isArray(this.unmatchedCarryOverProjectDeliverables)) {
            data["unmatchedCarryOverProjectDeliverables"] = [];
            for (let item of this.unmatchedCarryOverProjectDeliverables)
                data["unmatchedCarryOverProjectDeliverables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMoveToObservationToolVerificationViewModel {
    daDeliverablesThatHaveNoEstimates: DADeliverableViewModel[];
    daDeliverablesThatHaveNoMappings: DADeliverableViewModel[];
    disciplinesWithEstimatesButNotApproved: SMEDisciplineViewModel[];
    workplanHasNoProjectDeliverableWithDiscipline: boolean;
    checksThatRequiresProjectDeliverablesButHaveNoMappings: CheckViewModel[];
    checksThatHaveNoEstimates: CheckViewModel[];
    unmatchedCarryOverProjectDeliverables: ProjectDeliverableViewModel[];
}

export class SMEAttentionItemReminderEmailToViewModel extends EmailToViewModel implements ISMEAttentionItemReminderEmailToViewModel {

    constructor(data?: ISMEAttentionItemReminderEmailToViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SMEAttentionItemReminderEmailToViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEAttentionItemReminderEmailToViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISMEAttentionItemReminderEmailToViewModel extends IEmailToViewModel {
}

export class ObservationToolAttentionItemReminderRequestViewModel implements IObservationToolAttentionItemReminderRequestViewModel {
    observationToolAttentionItemReminderType!: string;
    selectedDisciplines?: string[] | undefined;
    deliverableId!: string;

    constructor(data?: IObservationToolAttentionItemReminderRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationToolAttentionItemReminderType = _data["observationToolAttentionItemReminderType"];
            if (Array.isArray(_data["selectedDisciplines"])) {
                this.selectedDisciplines = [] as any;
                for (let item of _data["selectedDisciplines"])
                    this.selectedDisciplines!.push(item);
            }
            this.deliverableId = _data["deliverableId"];
        }
    }

    static fromJS(data: any): ObservationToolAttentionItemReminderRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolAttentionItemReminderRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationToolAttentionItemReminderType"] = this.observationToolAttentionItemReminderType;
        if (Array.isArray(this.selectedDisciplines)) {
            data["selectedDisciplines"] = [];
            for (let item of this.selectedDisciplines)
                data["selectedDisciplines"].push(item);
        }
        data["deliverableId"] = this.deliverableId;
        return data;
    }
}

export interface IObservationToolAttentionItemReminderRequestViewModel {
    observationToolAttentionItemReminderType: string;
    selectedDisciplines?: string[] | undefined;
    deliverableId: string;
}

export class ObservationToolObservationRecommendationViewModel implements IObservationToolObservationRecommendationViewModel {
    inherentVulnerability!: string;
    urgency!: string;

    constructor(data?: IObservationToolObservationRecommendationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inherentVulnerability = _data["inherentVulnerability"];
            this.urgency = _data["urgency"];
        }
    }

    static fromJS(data: any): ObservationToolObservationRecommendationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolObservationRecommendationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inherentVulnerability"] = this.inherentVulnerability;
        data["urgency"] = this.urgency;
        return data;
    }
}

export interface IObservationToolObservationRecommendationViewModel {
    inherentVulnerability: string;
    urgency: string;
}

export class ObservationToolGetObservationPriorityRecommendationByAIViewModel implements IObservationToolGetObservationPriorityRecommendationByAIViewModel {
    smeDisciplineName!: string;
    phaseId!: string;
    observation!: string;
    concern!: string;
    recommendation!: string;
    daCategory!: string;
    timeFrameToAddress!: string;

    constructor(data?: IObservationToolGetObservationPriorityRecommendationByAIViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smeDisciplineName = _data["smeDisciplineName"];
            this.phaseId = _data["phaseId"];
            this.observation = _data["observation"];
            this.concern = _data["concern"];
            this.recommendation = _data["recommendation"];
            this.daCategory = _data["daCategory"];
            this.timeFrameToAddress = _data["timeFrameToAddress"];
        }
    }

    static fromJS(data: any): ObservationToolGetObservationPriorityRecommendationByAIViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolGetObservationPriorityRecommendationByAIViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smeDisciplineName"] = this.smeDisciplineName;
        data["phaseId"] = this.phaseId;
        data["observation"] = this.observation;
        data["concern"] = this.concern;
        data["recommendation"] = this.recommendation;
        data["daCategory"] = this.daCategory;
        data["timeFrameToAddress"] = this.timeFrameToAddress;
        return data;
    }
}

export interface IObservationToolGetObservationPriorityRecommendationByAIViewModel {
    smeDisciplineName: string;
    phaseId: string;
    observation: string;
    concern: string;
    recommendation: string;
    daCategory: string;
    timeFrameToAddress: string;
}

export class ObservationToolDisciplineOverrideCompleteViewModel implements IObservationToolDisciplineOverrideCompleteViewModel {
    smeDisciplineId!: string;
    observationToolId!: string;
    disciplineCode?: string | undefined;
    overrideReason?: string | undefined;

    constructor(data?: IObservationToolDisciplineOverrideCompleteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.observationToolId = _data["observationToolId"];
            this.disciplineCode = _data["disciplineCode"];
            this.overrideReason = _data["overrideReason"];
        }
    }

    static fromJS(data: any): ObservationToolDisciplineOverrideCompleteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolDisciplineOverrideCompleteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["observationToolId"] = this.observationToolId;
        data["disciplineCode"] = this.disciplineCode;
        data["overrideReason"] = this.overrideReason;
        return data;
    }
}

export interface IObservationToolDisciplineOverrideCompleteViewModel {
    smeDisciplineId: string;
    observationToolId: string;
    disciplineCode?: string | undefined;
    overrideReason?: string | undefined;
}

export class SMEDocumentsRequiredSelectionViewModel implements ISMEDocumentsRequiredSelectionViewModel {
    disciplines!: string[];
    documents!: string[];

    constructor(data?: ISMEDocumentsRequiredSelectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.disciplines = [];
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["disciplines"])) {
                this.disciplines = [] as any;
                for (let item of _data["disciplines"])
                    this.disciplines!.push(item);
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
        }
    }

    static fromJS(data: any): SMEDocumentsRequiredSelectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDocumentsRequiredSelectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.disciplines)) {
            data["disciplines"] = [];
            for (let item of this.disciplines)
                data["disciplines"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        return data;
    }
}

export interface ISMEDocumentsRequiredSelectionViewModel {
    disciplines: string[];
    documents: string[];
}

export class DisciplineDocumentMappingListViewModel implements IDisciplineDocumentMappingListViewModel {
    disciplineIdList!: string[];
    documentIdList!: string[];

    constructor(data?: IDisciplineDocumentMappingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.disciplineIdList = [];
            this.documentIdList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["disciplineIdList"])) {
                this.disciplineIdList = [] as any;
                for (let item of _data["disciplineIdList"])
                    this.disciplineIdList!.push(item);
            }
            if (Array.isArray(_data["documentIdList"])) {
                this.documentIdList = [] as any;
                for (let item of _data["documentIdList"])
                    this.documentIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DisciplineDocumentMappingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DisciplineDocumentMappingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.disciplineIdList)) {
            data["disciplineIdList"] = [];
            for (let item of this.disciplineIdList)
                data["disciplineIdList"].push(item);
        }
        if (Array.isArray(this.documentIdList)) {
            data["documentIdList"] = [];
            for (let item of this.documentIdList)
                data["documentIdList"].push(item);
        }
        return data;
    }
}

export interface IDisciplineDocumentMappingListViewModel {
    disciplineIdList: string[];
    documentIdList: string[];
}

export class ObservationToolMetricsChecksViewModel implements IObservationToolMetricsChecksViewModel {
    additionalInProgressUnlinked!: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    additionalInProgressLinked!: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    additionalComplete!: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    mandatoryInProgressUnlinked!: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    mandatoryInProgressLinked!: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    mandatoryComplete!: ObservationToolMetricsChecksLinkedDisciplinesViewModel;

    constructor(data?: IObservationToolMetricsChecksViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.additionalInProgressUnlinked = new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.additionalInProgressLinked = new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.additionalComplete = new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.mandatoryInProgressUnlinked = new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.mandatoryInProgressLinked = new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.mandatoryComplete = new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalInProgressUnlinked = _data["additionalInProgressUnlinked"] ? ObservationToolMetricsChecksLinkedDisciplinesViewModel.fromJS(_data["additionalInProgressUnlinked"]) : new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.additionalInProgressLinked = _data["additionalInProgressLinked"] ? ObservationToolMetricsChecksLinkedDisciplinesViewModel.fromJS(_data["additionalInProgressLinked"]) : new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.additionalComplete = _data["additionalComplete"] ? ObservationToolMetricsChecksLinkedDisciplinesViewModel.fromJS(_data["additionalComplete"]) : new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.mandatoryInProgressUnlinked = _data["mandatoryInProgressUnlinked"] ? ObservationToolMetricsChecksLinkedDisciplinesViewModel.fromJS(_data["mandatoryInProgressUnlinked"]) : new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.mandatoryInProgressLinked = _data["mandatoryInProgressLinked"] ? ObservationToolMetricsChecksLinkedDisciplinesViewModel.fromJS(_data["mandatoryInProgressLinked"]) : new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
            this.mandatoryComplete = _data["mandatoryComplete"] ? ObservationToolMetricsChecksLinkedDisciplinesViewModel.fromJS(_data["mandatoryComplete"]) : new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
        }
    }

    static fromJS(data: any): ObservationToolMetricsChecksViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsChecksViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalInProgressUnlinked"] = this.additionalInProgressUnlinked ? this.additionalInProgressUnlinked.toJSON() : <any>undefined;
        data["additionalInProgressLinked"] = this.additionalInProgressLinked ? this.additionalInProgressLinked.toJSON() : <any>undefined;
        data["additionalComplete"] = this.additionalComplete ? this.additionalComplete.toJSON() : <any>undefined;
        data["mandatoryInProgressUnlinked"] = this.mandatoryInProgressUnlinked ? this.mandatoryInProgressUnlinked.toJSON() : <any>undefined;
        data["mandatoryInProgressLinked"] = this.mandatoryInProgressLinked ? this.mandatoryInProgressLinked.toJSON() : <any>undefined;
        data["mandatoryComplete"] = this.mandatoryComplete ? this.mandatoryComplete.toJSON() : <any>undefined;
        return data;
    }
}

export interface IObservationToolMetricsChecksViewModel {
    additionalInProgressUnlinked: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    additionalInProgressLinked: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    additionalComplete: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    mandatoryInProgressUnlinked: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    mandatoryInProgressLinked: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
    mandatoryComplete: ObservationToolMetricsChecksLinkedDisciplinesViewModel;
}

export class ObservationToolMetricsChecksLinkedDisciplinesViewModel implements IObservationToolMetricsChecksLinkedDisciplinesViewModel {
    count!: number;
    smeDisciplineCounts!: SMEDisciplineCountViewModel[];

    constructor(data?: IObservationToolMetricsChecksLinkedDisciplinesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.smeDisciplineCounts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["smeDisciplineCounts"])) {
                this.smeDisciplineCounts = [] as any;
                for (let item of _data["smeDisciplineCounts"])
                    this.smeDisciplineCounts!.push(SMEDisciplineCountViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObservationToolMetricsChecksLinkedDisciplinesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsChecksLinkedDisciplinesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.smeDisciplineCounts)) {
            data["smeDisciplineCounts"] = [];
            for (let item of this.smeDisciplineCounts)
                data["smeDisciplineCounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObservationToolMetricsChecksLinkedDisciplinesViewModel {
    count: number;
    smeDisciplineCounts: SMEDisciplineCountViewModel[];
}

export class SMEDisciplineCountViewModel implements ISMEDisciplineCountViewModel {
    smeDiscipline!: SMEDisciplineViewModel;
    count!: number;

    constructor(data?: ISMEDisciplineCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.smeDiscipline = new SMEDisciplineViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smeDiscipline = _data["smeDiscipline"] ? SMEDisciplineViewModel.fromJS(_data["smeDiscipline"]) : new SMEDisciplineViewModel();
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): SMEDisciplineCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplineCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smeDiscipline"] = this.smeDiscipline ? this.smeDiscipline.toJSON() : <any>undefined;
        data["count"] = this.count;
        return data;
    }
}

export interface ISMEDisciplineCountViewModel {
    smeDiscipline: SMEDisciplineViewModel;
    count: number;
}

export class ObservationToolMetricsObservationInfoViewModel implements IObservationToolMetricsObservationInfoViewModel {
    observationToolId!: string;
    observationNumber?: number | undefined;
    title?: string | undefined;
    status!: string;
    standing!: string;
    nextActionWith?: string | undefined;
    isCarryOverToCurrentPhase!: boolean;
    inherentVulnerability?: string | undefined;
    urgency?: string | undefined;
    openedAt?: string | undefined;
    firstProjectNAWAt?: string | undefined;
    completedAt?: string | undefined;
    attentionItemReminders!: AttentionItemReminderViewModel[];
    daCategory?: string | undefined;

    constructor(data?: IObservationToolMetricsObservationInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attentionItemReminders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationToolId = _data["observationToolId"];
            this.observationNumber = _data["observationNumber"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.standing = _data["standing"];
            this.nextActionWith = _data["nextActionWith"];
            this.isCarryOverToCurrentPhase = _data["isCarryOverToCurrentPhase"];
            this.inherentVulnerability = _data["inherentVulnerability"];
            this.urgency = _data["urgency"];
            this.openedAt = _data["openedAt"];
            this.firstProjectNAWAt = _data["firstProjectNAWAt"];
            this.completedAt = _data["completedAt"];
            if (Array.isArray(_data["attentionItemReminders"])) {
                this.attentionItemReminders = [] as any;
                for (let item of _data["attentionItemReminders"])
                    this.attentionItemReminders!.push(AttentionItemReminderViewModel.fromJS(item));
            }
            this.daCategory = _data["daCategory"];
        }
    }

    static fromJS(data: any): ObservationToolMetricsObservationInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsObservationInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationToolId"] = this.observationToolId;
        data["observationNumber"] = this.observationNumber;
        data["title"] = this.title;
        data["status"] = this.status;
        data["standing"] = this.standing;
        data["nextActionWith"] = this.nextActionWith;
        data["isCarryOverToCurrentPhase"] = this.isCarryOverToCurrentPhase;
        data["inherentVulnerability"] = this.inherentVulnerability;
        data["urgency"] = this.urgency;
        data["openedAt"] = this.openedAt;
        data["firstProjectNAWAt"] = this.firstProjectNAWAt;
        data["completedAt"] = this.completedAt;
        if (Array.isArray(this.attentionItemReminders)) {
            data["attentionItemReminders"] = [];
            for (let item of this.attentionItemReminders)
                data["attentionItemReminders"].push(item.toJSON());
        }
        data["daCategory"] = this.daCategory;
        return data;
    }
}

export interface IObservationToolMetricsObservationInfoViewModel {
    observationToolId: string;
    observationNumber?: number | undefined;
    title?: string | undefined;
    status: string;
    standing: string;
    nextActionWith?: string | undefined;
    isCarryOverToCurrentPhase: boolean;
    inherentVulnerability?: string | undefined;
    urgency?: string | undefined;
    openedAt?: string | undefined;
    firstProjectNAWAt?: string | undefined;
    completedAt?: string | undefined;
    attentionItemReminders: AttentionItemReminderViewModel[];
    daCategory?: string | undefined;
}

export class CheckWithObservationsViewModel implements ICheckWithObservationsViewModel {
    check!: CheckViewModel;
    workloadEstimateAdditionalChecks!: WorkloadEstimateAdditionalCheckViewModel[];

    constructor(data?: ICheckWithObservationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.check = new CheckViewModel();
            this.workloadEstimateAdditionalChecks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.check = _data["check"] ? CheckViewModel.fromJS(_data["check"]) : new CheckViewModel();
            if (Array.isArray(_data["workloadEstimateAdditionalChecks"])) {
                this.workloadEstimateAdditionalChecks = [] as any;
                for (let item of _data["workloadEstimateAdditionalChecks"])
                    this.workloadEstimateAdditionalChecks!.push(WorkloadEstimateAdditionalCheckViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckWithObservationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckWithObservationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["check"] = this.check ? this.check.toJSON() : <any>undefined;
        if (Array.isArray(this.workloadEstimateAdditionalChecks)) {
            data["workloadEstimateAdditionalChecks"] = [];
            for (let item of this.workloadEstimateAdditionalChecks)
                data["workloadEstimateAdditionalChecks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICheckWithObservationsViewModel {
    check: CheckViewModel;
    workloadEstimateAdditionalChecks: WorkloadEstimateAdditionalCheckViewModel[];
}

export class ObservationToolMetricsValueRecognitionViewModel implements IObservationToolMetricsValueRecognitionViewModel {
    valueRecognitionTotal!: number;
    clarificationsActionsItems!: number;
    vulnerabilityUrgencyItems!: ObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel[];

    constructor(data?: IObservationToolMetricsValueRecognitionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vulnerabilityUrgencyItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueRecognitionTotal = _data["valueRecognitionTotal"];
            this.clarificationsActionsItems = _data["clarificationsActionsItems"];
            if (Array.isArray(_data["vulnerabilityUrgencyItems"])) {
                this.vulnerabilityUrgencyItems = [] as any;
                for (let item of _data["vulnerabilityUrgencyItems"])
                    this.vulnerabilityUrgencyItems!.push(ObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObservationToolMetricsValueRecognitionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsValueRecognitionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueRecognitionTotal"] = this.valueRecognitionTotal;
        data["clarificationsActionsItems"] = this.clarificationsActionsItems;
        if (Array.isArray(this.vulnerabilityUrgencyItems)) {
            data["vulnerabilityUrgencyItems"] = [];
            for (let item of this.vulnerabilityUrgencyItems)
                data["vulnerabilityUrgencyItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObservationToolMetricsValueRecognitionViewModel {
    valueRecognitionTotal: number;
    clarificationsActionsItems: number;
    vulnerabilityUrgencyItems: ObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel[];
}

export class ObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel implements IObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel {
    urgency!: string;
    inherentVulnerability!: string;
    actionItems!: number;

    constructor(data?: IObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urgency = _data["urgency"];
            this.inherentVulnerability = _data["inherentVulnerability"];
            this.actionItems = _data["actionItems"];
        }
    }

    static fromJS(data: any): ObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urgency"] = this.urgency;
        data["inherentVulnerability"] = this.inherentVulnerability;
        data["actionItems"] = this.actionItems;
        return data;
    }
}

export interface IObservationToolMetricsValueRecognitionVulnerabilityUrgencyViewModel {
    urgency: string;
    inherentVulnerability: string;
    actionItems: number;
}

export class ProjectValueRecognitionViewModel extends ValueRecognitionBaseViewModel implements IProjectValueRecognitionViewModel {
    projectId!: string;
    updatedAt?: string | undefined;

    constructor(data?: IProjectValueRecognitionViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"];
            this.updatedAt = _data["updatedAt"];
        }
    }

    static fromJS(data: any): ProjectValueRecognitionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectValueRecognitionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["updatedAt"] = this.updatedAt;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectValueRecognitionViewModel extends IValueRecognitionBaseViewModel {
    projectId: string;
    updatedAt?: string | undefined;
}

export class ProjectDADeliverableMappingViewModel implements IProjectDADeliverableMappingViewModel {
    id!: string;
    deliverableId!: string;
    projectDeliverableId!: string;
    createdAt!: string;
    updatedAt!: string;

    constructor(data?: IProjectDADeliverableMappingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deliverableId = _data["deliverableId"];
            this.projectDeliverableId = _data["projectDeliverableId"];
            this.createdAt = _data["createdAt"];
            this.updatedAt = _data["updatedAt"];
        }
    }

    static fromJS(data: any): ProjectDADeliverableMappingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDADeliverableMappingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deliverableId"] = this.deliverableId;
        data["projectDeliverableId"] = this.projectDeliverableId;
        data["createdAt"] = this.createdAt;
        data["updatedAt"] = this.updatedAt;
        return data;
    }
}

export interface IProjectDADeliverableMappingViewModel {
    id: string;
    deliverableId: string;
    projectDeliverableId: string;
    createdAt: string;
    updatedAt: string;
}

export class ProjectDADeliverableMappingListViewModel implements IProjectDADeliverableMappingListViewModel {
    deliverableIdList!: string[];
    projectDeliverableIdList!: string[];

    constructor(data?: IProjectDADeliverableMappingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.deliverableIdList = [];
            this.projectDeliverableIdList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deliverableIdList"])) {
                this.deliverableIdList = [] as any;
                for (let item of _data["deliverableIdList"])
                    this.deliverableIdList!.push(item);
            }
            if (Array.isArray(_data["projectDeliverableIdList"])) {
                this.projectDeliverableIdList = [] as any;
                for (let item of _data["projectDeliverableIdList"])
                    this.projectDeliverableIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectDADeliverableMappingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDADeliverableMappingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deliverableIdList)) {
            data["deliverableIdList"] = [];
            for (let item of this.deliverableIdList)
                data["deliverableIdList"].push(item);
        }
        if (Array.isArray(this.projectDeliverableIdList)) {
            data["projectDeliverableIdList"] = [];
            for (let item of this.projectDeliverableIdList)
                data["projectDeliverableIdList"].push(item);
        }
        return data;
    }
}

export interface IProjectDADeliverableMappingListViewModel {
    deliverableIdList: string[];
    projectDeliverableIdList: string[];
}

export class ProjectDADeliverableOneOnOneMappingViewModel implements IProjectDADeliverableOneOnOneMappingViewModel {
    daDeliverableId!: string;
    projectDeliverableId!: string;

    constructor(data?: IProjectDADeliverableOneOnOneMappingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daDeliverableId = _data["daDeliverableId"];
            this.projectDeliverableId = _data["projectDeliverableId"];
        }
    }

    static fromJS(data: any): ProjectDADeliverableOneOnOneMappingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDADeliverableOneOnOneMappingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daDeliverableId"] = this.daDeliverableId;
        data["projectDeliverableId"] = this.projectDeliverableId;
        return data;
    }
}

export interface IProjectDADeliverableOneOnOneMappingViewModel {
    daDeliverableId: string;
    projectDeliverableId: string;
}

export class ProjectDeliverableCheckMappingViewModel implements IProjectDeliverableCheckMappingViewModel {
    id!: string;
    checkId!: string;
    projectDeliverableId!: string;

    constructor(data?: IProjectDeliverableCheckMappingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.checkId = _data["checkId"];
            this.projectDeliverableId = _data["projectDeliverableId"];
        }
    }

    static fromJS(data: any): ProjectDeliverableCheckMappingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableCheckMappingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checkId"] = this.checkId;
        data["projectDeliverableId"] = this.projectDeliverableId;
        return data;
    }
}

export interface IProjectDeliverableCheckMappingViewModel {
    id: string;
    checkId: string;
    projectDeliverableId: string;
}

export class ProjectDeliverableCheckMappingListViewModel implements IProjectDeliverableCheckMappingListViewModel {
    checkIdList!: string[];
    projectDeliverableIdList!: string[];

    constructor(data?: IProjectDeliverableCheckMappingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checkIdList = [];
            this.projectDeliverableIdList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checkIdList"])) {
                this.checkIdList = [] as any;
                for (let item of _data["checkIdList"])
                    this.checkIdList!.push(item);
            }
            if (Array.isArray(_data["projectDeliverableIdList"])) {
                this.projectDeliverableIdList = [] as any;
                for (let item of _data["projectDeliverableIdList"])
                    this.projectDeliverableIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectDeliverableCheckMappingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableCheckMappingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checkIdList)) {
            data["checkIdList"] = [];
            for (let item of this.checkIdList)
                data["checkIdList"].push(item);
        }
        if (Array.isArray(this.projectDeliverableIdList)) {
            data["projectDeliverableIdList"] = [];
            for (let item of this.projectDeliverableIdList)
                data["projectDeliverableIdList"].push(item);
        }
        return data;
    }
}

export interface IProjectDeliverableCheckMappingListViewModel {
    checkIdList: string[];
    projectDeliverableIdList: string[];
}

export class ProjectDeliverableWithMappingsViewModel extends ProjectDeliverableViewModel implements IProjectDeliverableWithMappingsViewModel {
    daDeliverableIdList!: string[];

    constructor(data?: IProjectDeliverableWithMappingsViewModel) {
        super(data);
        if (!data) {
            this.daDeliverableIdList = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["daDeliverableIdList"])) {
                this.daDeliverableIdList = [] as any;
                for (let item of _data["daDeliverableIdList"])
                    this.daDeliverableIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectDeliverableWithMappingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableWithMappingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.daDeliverableIdList)) {
            data["daDeliverableIdList"] = [];
            for (let item of this.daDeliverableIdList)
                data["daDeliverableIdList"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProjectDeliverableWithMappingsViewModel extends IProjectDeliverableViewModel {
    daDeliverableIdList: string[];
}

export class ProjectDeliverableWithCheckMappingsViewModel extends ProjectDeliverableViewModel implements IProjectDeliverableWithCheckMappingsViewModel {
    checkIdList!: string[];

    constructor(data?: IProjectDeliverableWithCheckMappingsViewModel) {
        super(data);
        if (!data) {
            this.checkIdList = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["checkIdList"])) {
                this.checkIdList = [] as any;
                for (let item of _data["checkIdList"])
                    this.checkIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectDeliverableWithCheckMappingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableWithCheckMappingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checkIdList)) {
            data["checkIdList"] = [];
            for (let item of this.checkIdList)
                data["checkIdList"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProjectDeliverableWithCheckMappingsViewModel extends IProjectDeliverableViewModel {
    checkIdList: string[];
}

export class ProjectDeliverableImportResultViewModel implements IProjectDeliverableImportResultViewModel {
    entitiesAdded!: ProjectDeliverableViewModel[];
    entitiesRemoved!: ProjectDeliverableViewModel[];
    entitiesUpdated!: ProjectDeliverableViewModel[];

    constructor(data?: IProjectDeliverableImportResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entitiesAdded = [];
            this.entitiesRemoved = [];
            this.entitiesUpdated = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entitiesAdded"])) {
                this.entitiesAdded = [] as any;
                for (let item of _data["entitiesAdded"])
                    this.entitiesAdded!.push(ProjectDeliverableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["entitiesRemoved"])) {
                this.entitiesRemoved = [] as any;
                for (let item of _data["entitiesRemoved"])
                    this.entitiesRemoved!.push(ProjectDeliverableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["entitiesUpdated"])) {
                this.entitiesUpdated = [] as any;
                for (let item of _data["entitiesUpdated"])
                    this.entitiesUpdated!.push(ProjectDeliverableViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDeliverableImportResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableImportResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entitiesAdded)) {
            data["entitiesAdded"] = [];
            for (let item of this.entitiesAdded)
                data["entitiesAdded"].push(item.toJSON());
        }
        if (Array.isArray(this.entitiesRemoved)) {
            data["entitiesRemoved"] = [];
            for (let item of this.entitiesRemoved)
                data["entitiesRemoved"].push(item.toJSON());
        }
        if (Array.isArray(this.entitiesUpdated)) {
            data["entitiesUpdated"] = [];
            for (let item of this.entitiesUpdated)
                data["entitiesUpdated"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDeliverableImportResultViewModel {
    entitiesAdded: ProjectDeliverableViewModel[];
    entitiesRemoved: ProjectDeliverableViewModel[];
    entitiesUpdated: ProjectDeliverableViewModel[];
}

export class ProjectDeliverableImportDuplicatesViewModel implements IProjectDeliverableImportDuplicatesViewModel {
    duplicateByKey!: string;
    duplicateByPropertyName!: string;
    duplicates!: ProjectDeliverableViewModel[];

    constructor(data?: IProjectDeliverableImportDuplicatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.duplicates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duplicateByKey = _data["duplicateByKey"];
            this.duplicateByPropertyName = _data["duplicateByPropertyName"];
            if (Array.isArray(_data["duplicates"])) {
                this.duplicates = [] as any;
                for (let item of _data["duplicates"])
                    this.duplicates!.push(ProjectDeliverableViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDeliverableImportDuplicatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableImportDuplicatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duplicateByKey"] = this.duplicateByKey;
        data["duplicateByPropertyName"] = this.duplicateByPropertyName;
        if (Array.isArray(this.duplicates)) {
            data["duplicates"] = [];
            for (let item of this.duplicates)
                data["duplicates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDeliverableImportDuplicatesViewModel {
    duplicateByKey: string;
    duplicateByPropertyName: string;
    duplicates: ProjectDeliverableViewModel[];
}

export class ReadinessCheckSaveViewModel implements IReadinessCheckSaveViewModel {
    summaryAssessment?: string | undefined;
    risksToProceed?: string | undefined;
    reviewResults?: string | undefined;
    completed!: boolean;
    closePhaseAndCarryOver!: boolean;

    constructor(data?: IReadinessCheckSaveViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summaryAssessment = _data["summaryAssessment"];
            this.risksToProceed = _data["risksToProceed"];
            this.reviewResults = _data["reviewResults"];
            this.completed = _data["completed"];
            this.closePhaseAndCarryOver = _data["closePhaseAndCarryOver"];
        }
    }

    static fromJS(data: any): ReadinessCheckSaveViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadinessCheckSaveViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summaryAssessment"] = this.summaryAssessment;
        data["risksToProceed"] = this.risksToProceed;
        data["reviewResults"] = this.reviewResults;
        data["completed"] = this.completed;
        data["closePhaseAndCarryOver"] = this.closePhaseAndCarryOver;
        return data;
    }
}

export interface IReadinessCheckSaveViewModel {
    summaryAssessment?: string | undefined;
    risksToProceed?: string | undefined;
    reviewResults?: string | undefined;
    completed: boolean;
    closePhaseAndCarryOver: boolean;
}

export class FocusAreaConfigViewModel implements IFocusAreaConfigViewModel {
    id!: string;
    title!: string;
    projectId?: string | undefined;
    focusAreaConfigProjectPhaseTemplateDefinitions?: FocusAreaConfigProjectPhaseTemplateDefinitionViewModel[] | undefined;
    hideIfOnShore!: boolean;
    hideIfOffShore!: boolean;
    hideOnPhaseIds?: string[] | undefined;
    phase2BDefinition?: string | undefined;
    phase2CDefinition?: string | undefined;
    phase3Definition?: string | undefined;
    phase4Definition?: string | undefined;

    constructor(data?: IFocusAreaConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["focusAreaConfigProjectPhaseTemplateDefinitions"])) {
                this.focusAreaConfigProjectPhaseTemplateDefinitions = [] as any;
                for (let item of _data["focusAreaConfigProjectPhaseTemplateDefinitions"])
                    this.focusAreaConfigProjectPhaseTemplateDefinitions!.push(FocusAreaConfigProjectPhaseTemplateDefinitionViewModel.fromJS(item));
            }
            this.hideIfOnShore = _data["hideIfOnShore"];
            this.hideIfOffShore = _data["hideIfOffShore"];
            if (Array.isArray(_data["hideOnPhaseIds"])) {
                this.hideOnPhaseIds = [] as any;
                for (let item of _data["hideOnPhaseIds"])
                    this.hideOnPhaseIds!.push(item);
            }
            this.phase2BDefinition = _data["phase2BDefinition"];
            this.phase2CDefinition = _data["phase2CDefinition"];
            this.phase3Definition = _data["phase3Definition"];
            this.phase4Definition = _data["phase4Definition"];
        }
    }

    static fromJS(data: any): FocusAreaConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FocusAreaConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.focusAreaConfigProjectPhaseTemplateDefinitions)) {
            data["focusAreaConfigProjectPhaseTemplateDefinitions"] = [];
            for (let item of this.focusAreaConfigProjectPhaseTemplateDefinitions)
                data["focusAreaConfigProjectPhaseTemplateDefinitions"].push(item.toJSON());
        }
        data["hideIfOnShore"] = this.hideIfOnShore;
        data["hideIfOffShore"] = this.hideIfOffShore;
        if (Array.isArray(this.hideOnPhaseIds)) {
            data["hideOnPhaseIds"] = [];
            for (let item of this.hideOnPhaseIds)
                data["hideOnPhaseIds"].push(item);
        }
        data["phase2BDefinition"] = this.phase2BDefinition;
        data["phase2CDefinition"] = this.phase2CDefinition;
        data["phase3Definition"] = this.phase3Definition;
        data["phase4Definition"] = this.phase4Definition;
        return data;
    }
}

export interface IFocusAreaConfigViewModel {
    id: string;
    title: string;
    projectId?: string | undefined;
    focusAreaConfigProjectPhaseTemplateDefinitions?: FocusAreaConfigProjectPhaseTemplateDefinitionViewModel[] | undefined;
    hideIfOnShore: boolean;
    hideIfOffShore: boolean;
    hideOnPhaseIds?: string[] | undefined;
    phase2BDefinition?: string | undefined;
    phase2CDefinition?: string | undefined;
    phase3Definition?: string | undefined;
    phase4Definition?: string | undefined;
}

export class FocusAreaConfigProjectPhaseTemplateDefinitionViewModel implements IFocusAreaConfigProjectPhaseTemplateDefinitionViewModel {
    focusAreaConfigId!: string;
    phaseId?: string | undefined;
    definition!: string;

    constructor(data?: IFocusAreaConfigProjectPhaseTemplateDefinitionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.focusAreaConfigId = _data["focusAreaConfigId"];
            this.phaseId = _data["phaseId"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): FocusAreaConfigProjectPhaseTemplateDefinitionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FocusAreaConfigProjectPhaseTemplateDefinitionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["focusAreaConfigId"] = this.focusAreaConfigId;
        data["phaseId"] = this.phaseId;
        data["definition"] = this.definition;
        return data;
    }
}

export interface IFocusAreaConfigProjectPhaseTemplateDefinitionViewModel {
    focusAreaConfigId: string;
    phaseId?: string | undefined;
    definition: string;
}

export class DeliverablesRecommendationForFocusAreaViewModel implements IDeliverablesRecommendationForFocusAreaViewModel {
    daDeliverableTemplatesIds?: string[] | undefined;
    daDeliverableIds?: string[] | undefined;
    focusAreaId!: string;

    constructor(data?: IDeliverablesRecommendationForFocusAreaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["daDeliverableTemplatesIds"])) {
                this.daDeliverableTemplatesIds = [] as any;
                for (let item of _data["daDeliverableTemplatesIds"])
                    this.daDeliverableTemplatesIds!.push(item);
            }
            if (Array.isArray(_data["daDeliverableIds"])) {
                this.daDeliverableIds = [] as any;
                for (let item of _data["daDeliverableIds"])
                    this.daDeliverableIds!.push(item);
            }
            this.focusAreaId = _data["focusAreaId"];
        }
    }

    static fromJS(data: any): DeliverablesRecommendationForFocusAreaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverablesRecommendationForFocusAreaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.daDeliverableTemplatesIds)) {
            data["daDeliverableTemplatesIds"] = [];
            for (let item of this.daDeliverableTemplatesIds)
                data["daDeliverableTemplatesIds"].push(item);
        }
        if (Array.isArray(this.daDeliverableIds)) {
            data["daDeliverableIds"] = [];
            for (let item of this.daDeliverableIds)
                data["daDeliverableIds"].push(item);
        }
        data["focusAreaId"] = this.focusAreaId;
        return data;
    }
}

export interface IDeliverablesRecommendationForFocusAreaViewModel {
    daDeliverableTemplatesIds?: string[] | undefined;
    daDeliverableIds?: string[] | undefined;
    focusAreaId: string;
}

export class FocusAreaUpdateStatementViewModel implements IFocusAreaUpdateStatementViewModel {
    id!: string;
    statement?: string | undefined;

    constructor(data?: IFocusAreaUpdateStatementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statement = _data["statement"];
        }
    }

    static fromJS(data: any): FocusAreaUpdateStatementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FocusAreaUpdateStatementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statement"] = this.statement;
        return data;
    }
}

export interface IFocusAreaUpdateStatementViewModel {
    id: string;
    statement?: string | undefined;
}

export class SMEDisciplineCreateOrUpdateViewModel implements ISMEDisciplineCreateOrUpdateViewModel {
    smeDisciplineConfigId!: string;
    name!: string;
    description?: string | undefined;
    code?: string | undefined;
    projectId?: string | undefined;
    smeDisciplineId!: string;
    disciplineCode!: string;
    projectPhaseId!: string;
    status!: string;
    isRiskBasedAssessment!: boolean;
    alwaysIncludeInPeerPool!: boolean;
    assignments!: SMEDisciplineAssignmentPeerPoolViewModel[];

    constructor(data?: ISMEDisciplineCreateOrUpdateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smeDisciplineConfigId = _data["smeDisciplineConfigId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.projectId = _data["projectId"];
            this.smeDisciplineId = _data["smeDisciplineId"];
            this.disciplineCode = _data["disciplineCode"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.status = _data["status"];
            this.isRiskBasedAssessment = _data["isRiskBasedAssessment"];
            this.alwaysIncludeInPeerPool = _data["alwaysIncludeInPeerPool"];
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(SMEDisciplineAssignmentPeerPoolViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SMEDisciplineCreateOrUpdateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SMEDisciplineCreateOrUpdateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smeDisciplineConfigId"] = this.smeDisciplineConfigId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["code"] = this.code;
        data["projectId"] = this.projectId;
        data["smeDisciplineId"] = this.smeDisciplineId;
        data["disciplineCode"] = this.disciplineCode;
        data["projectPhaseId"] = this.projectPhaseId;
        data["status"] = this.status;
        data["isRiskBasedAssessment"] = this.isRiskBasedAssessment;
        data["alwaysIncludeInPeerPool"] = this.alwaysIncludeInPeerPool;
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISMEDisciplineCreateOrUpdateViewModel {
    smeDisciplineConfigId: string;
    name: string;
    description?: string | undefined;
    code?: string | undefined;
    projectId?: string | undefined;
    smeDisciplineId: string;
    disciplineCode: string;
    projectPhaseId: string;
    status: string;
    isRiskBasedAssessment: boolean;
    alwaysIncludeInPeerPool: boolean;
    assignments: SMEDisciplineAssignmentPeerPoolViewModel[];
}

export class StaffViewModel implements IStaffViewModel {
    id!: string;
    staffConfigId?: string | undefined;
    title!: string;
    projectId?: string | undefined;
    projectPhaseId!: string;
    order?: number | undefined;
    value?: string | undefined;
    done!: boolean;
    isAdHoc!: boolean;
    createdBy!: string;
    createdAt!: string;
    updatedBy!: string;
    updatedAt!: string;

    constructor(data?: IStaffViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.staffConfigId = _data["staffConfigId"];
            this.title = _data["title"];
            this.projectId = _data["projectId"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.order = _data["order"];
            this.value = _data["value"];
            this.done = _data["done"];
            this.isAdHoc = _data["isAdHoc"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"];
        }
    }

    static fromJS(data: any): StaffViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StaffViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffConfigId"] = this.staffConfigId;
        data["title"] = this.title;
        data["projectId"] = this.projectId;
        data["projectPhaseId"] = this.projectPhaseId;
        data["order"] = this.order;
        data["value"] = this.value;
        data["done"] = this.done;
        data["isAdHoc"] = this.isAdHoc;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt;
        return data;
    }
}

export interface IStaffViewModel {
    id: string;
    staffConfigId?: string | undefined;
    title: string;
    projectId?: string | undefined;
    projectPhaseId: string;
    order?: number | undefined;
    value?: string | undefined;
    done: boolean;
    isAdHoc: boolean;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
}

export class CheckWithWorkloadEstimatesViewModel extends CheckViewModel implements ICheckWithWorkloadEstimatesViewModel {
    workloadEstimateAdditionalChecks!: WorkloadEstimateWithStatisticsAdditionalCheckViewModel[];
    totalHours!: number;

    constructor(data?: ICheckWithWorkloadEstimatesViewModel) {
        super(data);
        if (!data) {
            this.workloadEstimateAdditionalChecks = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["workloadEstimateAdditionalChecks"])) {
                this.workloadEstimateAdditionalChecks = [] as any;
                for (let item of _data["workloadEstimateAdditionalChecks"])
                    this.workloadEstimateAdditionalChecks!.push(WorkloadEstimateWithStatisticsAdditionalCheckViewModel.fromJS(item));
            }
            this.totalHours = _data["totalHours"];
        }
    }

    static fromJS(data: any): CheckWithWorkloadEstimatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckWithWorkloadEstimatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workloadEstimateAdditionalChecks)) {
            data["workloadEstimateAdditionalChecks"] = [];
            for (let item of this.workloadEstimateAdditionalChecks)
                data["workloadEstimateAdditionalChecks"].push(item.toJSON());
        }
        data["totalHours"] = this.totalHours;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckWithWorkloadEstimatesViewModel extends ICheckViewModel {
    workloadEstimateAdditionalChecks: WorkloadEstimateWithStatisticsAdditionalCheckViewModel[];
    totalHours: number;
}

export class WorkloadEstimateWithStatisticsAdditionalCheckViewModel extends WorkloadEstimateAdditionalCheckViewModel implements IWorkloadEstimateWithStatisticsAdditionalCheckViewModel {
    numberOfChecks!: number;
    averageNumberOfHours!: number;

    constructor(data?: IWorkloadEstimateWithStatisticsAdditionalCheckViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.numberOfChecks = _data["numberOfChecks"];
            this.averageNumberOfHours = _data["averageNumberOfHours"];
        }
    }

    static fromJS(data: any): WorkloadEstimateWithStatisticsAdditionalCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkloadEstimateWithStatisticsAdditionalCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfChecks"] = this.numberOfChecks;
        data["averageNumberOfHours"] = this.averageNumberOfHours;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkloadEstimateWithStatisticsAdditionalCheckViewModel extends IWorkloadEstimateAdditionalCheckViewModel {
    numberOfChecks: number;
    averageNumberOfHours: number;
}

export class WorkloadEstimateChangeAdditionalCheckViewModel implements IWorkloadEstimateChangeAdditionalCheckViewModel {
    hours?: number | undefined;
    checkId!: string;
    smeDisciplineId!: string;

    constructor(data?: IWorkloadEstimateChangeAdditionalCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.checkId = _data["checkId"];
            this.smeDisciplineId = _data["smeDisciplineId"];
        }
    }

    static fromJS(data: any): WorkloadEstimateChangeAdditionalCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkloadEstimateChangeAdditionalCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["checkId"] = this.checkId;
        data["smeDisciplineId"] = this.smeDisciplineId;
        return data;
    }
}

export interface IWorkloadEstimateChangeAdditionalCheckViewModel {
    hours?: number | undefined;
    checkId: string;
    smeDisciplineId: string;
}

export class CarryOverObservationWithEstimateViewModel implements ICarryOverObservationWithEstimateViewModel {
    observationToolObservationId!: string;
    observationToolObservation!: ObservationToolObservationViewModel;
    carryOverFromProjectPhaseId!: string;
    hours!: number;

    constructor(data?: ICarryOverObservationWithEstimateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.observationToolObservation = new ObservationToolObservationViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.observationToolObservation = _data["observationToolObservation"] ? ObservationToolObservationViewModel.fromJS(_data["observationToolObservation"]) : new ObservationToolObservationViewModel();
            this.carryOverFromProjectPhaseId = _data["carryOverFromProjectPhaseId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): CarryOverObservationWithEstimateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarryOverObservationWithEstimateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["observationToolObservation"] = this.observationToolObservation ? this.observationToolObservation.toJSON() : <any>undefined;
        data["carryOverFromProjectPhaseId"] = this.carryOverFromProjectPhaseId;
        data["hours"] = this.hours;
        return data;
    }
}

export interface ICarryOverObservationWithEstimateViewModel {
    observationToolObservationId: string;
    observationToolObservation: ObservationToolObservationViewModel;
    carryOverFromProjectPhaseId: string;
    hours: number;
}

export class WorkloadEstimateCarryOverObservationViewModel implements IWorkloadEstimateCarryOverObservationViewModel {
    id!: string;
    observationToolObservationId!: string;
    observationToolObservation!: ObservationToolObservationViewModel;
    projectPhaseId!: string;
    hours!: number;

    constructor(data?: IWorkloadEstimateCarryOverObservationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.observationToolObservation = new ObservationToolObservationViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.observationToolObservation = _data["observationToolObservation"] ? ObservationToolObservationViewModel.fromJS(_data["observationToolObservation"]) : new ObservationToolObservationViewModel();
            this.projectPhaseId = _data["projectPhaseId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): WorkloadEstimateCarryOverObservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkloadEstimateCarryOverObservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["observationToolObservation"] = this.observationToolObservation ? this.observationToolObservation.toJSON() : <any>undefined;
        data["projectPhaseId"] = this.projectPhaseId;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IWorkloadEstimateCarryOverObservationViewModel {
    id: string;
    observationToolObservationId: string;
    observationToolObservation: ObservationToolObservationViewModel;
    projectPhaseId: string;
    hours: number;
}

export class WorkloadEstimateChangeCarryOverObservationViewModel implements IWorkloadEstimateChangeCarryOverObservationViewModel {
    observationToolObservationId!: string;
    projectPhaseId!: string;
    hours!: number;

    constructor(data?: IWorkloadEstimateChangeCarryOverObservationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationToolObservationId = _data["observationToolObservationId"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): WorkloadEstimateChangeCarryOverObservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkloadEstimateChangeCarryOverObservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationToolObservationId"] = this.observationToolObservationId;
        data["projectPhaseId"] = this.projectPhaseId;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IWorkloadEstimateChangeCarryOverObservationViewModel {
    observationToolObservationId: string;
    projectPhaseId: string;
    hours: number;
}

export class WorkloadEstimateChangeViewModel implements IWorkloadEstimateChangeViewModel {
    hours?: number | undefined;
    daDeliverableId!: string;
    smeDisciplineId!: string;

    constructor(data?: IWorkloadEstimateChangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.daDeliverableId = _data["daDeliverableId"];
            this.smeDisciplineId = _data["smeDisciplineId"];
        }
    }

    static fromJS(data: any): WorkloadEstimateChangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkloadEstimateChangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["daDeliverableId"] = this.daDeliverableId;
        data["smeDisciplineId"] = this.smeDisciplineId;
        return data;
    }
}

export interface IWorkloadEstimateChangeViewModel {
    hours?: number | undefined;
    daDeliverableId: string;
    smeDisciplineId: string;
}

export class WorkplanEstimatesPlanViewModel implements IWorkplanEstimatesPlanViewModel {
    subTotalCost!: number;
    totalCost!: number;
    totalHours!: number;

    constructor(data?: IWorkplanEstimatesPlanViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subTotalCost = _data["subTotalCost"];
            this.totalCost = _data["totalCost"];
            this.totalHours = _data["totalHours"];
        }
    }

    static fromJS(data: any): WorkplanEstimatesPlanViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkplanEstimatesPlanViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subTotalCost"] = this.subTotalCost;
        data["totalCost"] = this.totalCost;
        data["totalHours"] = this.totalHours;
        return data;
    }
}

export interface IWorkplanEstimatesPlanViewModel {
    subTotalCost: number;
    totalCost: number;
    totalHours: number;
}

export class NewWorkplanViewModel implements INewWorkplanViewModel {
    projectId?: string | undefined;
    name!: string;
    description!: string;
    themes?: string[] | undefined;
    phaseId!: string;
    plannedStartDate?: string | undefined;
    plannedCompletionDate?: string | undefined;
    onShore!: boolean;
    offShore!: boolean;
    nojv!: boolean;
    daLead?: string | undefined;
    daSupports?: string[] | undefined;
    daManager?: string | undefined;
    projectContacts?: string[] | undefined;
    businessUnitId?: string | undefined;
    leadBy!: string;
    billingRateUSD!: number;
    daTime!: number;
    smeMargin?: number | undefined;
    ipimsDomain?: string | undefined;
    copyFromPhase?: string | undefined;
    copyDADeliverables!: boolean;
    copyProjectDeliverables!: boolean;
    copyDeliverableMappings!: boolean;
    copyPeerPool!: boolean;
    copyRiskAssessment!: boolean;
    userAnonymity!: boolean;
    engagementDate?: string | undefined;
    engagementType?: string | undefined;
    assetClassId?: string | undefined;
    chargeCode?: string | undefined;
    audit!: boolean;

    constructor(data?: INewWorkplanViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(item);
            }
            this.phaseId = _data["phaseId"];
            this.plannedStartDate = _data["plannedStartDate"];
            this.plannedCompletionDate = _data["plannedCompletionDate"];
            this.onShore = _data["onShore"];
            this.offShore = _data["offShore"];
            this.nojv = _data["nojv"];
            this.daLead = _data["daLead"];
            if (Array.isArray(_data["daSupports"])) {
                this.daSupports = [] as any;
                for (let item of _data["daSupports"])
                    this.daSupports!.push(item);
            }
            this.daManager = _data["daManager"];
            if (Array.isArray(_data["projectContacts"])) {
                this.projectContacts = [] as any;
                for (let item of _data["projectContacts"])
                    this.projectContacts!.push(item);
            }
            this.businessUnitId = _data["businessUnitId"];
            this.leadBy = _data["leadBy"];
            this.billingRateUSD = _data["billingRateUSD"];
            this.daTime = _data["daTime"];
            this.smeMargin = _data["smeMargin"];
            this.ipimsDomain = _data["ipimsDomain"];
            this.copyFromPhase = _data["copyFromPhase"];
            this.copyDADeliverables = _data["copyDADeliverables"];
            this.copyProjectDeliverables = _data["copyProjectDeliverables"];
            this.copyDeliverableMappings = _data["copyDeliverableMappings"];
            this.copyPeerPool = _data["copyPeerPool"];
            this.copyRiskAssessment = _data["copyRiskAssessment"];
            this.userAnonymity = _data["userAnonymity"];
            this.engagementDate = _data["engagementDate"];
            this.engagementType = _data["engagementType"];
            this.assetClassId = _data["assetClassId"];
            this.chargeCode = _data["chargeCode"];
            this.audit = _data["audit"];
        }
    }

    static fromJS(data: any): NewWorkplanViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewWorkplanViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item);
        }
        data["phaseId"] = this.phaseId;
        data["plannedStartDate"] = this.plannedStartDate;
        data["plannedCompletionDate"] = this.plannedCompletionDate;
        data["onShore"] = this.onShore;
        data["offShore"] = this.offShore;
        data["nojv"] = this.nojv;
        data["daLead"] = this.daLead;
        if (Array.isArray(this.daSupports)) {
            data["daSupports"] = [];
            for (let item of this.daSupports)
                data["daSupports"].push(item);
        }
        data["daManager"] = this.daManager;
        if (Array.isArray(this.projectContacts)) {
            data["projectContacts"] = [];
            for (let item of this.projectContacts)
                data["projectContacts"].push(item);
        }
        data["businessUnitId"] = this.businessUnitId;
        data["leadBy"] = this.leadBy;
        data["billingRateUSD"] = this.billingRateUSD;
        data["daTime"] = this.daTime;
        data["smeMargin"] = this.smeMargin;
        data["ipimsDomain"] = this.ipimsDomain;
        data["copyFromPhase"] = this.copyFromPhase;
        data["copyDADeliverables"] = this.copyDADeliverables;
        data["copyProjectDeliverables"] = this.copyProjectDeliverables;
        data["copyDeliverableMappings"] = this.copyDeliverableMappings;
        data["copyPeerPool"] = this.copyPeerPool;
        data["copyRiskAssessment"] = this.copyRiskAssessment;
        data["userAnonymity"] = this.userAnonymity;
        data["engagementDate"] = this.engagementDate;
        data["engagementType"] = this.engagementType;
        data["assetClassId"] = this.assetClassId;
        data["chargeCode"] = this.chargeCode;
        data["audit"] = this.audit;
        return data;
    }
}

export interface INewWorkplanViewModel {
    projectId?: string | undefined;
    name: string;
    description: string;
    themes?: string[] | undefined;
    phaseId: string;
    plannedStartDate?: string | undefined;
    plannedCompletionDate?: string | undefined;
    onShore: boolean;
    offShore: boolean;
    nojv: boolean;
    daLead?: string | undefined;
    daSupports?: string[] | undefined;
    daManager?: string | undefined;
    projectContacts?: string[] | undefined;
    businessUnitId?: string | undefined;
    leadBy: string;
    billingRateUSD: number;
    daTime: number;
    smeMargin?: number | undefined;
    ipimsDomain?: string | undefined;
    copyFromPhase?: string | undefined;
    copyDADeliverables: boolean;
    copyProjectDeliverables: boolean;
    copyDeliverableMappings: boolean;
    copyPeerPool: boolean;
    copyRiskAssessment: boolean;
    userAnonymity: boolean;
    engagementDate?: string | undefined;
    engagementType?: string | undefined;
    assetClassId?: string | undefined;
    chargeCode?: string | undefined;
    audit: boolean;
}

/** Keys: [ Low, Medium, High ] */
export enum InherentVulnerability {
    Low = "low",
    Medium = "medium",
    High = "high",
}

/** Keys: [ Low, Medium, High ] */
export enum Urgency {
    Low = "low",
    Medium = "medium",
    High = "high",
}

/** Keys: [ ByName, ByDocumentNumber ] */
export enum ProjectDeliverableImportDuplicateType {
    ByName = "byName",
    ByDocumentNumber = "byDocumentNumber",
}

/** Keys: [ ByName, ByDRSCode ] */
export enum DADeliverableImportDuplicateType {
    ByName = "byName",
    ByDRSCode = "byDRSCode",
}

/** Keys: [ Chevron ] */
export enum SharePointUrls {
    Chevron = "https://chevron.sharepoint.com/",
}

/** Keys: [ Url ] */
export enum ServiceNowForm {
    Url = "https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981",
}

/** Keys: [ DefaultEstimateHours ] */
export enum WorkloadEstimatesCarryOverObservation {
    DefaultEstimateHours = "6",
}

/** Keys: [ DAEngineers, ChapterManagers, SMEs, ProjectContacts, AllUsers ] */
export enum SendReleaseEmailRoles {
    DAEngineers = "da-engineers",
    ChapterManagers = "chapter-managers",
    SMEs = "sme",
    ProjectContacts = "project-contacts",
    AllUsers = "all-users",
}

/** Keys: [ DAEngineers, ChapterManagers, SMEs, RiskAssessmentSMEs, ProjectContacts, AllUsers ] */
export enum EmailMyTeamOptions {
    DAEngineers = "da-engineers",
    ChapterManagers = "chapter-managers",
    SMEs = "smes",
    RiskAssessmentSMEs = "risk-assessment-smes",
    ProjectContacts = "project-contacts",
    AllUsers = "all-users",
}

/** Keys: [ Queued, Pending, Approved ] */
export enum SMEDisciplinePeerPoolStatus {
    Queued = "queued",
    Pending = "pending",
    Approved = "approved",
}

/** Keys: [ RequestedSME, PrimarySME, SecondarySME, ChapterManager ] */
export enum SMEDisciplineAssignments {
    RequestedSME = "requested SME",
    PrimarySME = "primary SME",
    SecondarySME = "secondary SME",
    ChapterManager = "chapter manager",
}

/** Keys: [ Initiation, Observations, Closed ] */
export enum WorkplanStatus {
    Initiation = "initiation",
    Observations = "observations",
    Closed = "closed",
}

/** Keys: [ LoadedDocument, AssignedDocument, DeletedDocument, CreatedObservation, SavedDraftObservation, OpenedObservation, ClosedObservation, DisciplineReviewed, AddedDocumentNickname, ChangedDocumentNickname, AddedDocumentRevision, InReviewDeliverable ] */
export enum ObservationToolActivityTypes {
    LoadedDocument = "loaded document",
    AssignedDocument = "assigned document",
    DeletedDocument = "deleted document",
    CreatedObservation = "created observation",
    SavedDraftObservation = "saved draft observation",
    OpenedObservation = "opened observation",
    ClosedObservation = "closed observation",
    DisciplineReviewed = "discipline reviewed",
    AddedDocumentNickname = "added document nickname",
    ChangedDocumentNickname = "changed document nickname",
    AddedDocumentRevision = "added document revision",
    InReviewDeliverable = "deliverable moved to 'in review'",
}

/** Keys: [ PIDReview, SID, RAM, BOD, EnergyOptimization, ConstructibilityReview, PFDReview, InterfaceWithORRLead, InterfaceWithICSALead, TechScreening ] */
export enum CheckType {
    PIDReview = "P&ID review",
    SID = "SID",
    RAM = "RAM",
    BOD = "BOD",
    EnergyOptimization = "energy optimization",
    ConstructibilityReview = "constructibility review",
    PFDReview = "PFD review",
    InterfaceWithORRLead = "interface with ORR lead",
    InterfaceWithICSALead = "interface with ICSA lead",
    TechScreening = "tech screening",
}

/** Keys: [ DesignAssurance, SME ] */
export enum CheckOwner {
    DesignAssurance = "design assurance",
    SME = "SME",
}

/** Keys: [ Draft, Working, Open, Complete, Informational ] */
export enum ObservationToolObservationStatus {
    Draft = "draft",
    Working = "working",
    Open = "open",
    Complete = "complete",
    Informational = "informational",
}

/** Keys: [ InProgress, Complete ] */
export enum ObservationToolCheckStatus {
    InProgress = "in progress",
    Complete = "complete",
}

/** Keys: [ None ] */
export enum ObservationToolObservationStandingDisabled {
    None = "none",
}

/** Keys: [ InDiscussion, PendingMitigationPlan, MitigationPlanAgreedPendingDocuments, NoMitigationPlanAgreedEngageTechnicalAuthority, NoMitigationPlanAgreedUnresolved, RequestForClarification ] */
export enum ObservationToolObservationOpenStatusStandings {
    InDiscussion = "in discussion",
    PendingMitigationPlan = "pending mitigation plan",
    MitigationPlanAgreedPendingDocuments = "mitigation plan agreed, pending documents",
    NoMitigationPlanAgreedEngageTechnicalAuthority = "no mitigation plan agreed, engage technical authority",
    NoMitigationPlanAgreedUnresolved = "no mitigation plan agreed, unresolved",
    RequestForClarification = "request for clarification",
}

/** Keys: [ WithAction, WithoutAction ] */
export enum ObservationToolObservationCompleteStatusStandings {
    WithAction = "with action",
    WithoutAction = "without action",
}

/** Keys: [ IPIMS, SharePoint, SharePointFolder, SharePointFileFromFolder, SharePointNote, IPIMSNote ] */
export enum ObservationToolDocumentControlSystemTypes {
    IPIMS = "iPIMS",
    SharePoint = "SharePoint",
    SharePointFolder = "SharePointFolder",
    SharePointFileFromFolder = "SharePointFileFromFolder",
    SharePointNote = "SharePointNote",
    IPIMSNote = "iPIMSNote",
}

/** Keys: [ Strength, Safety, NotOperable, AssetIntegrity, RampUp, Maintenance, Reliability, Operability, IncompleteDesign, Optimization, InsufficientDocumentation, RequestForClarification ] */
export enum ObservationToolObservationDACategories {
    Strength = "strength",
    Safety = "safety",
    NotOperable = "not operable",
    AssetIntegrity = "asset integrity",
    RampUp = "ramp-up",
    Maintenance = "maintenance",
    Reliability = "reliability",
    Operability = "operability",
    IncompleteDesign = "incomplete design",
    Optimization = "optimization",
    InsufficientDocumentation = "insufficient documentation",
    RequestForClarification = "request for clarification",
}

/** Keys: [ MitigationPlanNotRequired ] */
export enum ObservationToolObservationInformationalStatusStandings {
    MitigationPlanNotRequired = "no mitigation plan required",
}

/** Keys: [ Shared, ProjectContact, DAEngineer, SME ] */
export enum ObservationToolObservationChannel {
    Shared = "Shared",
    ProjectContact = "ProjectContact",
    DAEngineer = "DAEngineer",
    SME = "SME",
}

/** Keys: [ P1, P2, P3, NA ] */
export enum ObservationToolPriority {
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    NA = "n/a",
}

/** Keys: [ StopWork, Phase2, Phase3, BeforeFID, Phase4, BeforeStartUp, Phase5 ] */
export enum ObservationToolTimeFrameToAddress {
    StopWork = "now, stop work until fully addressed",
    Phase2 = "phase 2",
    Phase3 = "phase 3",
    BeforeFID = "before FID",
    Phase4 = "phase 4",
    BeforeStartUp = "before start-up",
    Phase5 = "phase 5",
}

/** Keys: [ AdHoc, RiskAssessment, ManuallyAdded ] */
export enum DADeliverableOrigin {
    AdHoc = "AH",
    RiskAssessment = "RA",
    ManuallyAdded = "M",
}

/** Keys: [ NA, Low, Medium, High ] */
export enum FocusAreaValues {
    NA = "n/a",
    Low = "low",
    Medium = "medium",
    High = "high",
}

/** Keys: [ AllDisciplines, SelectedDisciplines, IncompleteReview ] */
export enum ObservationToolAttentionItemReminderType {
    AllDisciplines = "AllDisciplines",
    SelectedDisciplines = "SelectedDisciplines",
    IncompleteReview = "IncompleteReview",
}

export class FeatureToggleEntryViewModel implements IFeatureToggleEntryViewModel {
    uiFeatureName!: string;
    enabled!: boolean;

    constructor(data?: IFeatureToggleEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uiFeatureName = _data["uiFeatureName"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): FeatureToggleEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureToggleEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uiFeatureName"] = this.uiFeatureName;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IFeatureToggleEntryViewModel {
    uiFeatureName: string;
    enabled: boolean;
}

export class UserConfigViewModel implements IUserConfigViewModel {
    isEmailDisabled!: boolean;

    constructor(data?: IUserConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailDisabled = _data["isEmailDisabled"];
        }
    }

    static fromJS(data: any): UserConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailDisabled"] = this.isEmailDisabled;
        return data;
    }
}

export interface IUserConfigViewModel {
    isEmailDisabled: boolean;
}

export class UserDataViewModel implements IUserDataViewModel {
    oid!: string;
    displayName!: string;
    jobTitle!: string;

    constructor(data?: IUserDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oid = _data["oid"];
            this.displayName = _data["displayName"];
            this.jobTitle = _data["jobTitle"];
        }
    }

    static fromJS(data: any): UserDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oid"] = this.oid;
        data["displayName"] = this.displayName;
        data["jobTitle"] = this.jobTitle;
        return data;
    }
}

export interface IUserDataViewModel {
    oid: string;
    displayName: string;
    jobTitle: string;
}

export class PeerPoolExceptionViewModel implements IPeerPoolExceptionViewModel {
    oid!: string;

    constructor(data?: IPeerPoolExceptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oid = _data["oid"];
        }
    }

    static fromJS(data: any): PeerPoolExceptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PeerPoolExceptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oid"] = this.oid;
        return data;
    }
}

export interface IPeerPoolExceptionViewModel {
    oid: string;
}

export class GlobalAdminViewModel implements IGlobalAdminViewModel {
    oid!: string;

    constructor(data?: IGlobalAdminViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oid = _data["oid"];
        }
    }

    static fromJS(data: any): GlobalAdminViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalAdminViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oid"] = this.oid;
        return data;
    }
}

export interface IGlobalAdminViewModel {
    oid: string;
}

export class ApplicationVersionViewModel implements IApplicationVersionViewModel {
    currentVersion!: string;

    constructor(data?: IApplicationVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentVersion = _data["currentVersion"];
        }
    }

    static fromJS(data: any): ApplicationVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentVersion"] = this.currentVersion;
        return data;
    }
}

export interface IApplicationVersionViewModel {
    currentVersion: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}